const cardArr = {
  '110100': '北京市市辖区',
  '110101': '北京市东城区',
  '110102': '北京市西城区',
  '110103': '北京市崇文区',
  '110104': '北京市宣武区',
  '110105': '北京市朝阳区',
  '110106': '北京市丰台区',
  '110107': '北京市石景山区',
  '110108': '北京市海淀区',
  '110109': '北京市门头沟区',
  '110110': '北京市燕山区',
  '110111': '北京市房山区',
  '110112': '北京市通州区',
  '110113': '北京市顺义区',
  '110114': '北京市昌平区',
  '110115': '北京市大兴区',
  '110116': '北京市怀柔区',
  '110117': '北京市平谷区',
  '110221': '北京市昌平县',
  '110222': '北京市顺义县',
  '110223': '北京市通县',
  '110224': '北京市大兴县',
  '110225': '北京市房山县',
  '110226': '北京市平谷县',
  '110227': '北京市怀柔县',
  '110228': '北京市密云县',
  '110229': '北京市延庆县',
  '120000': '天津市',
  '120100': '天津市市辖区',
  '120101': '天津市和平区',
  '120102': '天津市河东区',
  '120103': '天津市河西区',
  '120104': '天津市南开区',
  '120105': '天津市河北区',
  '120106': '天津市红桥区',
  '120107': '天津市塘沽区',
  '120108': '天津市汉沽区',
  '120109': '天津市大港区',
  '120110': '天津市东丽区',
  '120111': '天津市西青区',
  '120112': '天津市津南区',
  '120113': '天津市北辰区',
  '120114': '天津市武清区',
  '120115': '天津市宝坻区',
  '120221': '天津市宁河县',
  '120222': '天津市武清县',
  '120223': '天津市静海县',
  '120224': '天津市宝坻县',
  '120225': '天津市蓟县',
  '130000': '河北省',
  '130100': '河北省石家庄市',
  '130101': '河北省石家庄市市辖区',
  '130102': '河北省石家庄市长安区',
  '130103': '河北省石家庄市桥东区',
  '130104': '河北省石家庄市桥西区',
  '130105': '河北省石家庄市新华区',
  '130106': '河北省石家庄市郊区',
  '130107': '河北省石家庄市井陉矿区',
  '130108': '河北省石家庄市裕华区',
  '130121': '河北省井陉县',
  '130122': '河北省获鹿县',
  '130123': '河北省正定县',
  '130124': '河北省栾城县',
  '130125': '河北省行唐县',
  '130126': '河北省灵寿县',
  '130127': '河北省高邑县',
  '130128': '河北省深泽县',
  '130129': '河北省赞皇县',
  '130130': '河北省无极县',
  '130131': '河北省平山县',
  '130132': '河北省元氏县',
  '130133': '河北省赵县',
  '130181': '河北省辛集市',
  '130182': '河北省藁城市',
  '130183': '河北省晋州市',
  '130184': '河北省新乐市',
  '130185': '河北省鹿泉市',
  '130200': '河北省唐山市',
  '130201': '河北省唐山市市辖区',
  '130202': '河北省唐山市路南区',
  '130203': '河北省唐山市路北区',
  '130204': '河北省唐山市古冶区',
  '130205': '河北省唐山市开平区',
  '130206': '河北省唐山市新区',
  '130207': '河北省唐山市丰南区',
  '130208': '河北省唐山市丰润区',
  '130221': '河北省丰润县',
  '130222': '河北省丰南县',
  '130223': '河北省滦县',
  '130224': '河北省滦南县',
  '130225': '河北省乐亭县',
  '130226': '河北省迁安县',
  '130227': '河北省迁西县',
  '130228': '河北省遵化县',
  '130229': '河北省玉田县',
  '130230': '河北省唐海县',
  '130281': '河北省遵化市',
  '130282': '河北省丰南市',
  '130283': '河北省迁安市',
  '130300': '河北省秦皇岛市',
  '130301': '河北省秦皇岛市市辖区',
  '130302': '河北省秦皇岛市海港区',
  '130303': '河北省秦皇岛市山海关区',
  '130304': '河北省秦皇岛市北戴河区',
  '130321': '河北省青龙满族自治县',
  '130322': '河北省昌黎县',
  '130323': '河北省抚宁县',
  '130324': '河北省卢龙县',
  '130400': '河北省邯郸市',
  '130401': '河北省邯郸市市辖区',
  '130402': '河北省邯郸市邯山区',
  '130403': '河北省邯郸市丛台区',
  '130404': '河北省邯郸市复兴区',
  '130406': '河北省邯郸市峰峰矿区',
  '130421': '河北省邯郸县',
  '130422': '河北省武安县',
  '130423': '河北省临漳县',
  '130424': '河北省成安县',
  '130425': '河北省大名县',
  '130426': '河北省涉县',
  '130427': '河北省磁县',
  '130428': '河北省肥乡县',
  '130429': '河北省永年县',
  '130430': '河北省邱县',
  '130431': '河北省鸡泽县',
  '130432': '河北省广平县',
  '130433': '河北省馆陶县',
  '130434': '河北省魏县',
  '130435': '河北省曲周县',
  '130481': '河北省武安市',
  '130500': '河北省邢台市',
  '130501': '河北省邢台市市辖区',
  '130502': '河北省邢台市桥东区',
  '130503': '河北省邢台市桥西区',
  '130504': '河北省邢台市郊区',
  '130521': '河北省邢台县',
  '130522': '河北省临城县',
  '130523': '河北省内丘县',
  '130524': '河北省柏乡县',
  '130525': '河北省隆尧县',
  '130526': '河北省任县',
  '130527': '河北省南和县',
  '130528': '河北省宁晋县',
  '130529': '河北省巨鹿县',
  '130530': '河北省新河县',
  '130531': '河北省广宗县',
  '130532': '河北省平乡县',
  '130533': '河北省威县',
  '130534': '河北省清河县',
  '130535': '河北省临西县',
  '130581': '河北省南宫市',
  '130582': '河北省沙河市',
  '130600': '河北省保定市',
  '130601': '河北省保定市市辖区',
  '130602': '河北省保定市新市区',
  '130603': '河北省保定市北市区',
  '130604': '河北省保定市南市区',
  '130605': '河北省保定市郊区',
  '130621': '河北省满城县',
  '130622': '河北省清苑县',
  '130623': '河北省涞水县',
  '130624': '河北省阜平县',
  '130625': '河北省徐水县',
  '130626': '河北省定兴县',
  '130627': '河北省唐县',
  '130628': '河北省高阳县',
  '130629': '河北省容城县',
  '130630': '河北省涞源县',
  '130631': '河北省望都县',
  '130632': '河北省安新县',
  '130633': '河北省易县',
  '130634': '河北省曲阳县',
  '130635': '河北省蠡县',
  '130636': '河北省顺平县',
  '130637': '河北省博野县',
  '130638': '河北省雄县',
  '130681': '河北省涿州市',
  '130682': '河北省定州市',
  '130683': '河北省安国市',
  '130684': '河北省高碑店市',
  '130700': '河北省张家口市',
  '130701': '河北省张家口市市辖区',
  '130702': '河北省张家口市桥东区',
  '130703': '河北省张家口市桥西区',
  '130704': '河北省张家口市茶坊区',
  '130705': '河北省张家口市宣化区',
  '130706': '河北省张家口市下花园区',
  '130707': '河北省张家口市庞家堡区',
  '130721': '河北省宣化县',
  '130722': '河北省张北县',
  '130723': '河北省康保县',
  '130724': '河北省沽源县',
  '130725': '河北省尚义县',
  '130726': '河北省蔚县',
  '130727': '河北省阳原县',
  '130728': '河北省怀安县',
  '130729': '河北省万全县',
  '130730': '河北省怀来县',
  '130731': '河北省涿鹿县',
  '130732': '河北省赤城县',
  '130733': '河北省崇礼县',
  '130800': '河北省承德市',
  '130801': '河北省承德市市辖区',
  '130802': '河北省承德市双桥区',
  '130803': '河北省承德市双滦区',
  '130804': '河北省承德市鹰手营子矿区',
  '130821': '河北省承德县',
  '130822': '河北省兴隆县',
  '130823': '河北省平泉县',
  '130824': '河北省滦平县',
  '130825': '河北省隆化县',
  '130826': '河北省丰宁满族自治县',
  '130827': '河北省宽城满族自治县',
  '130828': '河北省围场满族蒙古族自治县',
  '130900': '河北省沧州市',
  '130901': '河北省沧州市市辖区',
  '130902': '河北省沧州市新华区',
  '130903': '河北省沧州市运河区',
  '130904': '河北省沧州市郊区',
  '130921': '河北省沧县',
  '130922': '河北省青县',
  '130923': '河北省东光县',
  '130924': '河北省海兴县',
  '130925': '河北省盐山县',
  '130926': '河北省肃宁县',
  '130927': '河北省南皮县',
  '130928': '河北省吴桥县',
  '130929': '河北省献县',
  '130930': '河北省孟村回族自治县',
  '130981': '河北省泊头市',
  '130982': '河北省任丘市',
  '130983': '河北省黄骅市',
  '130984': '河北省河间市',
  '131000': '河北省廊坊市',
  '131001': '河北省廊坊市市辖区',
  '131002': '河北省廊坊市安次区',
  '131003': '河北省廊坊市广阳区',
  '131021': '河北省三河县',
  '131022': '河北省固安县',
  '131023': '河北省永清县',
  '131024': '河北省香河县',
  '131025': '河北省大城县',
  '131026': '河北省文安县',
  '131027': '河北省霸县',
  '131028': '河北省大厂回族自治县',
  '131081': '河北省霸州市',
  '131082': '河北省三河市',
  '131100': '河北省衡水市',
  '131101': '河北省衡水市市辖区',
  '131102': '河北省衡水市桃城区',
  '131121': '河北省枣强县',
  '131122': '河北省武邑县',
  '131123': '河北省武强县',
  '131124': '河北省饶阳县',
  '131125': '河北省安平县',
  '131126': '河北省故城县',
  '131127': '河北省景县',
  '131128': '河北省阜城县',
  '131181': '河北省冀州市',
  '131182': '河北省深州市',
  '132100': '河北省邯郸地区',
  '132101': '河北省邯郸市',
  '132121': '河北省大名县',
  '132122': '河北省魏县',
  '132123': '河北省曲周县',
  '132124': '河北省丘县',
  '132125': '河北省鸡泽县',
  '132126': '河北省肥乡县',
  '132127': '河北省广平县',
  '132128': '河北省成安县',
  '132129': '河北省临漳县',
  '132130': '河北省磁县',
  '132131': '河北省武安县',
  '132132': '河北省涉县',
  '132133': '河北省永年县',
  '132134': '河北省邯郸县',
  '132135': '河北省馆陶县',
  '132200': '河北省邢台地区',
  '132201': '河北省南宫市',
  '132202': '河北省沙河市',
  '132221': '河北省邢台县',
  '132222': '河北省沙河县',
  '132223': '河北省临城县',
  '132224': '河北省内丘县',
  '132225': '河北省柏乡县',
  '132226': '河北省隆尧县',
  '132227': '河北省任县',
  '132228': '河北省南和县',
  '132229': '河北省宁晋县',
  '132230': '河北省南宫县',
  '132231': '河北省巨鹿县',
  '132232': '河北省新河县',
  '132233': '河北省广宗县',
  '132234': '河北省平乡县',
  '132235': '河北省威县',
  '132236': '河北省清河县',
  '132237': '河北省临西县',
  '132300': '河北省石家庄地区',
  '132301': '河北省辛集市',
  '132302': '河北省藁城市',
  '132321': '河北省束鹿县',
  '132322': '河北省晋县',
  '132323': '河北省深泽县',
  '132324': '河北省无极县',
  '132325': '河北省藁城县',
  '132326': '河北省赵县',
  '132327': '河北省栾城县',
  '132328': '河北省正定县',
  '132329': '河北省新乐县',
  '132330': '河北省高邑县',
  '132331': '河北省元氏县',
  '132332': '河北省赞皇县',
  '132333': '河北省井陉县',
  '132334': '河北省获鹿县',
  '132335': '河北省平山县',
  '132336': '河北省灵寿县',
  '132337': '河北省行唐县',
  '132400': '河北省保定地区',
  '132401': '河北省定州市',
  '132402': '河北省涿州市',
  '132403': '河北省安国市',
  '132404': '河北省高碑店市',
  '132421': '河北省易县',
  '132422': '河北省满城县',
  '132423': '河北省徐水县',
  '132424': '河北省涞源县',
  '132425': '河北省定兴县',
  '132426': '河北省顺平县',
  '132427': '河北省唐县',
  '132428': '河北省望都县',
  '132429': '河北省涞水县',
  '132430': '河北省涿县',
  '132431': '河北省清苑县',
  '132432': '河北省高阳县',
  '132433': '河北省安新县',
  '132434': '河北省雄县',
  '132435': '河北省容城县',
  '132436': '河北省新城县',
  '132437': '河北省曲阳县',
  '132438': '河北省阜平县',
  '132439': '河北省定县',
  '132440': '河北省安国县',
  '132441': '河北省博野县',
  '132442': '河北省蠡县',
  '132500': '河北省张家口地区',
  '132501': '河北省张家口市',
  '132521': '河北省张北县',
  '132522': '河北省康保县',
  '132523': '河北省沽源县',
  '132524': '河北省尚义县',
  '132525': '河北省蔚县',
  '132526': '河北省阳原县',
  '132527': '河北省怀安县',
  '132528': '河北省万全县',
  '132529': '河北省怀来县',
  '132530': '河北省涿鹿县',
  '132531': '河北省宣化县',
  '132532': '河北省赤城县',
  '132533': '河北省崇礼县',
  '132600': '河北省承德地区',
  '132601': '河北省承德市',
  '132621': '河北省青龙县',
  '132622': '河北省宽城县',
  '132623': '河北省兴隆县',
  '132624': '河北省平泉县',
  '132625': '河北省承德县',
  '132626': '河北省滦平县',
  '132627': '河北省丰宁县',
  '132628': '河北省隆化县',
  '132629': '河北省围场县',
  '132701': '河北省秦皇岛市',
  '132721': '河北省丰润县',
  '132722': '河北省丰南县',
  '132723': '河北省滦县',
  '132724': '河北省滦南县',
  '132725': '河北省乐亭县',
  '132726': '河北省昌黎县',
  '132727': '河北省抚宁县',
  '132728': '河北省卢龙县',
  '132729': '河北省迁安县',
  '132730': '河北省迁西县',
  '132731': '河北省遵化县',
  '132732': '河北省玉田县',
  '132800': '河北省廊坊地区',
  '132801': '河北省廊坊市',
  '132821': '河北省三河县',
  '132822': '河北省大厂回族自治县',
  '132823': '河北省香河县',
  '132824': '河北省安次县',
  '132825': '河北省永清县',
  '132826': '河北省固安县',
  '132827': '河北省霸县',
  '132828': '河北省文安县',
  '132829': '河北省大城县',
  '132900': '河北省沧州地区',
  '132901': '河北省沧州市',
  '132902': '河北省泊头市',
  '132903': '河北省任丘市',
  '132904': '河北省黄骅市',
  '132905': '河北省河间市',
  '132921': '河北省沧县',
  '132922': '河北省河间县',
  '132923': '河北省肃宁县',
  '132924': '河北省献县',
  '132925': '河北省交河县',
  '132926': '河北省吴桥县',
  '132927': '河北省东光县',
  '132928': '河北省南皮县',
  '132929': '河北省盐山县',
  '132930': '河北省黄骅县',
  '132931': '河北省孟村回族自治县',
  '132932': '河北省青县',
  '132933': '河北省任丘县',
  '132934': '河北省海兴县',
  '133000': '河北省衡水地区',
  '133001': '河北省衡水市',
  '133002': '河北省冀州市',
  '133021': '河北省衡水县',
  '133022': '河北省冀县',
  '133023': '河北省枣强县',
  '133024': '河北省武邑县',
  '133025': '河北省深县',
  '133026': '河北省武强县',
  '133027': '河北省饶阳县',
  '133028': '河北省安平县',
  '133029': '河北省故城县',
  '133030': '河北省景县',
  '133031': '河北省阜城县',
  '139000': '河北省省直辖单位',
  '139001': '河北省武安市',
  '140000': '山西省',
  '140100': '山西省太原市',
  '140101': '山西省太原市市辖区',
  '140102': '山西省太原市南城区',
  '140103': '山西省太原市北城区',
  '140104': '山西省太原市河西区',
  '140105': '山西省太原市小店区',
  '140106': '山西省太原市迎泽区',
  '140107': '山西省太原市杏花岭区',
  '140108': '山西省太原市尖草坪区',
  '140109': '山西省太原市万柏林区',
  '140110': '山西省太原市晋源区',
  '140111': '山西省太原市古交工矿区',
  '140112': '山西省太原市南郊区',
  '140113': '山西省太原市北郊区',
  '140120': '山西省太原市区',
  '140121': '山西省清徐县',
  '140122': '山西省阳曲县',
  '140123': '山西省娄烦县',
  '140181': '山西省古交市',
  '140200': '山西省大同市',
  '140201': '山西省大同市市辖区',
  '140202': '山西省大同市城区',
  '140203': '山西省大同市矿区',
  '140211': '山西省大同市南郊区',
  '140212': '山西省大同市新荣区',
  '140221': '山西省阳高县',
  '140222': '山西省天镇县',
  '140223': '山西省广灵县',
  '140224': '山西省灵丘县',
  '140225': '山西省浑源县',
  '140226': '山西省左云县',
  '140227': '山西省大同县',
  '140300': '山西省阳泉市',
  '140301': '山西省阳泉市市辖区',
  '140302': '山西省阳泉市城区',
  '140303': '山西省阳泉市矿区',
  '140311': '山西省阳泉市郊区',
  '140321': '山西省平定县',
  '140322': '山西省盂县',
  '140400': '山西省长治市',
  '140401': '山西省长治市市辖区',
  '140402': '山西省长治市城区',
  '140411': '山西省长治市郊区',
  '140421': '山西省长治县',
  '140422': '山西省潞城县',
  '140423': '山西省襄垣县',
  '140424': '山西省屯留县',
  '140425': '山西省平顺县',
  '140426': '山西省黎城县',
  '140427': '山西省壶关县',
  '140428': '山西省长子县',
  '140429': '山西省武乡县',
  '140430': '山西省沁县',
  '140431': '山西省沁源县',
  '140481': '山西省潞城市',
  '140500': '山西省晋城市',
  '140501': '山西省晋城市市辖区',
  '140502': '山西省晋城市城区',
  '140511': '山西省晋城市郊区',
  '140521': '山西省沁水县',
  '140522': '山西省阳城县',
  '140523': '山西省高平县',
  '140524': '山西省陵川县',
  '140525': '山西省泽州县',
  '140581': '山西省高平市',
  '140600': '山西省朔州市',
  '140601': '山西省朔州市市辖区',
  '140602': '山西省朔州市朔城区',
  '140603': '山西省朔州市平鲁区',
  '140621': '山西省山阴县',
  '140622': '山西省应县',
  '140623': '山西省右玉县',
  '140624': '山西省怀仁县',
  '140700': '山西省晋中市',
  '140701': '山西省晋中市市辖区',
  '140702': '山西省晋中市榆次区',
  '140721': '山西省榆社县',
  '140722': '山西省左权县',
  '140723': '山西省和顺县',
  '140724': '山西省昔阳县',
  '140725': '山西省寿阳县',
  '140726': '山西省太谷县',
  '140727': '山西省祁县',
  '140728': '山西省平遥县',
  '140729': '山西省灵石县',
  '140781': '山西省介休市',
  '140800': '山西省运城市',
  '140801': '山西省运城市市辖区',
  '140802': '山西省运城市盐湖区',
  '140821': '山西省临猗县',
  '140822': '山西省万荣县',
  '140823': '山西省闻喜县',
  '140824': '山西省稷山县',
  '140825': '山西省新绛县',
  '140826': '山西省绛县',
  '140827': '山西省垣曲县',
  '140828': '山西省夏县',
  '140829': '山西省平陆县',
  '140830': '山西省芮城县',
  '140881': '山西省永济市',
  '140882': '山西省河津市',
  '140900': '山西省忻州市',
  '140901': '山西省忻州市市辖区',
  '140902': '山西省忻州市忻府区',
  '140921': '山西省定襄县',
  '140922': '山西省五台县',
  '140923': '山西省代县',
  '140924': '山西省繁峙县',
  '140925': '山西省宁武县',
  '140926': '山西省静乐县',
  '140927': '山西省神池县',
  '140928': '山西省五寨县',
  '140929': '山西省岢岚县',
  '140930': '山西省河曲县',
  '140931': '山西省保德县',
  '140932': '山西省偏关县',
  '140981': '山西省原平市',
  '141000': '山西省临汾市',
  '141001': '山西省临汾市市辖区',
  '141002': '山西省临汾市尧都区',
  '141021': '山西省曲沃县',
  '141022': '山西省翼城县',
  '141023': '山西省襄汾县',
  '141024': '山西省洪洞县',
  '141025': '山西省古县',
  '141026': '山西省安泽县',
  '141027': '山西省浮山县',
  '141028': '山西省吉县',
  '141029': '山西省乡宁县',
  '141030': '山西省大宁县',
  '141031': '山西省隰县',
  '141032': '山西省永和县',
  '141033': '山西省蒲县',
  '141034': '山西省汾西县',
  '141081': '山西省侯马市',
  '141082': '山西省霍州市',
  '141100': '山西省吕梁市',
  '141101': '山西省吕梁市市辖区',
  '141102': '山西省吕梁市离石区',
  '141121': '山西省文水县',
  '141122': '山西省交城县',
  '141123': '山西省兴县',
  '141124': '山西省临县',
  '141125': '山西省柳林县',
  '141126': '山西省石楼县',
  '141127': '山西省岚县',
  '141128': '山西省方山县',
  '141129': '山西省中阳县',
  '141130': '山西省交口县',
  '141181': '山西省孝义市',
  '141182': '山西省汾阳市',
  '142100': '山西省雁北地区',
  '142121': '山西省阳高县',
  '142122': '山西省天镇县',
  '142123': '山西省广灵县',
  '142124': '山西省灵丘县',
  '142125': '山西省浑源县',
  '142126': '山西省应县',
  '142127': '山西省山阴县',
  '142128': '山西省朔县',
  '142129': '山西省平鲁县',
  '142130': '山西省左云县',
  '142131': '山西省右玉县',
  '142132': '山西省大同县',
  '142133': '山西省怀仁县',
  '142200': '山西省忻州地区',
  '142201': '山西省忻州市',
  '142202': '山西省原平市',
  '142221': '山西省忻县',
  '142222': '山西省定襄县',
  '142223': '山西省五台县',
  '142224': '山西省原平县',
  '142225': '山西省代县',
  '142226': '山西省繁峙县',
  '142227': '山西省宁武县',
  '142228': '山西省静乐县',
  '142229': '山西省神池县',
  '142230': '山西省五寨县',
  '142231': '山西省岢岚县',
  '142232': '山西省河曲县',
  '142233': '山西省保德县',
  '142234': '山西省偏关县',
  '142300': '山西省吕梁地区',
  '142301': '山西省孝义市',
  '142302': '山西省离石市',
  '142303': '山西省汾阳市',
  '142321': '山西省汾阳县',
  '142322': '山西省文水县',
  '142323': '山西省交城县',
  '142324': '山西省孝义县',
  '142325': '山西省兴县',
  '142326': '山西省临县',
  '142327': '山西省柳林县',
  '142328': '山西省石楼县',
  '142329': '山西省岚县',
  '142330': '山西省方山县',
  '142331': '山西省离石县',
  '142332': '山西省中阳县',
  '142333': '山西省交口县',
  '142400': '山西省晋中地区',
  '142401': '山西省榆次市',
  '142402': '山西省介休市',
  '142421': '山西省榆社县',
  '142422': '山西省左权县',
  '142423': '山西省和顺县',
  '142424': '山西省昔阳县',
  '142425': '山西省平定县',
  '142426': '山西省盂县',
  '142427': '山西省寿阳县',
  '142428': '山西省榆次县',
  '142429': '山西省太谷县',
  '142430': '山西省祁县',
  '142431': '山西省平遥县',
  '142432': '山西省介休县',
  '142433': '山西省灵石县',
  '142500': '山西省晋东南地区',
  '142501': '山西省晋城市',
  '142521': '山西省长治县',
  '142522': '山西省潞城县',
  '142523': '山西省屯留县',
  '142524': '山西省长子县',
  '142525': '山西省沁水县',
  '142526': '山西省阳城县',
  '142527': '山西省晋城县',
  '142528': '山西省高平县',
  '142529': '山西省陵川县',
  '142530': '山西省壶关县',
  '142531': '山西省平顺县',
  '142532': '山西省黎城县',
  '142533': '山西省武乡县',
  '142534': '山西省襄垣县',
  '142535': '山西省沁县',
  '142536': '山西省沁源县',
  '142600': '山西省临汾地区',
  '142601': '山西省临汾市',
  '142602': '山西省侯马市',
  '142603': '山西省霍州市',
  '142621': '山西省曲沃县',
  '142622': '山西省翼城县',
  '142623': '山西省襄汾县',
  '142624': '山西省临汾县',
  '142625': '山西省洪洞县',
  '142626': '山西省霍县',
  '142627': '山西省古县',
  '142628': '山西省安泽县',
  '142629': '山西省浮山县',
  '142630': '山西省吉县',
  '142631': '山西省乡宁县',
  '142632': '山西省蒲县',
  '142633': '山西省大宁县',
  '142634': '山西省永和县',
  '142635': '山西省隰县',
  '142636': '山西省汾西县',
  '142700': '山西省运城地区',
  '142701': '山西省运城市',
  '142702': '山西省永济市',
  '142703': '山西省河津市',
  '142721': '山西省运城县',
  '142722': '山西省永济县',
  '142723': '山西省芮城县',
  '142724': '山西省临猗县',
  '142725': '山西省万荣县',
  '142726': '山西省新绛县',
  '142727': '山西省稷山县',
  '142728': '山西省河津县',
  '142729': '山西省闻喜县',
  '142730': '山西省夏县',
  '142731': '山西省绛县',
  '142732': '山西省平陆县',
  '142733': '山西省垣曲县',
  '149000': '山西省省直辖单位',
  '149001': '山西省古交市',
  '150000': '内蒙古自治区',
  '150100': '内蒙古自治区呼和浩特市',
  '150101': '内蒙古自治区呼和浩特市市辖区',
  '150102': '内蒙古自治区呼和浩特市新城区',
  '150103': '内蒙古自治区呼和浩特市回民区',
  '150104': '内蒙古自治区呼和浩特市玉泉区',
  '150105': '内蒙古自治区呼和浩特市赛罕区',
  '150120': '内蒙古自治区呼和浩特市区',
  '150121': '内蒙古自治区土默特左旗',
  '150122': '内蒙古自治区托克托县',
  '150123': '内蒙古自治区和林格尔县',
  '150124': '内蒙古自治区清水河县',
  '150125': '内蒙古自治区武川县',
  '150200': '内蒙古自治区包头市',
  '150201': '内蒙古自治区包头市市辖区',
  '150202': '内蒙古自治区包头市东河区',
  '150203': '内蒙古自治区包头市昆都仑区',
  '150204': '内蒙古自治区包头市青山区',
  '150205': '内蒙古自治区包头市石拐区',
  '150206': '内蒙古自治区包头市白云矿区',
  '150207': '内蒙古自治区包头市九原区',
  '150220': '内蒙古自治区包头市区',
  '150221': '内蒙古自治区土默特右旗',
  '150222': '内蒙古自治区固阳县',
  '150223': '内蒙古自治区达尔罕茂明安联合旗',
  '150300': '内蒙古自治区乌海市',
  '150301': '内蒙古自治区乌海市市辖区',
  '150302': '内蒙古自治区乌海市海勃湾区',
  '150303': '内蒙古自治区乌海市海南区',
  '150304': '内蒙古自治区乌海市乌达区',
  '150400': '内蒙古自治区赤峰市',
  '150401': '内蒙古自治区赤峰市市辖区',
  '150402': '内蒙古自治区赤峰市红山区',
  '150403': '内蒙古自治区赤峰市元宝山区',
  '150404': '内蒙古自治区赤峰市松山区',
  '150421': '内蒙古自治区阿鲁科尔沁旗',
  '150422': '内蒙古自治区巴林左旗',
  '150423': '内蒙古自治区巴林右旗',
  '150424': '内蒙古自治区林西县',
  '150425': '内蒙古自治区克什克腾旗',
  '150426': '内蒙古自治区翁牛特旗',
  '150428': '内蒙古自治区喀喇沁旗',
  '150429': '内蒙古自治区宁城县',
  '150430': '内蒙古自治区敖汉旗',
  '150500': '内蒙古自治区通辽市',
  '150501': '内蒙古自治区通辽市市辖区',
  '150502': '内蒙古自治区通辽市科尔沁区',
  '150521': '内蒙古自治区科尔沁左翼中旗',
  '150522': '内蒙古自治区科尔沁左翼后旗',
  '150523': '内蒙古自治区开鲁县',
  '150524': '内蒙古自治区库伦旗',
  '150525': '内蒙古自治区奈曼旗',
  '150526': '内蒙古自治区扎鲁特旗',
  '150581': '内蒙古自治区霍林郭勒市',
  '150600': '内蒙古自治区鄂尔多斯市',
  '150602': '内蒙古自治区鄂尔多斯市东胜区',
  '150621': '内蒙古自治区达拉特旗',
  '150622': '内蒙古自治区准格尔旗',
  '150623': '内蒙古自治区鄂托克前旗',
  '150624': '内蒙古自治区鄂托克旗',
  '150625': '内蒙古自治区杭锦旗',
  '150626': '内蒙古自治区乌审旗',
  '150627': '内蒙古自治区伊金霍洛旗',
  '150700': '内蒙古自治区呼伦贝尔市',
  '150701': '内蒙古自治区呼伦贝尔市市辖区',
  '150702': '内蒙古自治区呼伦贝尔市海拉尔区',
  '150721': '内蒙古自治区阿荣旗',
  '150722': '内蒙古自治区莫力达瓦达斡尔族自治旗',
  '150723': '内蒙古自治区鄂伦春自治旗',
  '150724': '内蒙古自治区鄂温克族自治旗',
  '150725': '内蒙古自治区陈巴尔虎旗',
  '150726': '内蒙古自治区新巴尔虎左旗',
  '150727': '内蒙古自治区新巴尔虎右旗',
  '150781': '内蒙古自治区满洲里市',
  '150782': '内蒙古自治区牙克石市',
  '150783': '内蒙古自治区扎兰屯市',
  '150784': '内蒙古自治区额尔古纳市',
  '150785': '内蒙古自治区根河市',
  '150800': '内蒙古自治区巴彦淖尔市',
  '150801': '内蒙古自治区巴彦淖尔市市辖区',
  '150802': '内蒙古自治区巴彦淖尔市临河区',
  '150821': '内蒙古自治区五原县',
  '150822': '内蒙古自治区磴口县',
  '150823': '内蒙古自治区乌拉特前旗',
  '150824': '内蒙古自治区乌拉特中旗',
  '150825': '内蒙古自治区乌拉特后旗',
  '150826': '内蒙古自治区杭锦后旗',
  '150900': '内蒙古自治区乌兰察布市',
  '150901': '内蒙古自治区乌兰察布市市辖区',
  '150902': '内蒙古自治区乌兰察布市集宁区',
  '150921': '内蒙古自治区卓资县',
  '150922': '内蒙古自治区化德县',
  '150923': '内蒙古自治区商都县',
  '150924': '内蒙古自治区兴和县',
  '150925': '内蒙古自治区凉城县',
  '150926': '内蒙古自治区察哈尔右翼前旗',
  '150927': '内蒙古自治区察哈尔右翼中旗',
  '150928': '内蒙古自治区察哈尔右翼后旗',
  '150929': '内蒙古自治区四子王旗',
  '150981': '内蒙古自治区丰镇市',
  '152100': '内蒙古自治区呼伦贝尔盟',
  '152101': '内蒙古自治区海拉尔市',
  '152102': '内蒙古自治区满洲里市',
  '152103': '内蒙古自治区扎兰屯市',
  '152104': '内蒙古自治区牙克石市',
  '152105': '内蒙古自治区根河市',
  '152106': '内蒙古自治区额尔古纳市',
  '152121': '内蒙古自治区布特哈旗',
  '152122': '内蒙古自治区阿荣旗',
  '152123': '内蒙古自治区莫力达瓦达斡尔族自治旗',
  '152124': '内蒙古自治区喜桂图旗',
  '152125': '内蒙古自治区额尔古纳右旗',
  '152126': '内蒙古自治区额尔古纳左旗',
  '152127': '内蒙古自治区鄂伦春自治旗',
  '152128': '内蒙古自治区鄂温克族自治旗',
  '152129': '内蒙古自治区新巴尔虎右旗',
  '152130': '内蒙古自治区新巴尔虎左旗',
  '152131': '内蒙古自治区陈巴尔虎旗',
  '152200': '内蒙古自治区兴安盟',
  '152201': '内蒙古自治区乌兰浩特市',
  '152202': '内蒙古自治区阿尔山市',
  '152221': '内蒙古自治区科尔沁右翼前旗',
  '152222': '内蒙古自治区科尔沁右翼中旗',
  '152223': '内蒙古自治区扎赉特旗',
  '152224': '内蒙古自治区突泉县',
  '152300': '内蒙古自治区哲里木盟',
  '152301': '内蒙古自治区通辽市',
  '152302': '内蒙古自治区霍林郭勒市',
  '152321': '内蒙古自治区通辽县',
  '152322': '内蒙古自治区科尔沁左翼中旗',
  '152323': '内蒙古自治区科尔沁左翼后旗',
  '152324': '内蒙古自治区开鲁县',
  '152325': '内蒙古自治区库伦旗',
  '152326': '内蒙古自治区奈曼旗',
  '152327': '内蒙古自治区扎鲁特旗',
  '152400': '内蒙古自治区昭乌达盟',
  '152401': '内蒙古自治区赤峰市',
  '152421': '内蒙古自治区阿鲁科尔沁旗',
  '152422': '内蒙古自治区巴林左旗',
  '152423': '内蒙古自治区巴林右旗',
  '152424': '内蒙古自治区林西县',
  '152425': '内蒙古自治区克什克腾旗',
  '152426': '内蒙古自治区翁牛特旗',
  '152427': '内蒙古自治区赤峰县',
  '152428': '内蒙古自治区喀喇沁旗',
  '152429': '内蒙古自治区宁城县',
  '152430': '内蒙古自治区敖汉旗',
  '152500': '内蒙古自治区锡林郭勒盟',
  '152501': '内蒙古自治区二连浩特市',
  '152502': '内蒙古自治区锡林浩特市',
  '152521': '内蒙古自治区阿巴哈纳尔旗',
  '152522': '内蒙古自治区阿巴嘎旗',
  '152523': '内蒙古自治区苏尼特左旗',
  '152524': '内蒙古自治区苏尼特右旗',
  '152525': '内蒙古自治区东乌珠穆沁旗',
  '152526': '内蒙古自治区西乌珠穆沁旗',
  '152527': '内蒙古自治区太仆寺旗',
  '152528': '内蒙古自治区镶黄旗',
  '152529': '内蒙古自治区正镶白旗',
  '152530': '内蒙古自治区正蓝旗',
  '152531': '内蒙古自治区多伦县',
  '152600': '内蒙古自治区乌兰察布盟',
  '152601': '内蒙古自治区集宁市',
  '152602': '内蒙古自治区丰镇市',
  '152621': '内蒙古自治区武川县',
  '152622': '内蒙古自治区和林格尔县',
  '152623': '内蒙古自治区清水河县',
  '152624': '内蒙古自治区卓资县',
  '152625': '内蒙古自治区化德县',
  '152626': '内蒙古自治区商都县',
  '152627': '内蒙古自治区兴和县',
  '152628': '内蒙古自治区丰镇县',
  '152629': '内蒙古自治区凉城县',
  '152630': '内蒙古自治区察哈尔右翼前旗',
  '152631': '内蒙古自治区察哈尔右翼中旗',
  '152632': '内蒙古自治区察哈尔右翼后旗',
  '152634': '内蒙古自治区四子王旗',
  '152700': '内蒙古自治区伊克昭盟',
  '152701': '内蒙古自治区东胜市',
  '152721': '内蒙古自治区东胜县',
  '152722': '内蒙古自治区达拉特旗',
  '152723': '内蒙古自治区准格尔旗',
  '152724': '内蒙古自治区鄂托克前旗',
  '152725': '内蒙古自治区鄂托克旗',
  '152726': '内蒙古自治区杭锦旗',
  '152727': '内蒙古自治区乌审旗',
  '152728': '内蒙古自治区伊金霍洛旗',
  '152800': '内蒙古自治区巴彦淖尔盟',
  '152801': '内蒙古自治区临河市',
  '152821': '内蒙古自治区临河县',
  '152822': '内蒙古自治区五原县',
  '152823': '内蒙古自治区磴口县',
  '152824': '内蒙古自治区乌拉特前旗',
  '152825': '内蒙古自治区乌拉特中旗',
  '152826': '内蒙古自治区乌拉特后旗',
  '152827': '内蒙古自治区杭锦后旗',
  '152900': '内蒙古自治区阿拉善盟',
  '152921': '内蒙古自治区阿拉善左旗',
  '152922': '内蒙古自治区阿拉善右旗',
  '152923': '内蒙古自治区额济纳旗',
  '210000': '辽宁省',
  '210100': '辽宁省沈阳市',
  '210101': '辽宁省沈阳市市辖区',
  '210102': '辽宁省沈阳市和平区',
  '210103': '辽宁省沈阳市沈河区',
  '210104': '辽宁省沈阳市大东区',
  '210105': '辽宁省沈阳市皇姑区',
  '210106': '辽宁省沈阳市铁西区',
  '210111': '辽宁省沈阳市苏家屯区',
  '210112': '辽宁省沈阳市东陵区',
  '210113': '辽宁省沈阳市新城子区',
  '210114': '辽宁省沈阳市于洪区',
  '210120': '辽宁省沈阳市区',
  '210121': '辽宁省新民县',
  '210122': '辽宁省辽中县',
  '210123': '辽宁省康平县',
  '210124': '辽宁省法库县',
  '210181': '辽宁省新民市',
  '210200': '辽宁省大连市',
  '210201': '辽宁省大连市市辖区',
  '210202': '辽宁省大连市中山区',
  '210203': '辽宁省大连市西岗区',
  '210204': '辽宁省大连市沙河口区',
  '210211': '辽宁省大连市甘井子区',
  '210212': '辽宁省大连市旅顺口区',
  '210213': '辽宁省大连市金州区',
  '210219': '辽宁省瓦房店市',
  '210220': '辽宁省大连市区',
  '210221': '辽宁省金县',
  '210222': '辽宁省新金县',
  '210223': '辽宁省复县',
  '210224': '辽宁省长海县',
  '210225': '辽宁省庄河县',
  '210281': '辽宁省瓦房店市',
  '210282': '辽宁省普兰店市',
  '210283': '辽宁省庄河市',
  '210300': '辽宁省鞍山市',
  '210301': '辽宁省鞍山市市辖区',
  '210302': '辽宁省鞍山市铁东区',
  '210303': '辽宁省鞍山市铁西区',
  '210304': '辽宁省鞍山市立山区',
  '210311': '辽宁省鞍山市千山区',
  '210319': '辽宁省海城市',
  '210320': '辽宁省鞍山市区',
  '210321': '辽宁省台安县',
  '210322': '辽宁省海城县',
  '210323': '辽宁省岫岩满族自治县',
  '210381': '辽宁省海城市',
  '210400': '辽宁省抚顺市',
  '210401': '辽宁省抚顺市市辖区',
  '210402': '辽宁省抚顺市新抚区',
  '210403': '辽宁省抚顺市东洲区',
  '210404': '辽宁省抚顺市望花区',
  '210411': '辽宁省抚顺市顺城区',
  '210420': '辽宁省抚顺市区',
  '210421': '辽宁省抚顺县',
  '210422': '辽宁省新宾满族自治县',
  '210423': '辽宁省清原满族自治县',
  '210500': '辽宁省本溪市',
  '210501': '辽宁省本溪市市辖区',
  '210502': '辽宁省本溪市平山区',
  '210503': '辽宁省本溪市溪湖区',
  '210504': '辽宁省本溪市明山区',
  '210505': '辽宁省本溪市南芬区',
  '210511': '辽宁省本溪市南芬区',
  '210520': '辽宁省本溪市区',
  '210521': '辽宁省本溪满族自治县',
  '210522': '辽宁省桓仁满族自治县',
  '210600': '辽宁省丹东市',
  '210601': '辽宁省丹东市市辖区',
  '210602': '辽宁省丹东市元宝区',
  '210603': '辽宁省丹东市振兴区',
  '210604': '辽宁省丹东市振安区',
  '210620': '辽宁省丹东市区',
  '210621': '辽宁省凤城满族自治县',
  '210622': '辽宁省岫岩满族自治县',
  '210623': '辽宁省东沟县',
  '210624': '辽宁省宽甸满族自治县',
  '210681': '辽宁省东港市',
  '210682': '辽宁省凤城市',
  '210700': '辽宁省锦州市',
  '210701': '辽宁省锦州市市辖区',
  '210702': '辽宁省锦州市古塔区',
  '210703': '辽宁省锦州市凌河区',
  '210704': '辽宁省锦州市南票区',
  '210705': '辽宁省锦州市葫芦岛区',
  '210711': '辽宁省锦州市太和区',
  '210719': '辽宁省锦西市',
  '210720': '辽宁省锦州市区',
  '210721': '辽宁省锦西县',
  '210722': '辽宁省兴城县',
  '210723': '辽宁省绥中县',
  '210724': '辽宁省锦县',
  '210725': '辽宁省北镇满族自治县',
  '210726': '辽宁省黑山县',
  '210727': '辽宁省义县',
  '210781': '辽宁省凌海市',
  '210782': '辽宁省北宁市',
  '210800': '辽宁省营口市',
  '210801': '辽宁省营口市市辖区',
  '210802': '辽宁省营口市站前区',
  '210803': '辽宁省营口市西市区',
  '210804': '辽宁省营口市鲅鱼圈区',
  '210811': '辽宁省营口市老边区',
  '210812': '辽宁省营口市鲅鱼圈区',
  '210820': '辽宁省营口市区',
  '210821': '辽宁省营口县',
  '210822': '辽宁省盘山县',
  '210823': '辽宁省大洼县',
  '210824': '辽宁省盖县',
  '210881': '辽宁省盖州市',
  '210882': '辽宁省大石桥市',
  '210900': '辽宁省阜新市',
  '210901': '辽宁省阜新市市辖区',
  '210902': '辽宁省阜新市海州区',
  '210903': '辽宁省阜新市新邱区',
  '210904': '辽宁省阜新市太平区',
  '210905': '辽宁省阜新市清河门区',
  '210911': '辽宁省阜新市细河区',
  '210920': '辽宁省阜新市区',
  '210921': '辽宁省阜新蒙古族自治县',
  '210922': '辽宁省彰武县',
  '211000': '辽宁省辽阳市',
  '211001': '辽宁省辽阳市市辖区',
  '211002': '辽宁省辽阳市白塔区',
  '211003': '辽宁省辽阳市文圣区',
  '211004': '辽宁省辽阳市宏伟区',
  '211005': '辽宁省辽阳市弓长岭区',
  '211011': '辽宁省辽阳市太子河区',
  '211020': '辽宁省辽阳市区',
  '211021': '辽宁省辽阳县',
  '211022': '辽宁省灯塔县',
  '211081': '辽宁省灯塔市',
  '211100': '辽宁省盘锦市',
  '211101': '辽宁省盘锦市市辖区',
  '211102': '辽宁省盘锦市双台子区',
  '211103': '辽宁省盘锦市兴隆台区',
  '211111': '辽宁省盘锦市郊区',
  '211121': '辽宁省大洼县',
  '211122': '辽宁省盘山县',
  '211200': '辽宁省铁岭市',
  '211201': '辽宁省铁岭市市辖区',
  '211202': '辽宁省铁岭市银州区',
  '211203': '辽宁省铁岭市铁法区',
  '211204': '辽宁省铁岭市清河区',
  '211221': '辽宁省铁岭县',
  '211222': '辽宁省开原县',
  '211223': '辽宁省西丰县',
  '211224': '辽宁省昌图县',
  '211225': '辽宁省康平县',
  '211226': '辽宁省法库县',
  '211281': '辽宁省调兵山市',
  '211282': '辽宁省开原市',
  '211300': '辽宁省朝阳市',
  '211301': '辽宁省朝阳市市辖区',
  '211302': '辽宁省朝阳市双塔区',
  '211303': '辽宁省朝阳市龙城区',
  '211319': '辽宁省北票市',
  '211321': '辽宁省朝阳县',
  '211322': '辽宁省建平县',
  '211323': '辽宁省凌源县',
  '211324': '辽宁省喀喇沁左翼蒙古族自治县',
  '211325': '辽宁省建昌县',
  '211326': '辽宁省北票县',
  '211381': '辽宁省北票市',
  '211382': '辽宁省凌源市',
  '211400': '辽宁省葫芦岛市',
  '211401': '辽宁省葫芦岛市市辖区',
  '211402': '辽宁省葫芦岛市连山区',
  '211403': '辽宁省葫芦岛市龙港区',
  '211404': '辽宁省葫芦岛市南票区',
  '211421': '辽宁省绥中县',
  '211422': '辽宁省建昌县',
  '211481': '辽宁省兴城市',
  '212100': '辽宁省铁岭地区',
  '212101': '辽宁省铁岭市',
  '212102': '辽宁省铁法市',
  '212121': '辽宁省铁岭县',
  '212122': '辽宁省开原县',
  '212123': '辽宁省西丰县',
  '212124': '辽宁省昌图县',
  '212125': '辽宁省康平县',
  '212126': '辽宁省法库县',
  '212200': '辽宁省朝阳地区',
  '212201': '辽宁省朝阳市',
  '212221': '辽宁省朝阳县',
  '212222': '辽宁省建平县',
  '212223': '辽宁省凌源县',
  '212224': '辽宁省喀啦沁左翼蒙古族自治县',
  '212225': '辽宁省建昌县',
  '212226': '辽宁省北票县',
  '219001': '辽宁省瓦房店市',
  '219002': '辽宁省海城市',
  '219003': '辽宁省锦西市',
  '219004': '辽宁省兴城市',
  '219005': '辽宁省铁法市',
  '219006': '辽宁省北票市',
  '219007': '辽宁省开原市',
  '220000': '吉林省',
  '220100': '吉林省长春市',
  '220101': '吉林省长春市市辖区',
  '220102': '吉林省长春市南关区',
  '220103': '吉林省长春市宽城区',
  '220104': '吉林省长春市朝阳区',
  '220105': '吉林省长春市二道区',
  '220106': '吉林省长春市绿园区',
  '220111': '吉林省长春市郊区',
  '220112': '吉林省长春市双阳区',
  '220120': '吉林省长春市区',
  '220121': '吉林省榆树县',
  '220122': '吉林省农安县',
  '220123': '吉林省九台县',
  '220124': '吉林省德惠县',
  '220125': '吉林省双阳县',
  '220181': '吉林省九台市',
  '220182': '吉林省榆树市',
  '220183': '吉林省德惠市',
  '220200': '吉林省吉林市',
  '220201': '吉林省吉林市市辖区',
  '220202': '吉林省吉林市昌邑区',
  '220203': '吉林省吉林市龙潭区',
  '220204': '吉林省吉林市船营区',
  '220211': '吉林省吉林市丰满区',
  '220220': '吉林省吉林市区',
  '220221': '吉林省永吉县',
  '220222': '吉林省舒兰县',
  '220223': '吉林省磐石县',
  '220224': '吉林省蛟河县',
  '220225': '吉林省桦甸县',
  '220281': '吉林省蛟河市',
  '220282': '吉林省桦甸市',
  '220283': '吉林省舒兰市',
  '220284': '吉林省磐石市',
  '220300': '吉林省四平市',
  '220301': '吉林省四平市市辖区',
  '220302': '吉林省四平市铁西区',
  '220303': '吉林省四平市铁东区',
  '220319': '吉林省公主岭市',
  '220321': '吉林省怀德县',
  '220322': '吉林省梨树县',
  '220323': '吉林省伊通满族自治县',
  '220324': '吉林省双辽县',
  '220381': '吉林省公主岭市',
  '220382': '吉林省双辽市',
  '220400': '吉林省辽源市',
  '220401': '吉林省辽源市市辖区',
  '220402': '吉林省辽源市龙山区',
  '220403': '吉林省辽源市西安区',
  '220421': '吉林省东丰县',
  '220422': '吉林省东辽县',
  '220500': '吉林省通化市',
  '220501': '吉林省通化市市辖区',
  '220502': '吉林省通化市东昌区',
  '220503': '吉林省通化市二道江区',
  '220519': '吉林省梅河口市',
  '220521': '吉林省通化县',
  '220522': '吉林省集安县',
  '220523': '吉林省辉南县',
  '220524': '吉林省柳河县',
  '220581': '吉林省梅河口市',
  '220582': '吉林省集安市',
  '220600': '吉林省白山市',
  '220601': '吉林省白山市市辖区',
  '220602': '吉林省白山市八道江区',
  '220603': '吉林省浑江市三岔子区',
  '220604': '吉林省浑江市临江区',
  '220621': '吉林省抚松县',
  '220622': '吉林省靖宇县',
  '220623': '吉林省长白朝鲜族自治县',
  '220624': '吉林省临江县',
  '220625': '吉林省江源县',
  '220681': '吉林省临江市',
  '220700': '吉林省松原市',
  '220701': '吉林省松原市市辖区',
  '220702': '吉林省松原市宁江区',
  '220721': '吉林省前郭尔罗斯蒙古族自治县',
  '220722': '吉林省长岭县',
  '220723': '吉林省乾安县',
  '220724': '吉林省扶余县',
  '220800': '吉林省白城市',
  '220801': '吉林省白城市市辖区',
  '220802': '吉林省白城市洮北区',
  '220821': '吉林省镇赉县',
  '220822': '吉林省通榆县',
  '220881': '吉林省洮南市',
  '220882': '吉林省大安市',
  '222100': '吉林省四平地区',
  '222101': '吉林省四平市',
  '222102': '吉林省辽源市',
  '222121': '吉林省怀德县',
  '222122': '吉林省梨树县',
  '222123': '吉林省伊通县',
  '222124': '吉林省东丰县',
  '222125': '吉林省双辽县',
  '222200': '吉林省通化地区',
  '222201': '吉林省通化市',
  '222202': '吉林省浑江市',
  '222221': '吉林省海龙县',
  '222222': '吉林省通化县',
  '222223': '吉林省柳河县',
  '222224': '吉林省辉南县',
  '222225': '吉林省集安县',
  '222226': '吉林省抚松县',
  '222227': '吉林省靖宇县',
  '222228': '吉林省长白朝鲜族自治县',
  '222300': '吉林省白城地区',
  '222301': '吉林省白城市',
  '222302': '吉林省洮南市',
  '222303': '吉林省扶余市',
  '222304': '吉林省大安市',
  '222321': '吉林省扶余县',
  '222322': '吉林省洮安县',
  '222323': '吉林省长岭县',
  '222324': '吉林省前郭尔罗斯蒙古族自治县',
  '222325': '吉林省大安县',
  '222326': '吉林省镇赉县',
  '222327': '吉林省通榆县',
  '222328': '吉林省乾安县',
  '222400': '吉林省延边朝鲜族自治州',
  '222401': '吉林省延吉市',
  '222402': '吉林省图们市',
  '222403': '吉林省敦化市',
  '222404': '吉林省珲春市',
  '222405': '吉林省龙井市',
  '222406': '吉林省和龙市',
  '222421': '吉林省龙井县',
  '222422': '吉林省敦化县',
  '222423': '吉林省和龙县',
  '222424': '吉林省汪清县',
  '222425': '吉林省珲春县',
  '222426': '吉林省安图县',
  '229000': '吉林省省直辖行政单位',
  '229001': '吉林省公主岭市',
  '229002': '吉林省梅河口市',
  '229003': '吉林省集安市',
  '229004': '吉林省桦甸市',
  '229005': '吉林省九台市',
  '230000': '黑龙江省',
  '230100': '黑龙江省哈尔滨市',
  '230101': '黑龙江省哈尔滨市市辖区',
  '230102': '黑龙江省哈尔滨市道里区',
  '230103': '黑龙江省哈尔滨市南岗区',
  '230104': '黑龙江省哈尔滨市道外区',
  '230105': '黑龙江省哈尔滨市太平区',
  '230106': '黑龙江省哈尔滨市香坊区',
  '230107': '黑龙江省哈尔滨市动力区',
  '230108': '黑龙江省哈尔滨市平房区',
  '230109': '黑龙江省哈尔滨市松北区',
  '230111': '黑龙江省哈尔滨市呼兰区',
  '230121': '黑龙江省呼兰县',
  '230122': '黑龙江省阿城县',
  '230123': '黑龙江省依兰县',
  '230124': '黑龙江省方正县',
  '230125': '黑龙江省宾县',
  '230126': '黑龙江省巴彦县',
  '230127': '黑龙江省木兰县',
  '230128': '黑龙江省通河县',
  '230129': '黑龙江省延寿县',
  '230181': '黑龙江省阿城市',
  '230182': '黑龙江省双城市',
  '230183': '黑龙江省尚志市',
  '230184': '黑龙江省五常市',
  '230200': '黑龙江省齐齐哈尔市',
  '230201': '黑龙江省齐齐哈尔市市辖区',
  '230202': '黑龙江省齐齐哈尔市龙沙区',
  '230203': '黑龙江省齐齐哈尔市建华区',
  '230204': '黑龙江省齐齐哈尔市铁锋区',
  '230205': '黑龙江省齐齐哈尔市昂昂溪区',
  '230206': '黑龙江省齐齐哈尔市富拉尔基区',
  '230207': '黑龙江省齐齐哈尔市碾子山区',
  '230208': '黑龙江省齐齐哈尔市梅里斯达斡尔族区',
  '230221': '黑龙江省龙江县',
  '230222': '黑龙江省讷河县',
  '230223': '黑龙江省依安县',
  '230224': '黑龙江省泰来县',
  '230225': '黑龙江省甘南县',
  '230226': '黑龙江省杜尔伯特蒙古族自治县',
  '230227': '黑龙江省富裕县',
  '230228': '黑龙江省林甸县',
  '230229': '黑龙江省克山县',
  '230230': '黑龙江省克东县',
  '230231': '黑龙江省拜泉县',
  '230281': '黑龙江省讷河市',
  '230300': '黑龙江省鸡西市',
  '230301': '黑龙江省鸡西市市辖区',
  '230302': '黑龙江省鸡西市鸡冠区',
  '230303': '黑龙江省鸡西市恒山区',
  '230304': '黑龙江省鸡西市滴道区',
  '230305': '黑龙江省鸡西市梨树区',
  '230306': '黑龙江省鸡西市城子河区',
  '230307': '黑龙江省鸡西市麻山区',
  '230321': '黑龙江省鸡东县',
  '230322': '黑龙江省虎林县',
  '230381': '黑龙江省虎林市',
  '230382': '黑龙江省密山市',
  '230400': '黑龙江省鹤岗市',
  '230401': '黑龙江省鹤岗市市辖区',
  '230402': '黑龙江省鹤岗市向阳区',
  '230403': '黑龙江省鹤岗市工农区',
  '230404': '黑龙江省鹤岗市南山区',
  '230405': '黑龙江省鹤岗市兴安区',
  '230406': '黑龙江省鹤岗市东山区',
  '230407': '黑龙江省鹤岗市兴山区',
  '230421': '黑龙江省萝北县',
  '230422': '黑龙江省绥滨县',
  '230500': '黑龙江省双鸭山市',
  '230501': '黑龙江省双鸭山市市辖区',
  '230502': '黑龙江省双鸭山市尖山区',
  '230503': '黑龙江省双鸭山市岭东区',
  '230504': '黑龙江省双鸭山市岭西区',
  '230505': '黑龙江省双鸭山市四方台区',
  '230506': '黑龙江省双鸭山市宝山区',
  '230521': '黑龙江省集贤县',
  '230522': '黑龙江省友谊县',
  '230523': '黑龙江省宝清县',
  '230524': '黑龙江省饶河县',
  '230600': '黑龙江省大庆市',
  '230601': '黑龙江省大庆市市辖区',
  '230602': '黑龙江省大庆市萨尔图区',
  '230603': '黑龙江省大庆市龙凤区',
  '230604': '黑龙江省大庆市让胡路区',
  '230605': '黑龙江省大庆市红岗区',
  '230606': '黑龙江省大庆市大同区',
  '230621': '黑龙江省肇州县',
  '230622': '黑龙江省肇源县',
  '230623': '黑龙江省林甸县',
  '230624': '黑龙江省杜尔伯特蒙古族自治县',
  '230700': '黑龙江省伊春市',
  '230701': '黑龙江省伊春市市辖区',
  '230702': '黑龙江省伊春市伊春区',
  '230703': '黑龙江省伊春市南岔区',
  '230704': '黑龙江省伊春市友好区',
  '230705': '黑龙江省伊春市西林区',
  '230706': '黑龙江省伊春市翠峦区',
  '230707': '黑龙江省伊春市新青区',
  '230708': '黑龙江省伊春市美溪区',
  '230709': '黑龙江省伊春市金山屯区',
  '230710': '黑龙江省伊春市五营区',
  '230711': '黑龙江省伊春市乌马河区',
  '230712': '黑龙江省伊春市汤旺河区',
  '230713': '黑龙江省伊春市带岭区',
  '230714': '黑龙江省伊春市乌伊岭区',
  '230715': '黑龙江省伊春市红星区',
  '230716': '黑龙江省伊春市上甘岭区',
  '230720': '黑龙江省伊春地区',
  '230721': '黑龙江省铁力县',
  '230722': '黑龙江省嘉荫县',
  '230781': '黑龙江省铁力市',
  '230800': '黑龙江省佳木斯市',
  '230801': '黑龙江省佳木斯市市辖区',
  '230802': '黑龙江省佳木斯市永红区',
  '230803': '黑龙江省佳木斯市向阳区',
  '230804': '黑龙江省佳木斯市前进区',
  '230805': '黑龙江省佳木斯市东风区',
  '230811': '黑龙江省佳木斯市郊区',
  '230821': '黑龙江省富锦县',
  '230822': '黑龙江省桦南县',
  '230823': '黑龙江省依兰县',
  '230825': '黑龙江省集贤县',
  '230826': '黑龙江省桦川县',
  '230827': '黑龙江省宝清县',
  '230828': '黑龙江省汤原县',
  '230829': '黑龙江省绥滨县',
  '230830': '黑龙江省萝北县',
  '230831': '黑龙江省同江县',
  '230832': '黑龙江省饶河县',
  '230833': '黑龙江省抚远县',
  '230834': '黑龙江省友谊县',
  '230881': '黑龙江省同江市',
  '230882': '黑龙江省富锦市',
  '230900': '黑龙江省七台河市',
  '230901': '黑龙江省七台河市市辖区',
  '230902': '黑龙江省七台河市新兴区',
  '230903': '黑龙江省七台河市桃山区',
  '230904': '黑龙江省七台河市茄子河区',
  '230921': '黑龙江省勃利县',
  '231000': '黑龙江省牡丹江市',
  '231001': '黑龙江省牡丹江市市辖区',
  '231002': '黑龙江省牡丹江市东安区',
  '231003': '黑龙江省牡丹江市阳明区',
  '231004': '黑龙江省牡丹江市爱民区',
  '231005': '黑龙江省牡丹江市西安区',
  '231011': '黑龙江省牡丹江市郊区',
  '231020': '黑龙江省绥芬河市',
  '231021': '黑龙江省宁安县',
  '231022': '黑龙江省海林县',
  '231023': '黑龙江省穆棱县',
  '231024': '黑龙江省东宁县',
  '231025': '黑龙江省林口县',
  '231026': '黑龙江省密山县',
  '231027': '黑龙江省虎林县',
  '231081': '黑龙江省绥芬河市',
  '231082': '黑龙江省密山市',
  '231083': '黑龙江省海林市',
  '231084': '黑龙江省宁安市',
  '231085': '黑龙江省穆棱市',
  '231100': '黑龙江省黑河市',
  '231101': '黑龙江省黑河市市辖区',
  '231102': '黑龙江省黑河市爱辉区',
  '231121': '黑龙江省嫩江县',
  '231122': '黑龙江省德都县',
  '231123': '黑龙江省逊克县',
  '231124': '黑龙江省孙吴县',
  '231181': '黑龙江省北安市',
  '231182': '黑龙江省五大连池市',
  '231200': '黑龙江省绥化市',
  '231201': '黑龙江省绥化市市辖区',
  '231202': '黑龙江省绥化市北林区',
  '231221': '黑龙江省望奎县',
  '231222': '黑龙江省兰西县',
  '231223': '黑龙江省青冈县',
  '231224': '黑龙江省庆安县',
  '231225': '黑龙江省明水县',
  '231226': '黑龙江省绥棱县',
  '231281': '黑龙江省安达市',
  '231282': '黑龙江省肇东市',
  '231283': '黑龙江省海伦市',
  '232100': '黑龙江省松花江地区',
  '232101': '黑龙江省双城市',
  '232102': '黑龙江省尚志市',
  '232103': '黑龙江省五常市',
  '232121': '黑龙江省阿城县',
  '232122': '黑龙江省宾县',
  '232123': '黑龙江省呼兰县',
  '232124': '黑龙江省双城县',
  '232125': '黑龙江省五常县',
  '232126': '黑龙江省巴彦县',
  '232127': '黑龙江省木兰县',
  '232128': '黑龙江省通河县',
  '232129': '黑龙江省尚志县',
  '232130': '黑龙江省方正县',
  '232131': '黑龙江省延寿县',
  '232200': '黑龙江省嫩江地区',
  '232221': '黑龙江省龙江县',
  '232222': '黑龙江省讷河县',
  '232223': '黑龙江省依安县',
  '232224': '黑龙江省泰来县',
  '232225': '黑龙江省甘南县',
  '232226': '黑龙江省杜尔伯特蒙古族自治县',
  '232227': '黑龙江省富裕县',
  '232228': '黑龙江省林甸县',
  '232229': '黑龙江省克山县',
  '232230': '黑龙江省克东县',
  '232231': '黑龙江省拜泉县',
  '232300': '黑龙江省绥化地区',
  '232301': '黑龙江省绥化市',
  '232302': '黑龙江省安达市',
  '232303': '黑龙江省肇东市',
  '232304': '黑龙江省海伦市',
  '232321': '黑龙江省海伦县',
  '232322': '黑龙江省肇东县',
  '232323': '黑龙江省绥化县',
  '232324': '黑龙江省望奎县',
  '232325': '黑龙江省兰西县',
  '232326': '黑龙江省青冈县',
  '232327': '黑龙江省安达县',
  '232328': '黑龙江省肇源县',
  '232329': '黑龙江省肇州县',
  '232330': '黑龙江省庆安县',
  '232331': '黑龙江省明水县',
  '232332': '黑龙江省绥棱县',
  '232400': '黑龙江省合江地区',
  '232401': '黑龙江省佳木斯市',
  '232402': '黑龙江省七台河市',
  '232421': '黑龙江省富锦县',
  '232422': '黑龙江省桦南县',
  '232423': '黑龙江省依兰县',
  '232424': '黑龙江省勃利县',
  '232425': '黑龙江省集贤县',
  '232426': '黑龙江省桦川县',
  '232427': '黑龙江省宝清县',
  '232428': '黑龙江省汤源县',
  '232429': '黑龙江省绥滨县',
  '232430': '黑龙江省萝北县',
  '232431': '黑龙江省同江县',
  '232432': '黑龙江省饶河县',
  '232433': '黑龙江省抚远县',
  '232500': '黑龙江省牡丹江地区',
  '232501': '黑龙江省牡丹江市',
  '232502': '黑龙江省绥芬河市',
  '232521': '黑龙江省宁安县',
  '232522': '黑龙江省海林县',
  '232523': '黑龙江省穆棱县',
  '232524': '黑龙江省东宁县',
  '232525': '黑龙江省林口县',
  '232526': '黑龙江省鸡东县',
  '232527': '黑龙江省密山县',
  '232528': '黑龙江省虎林县',
  '232600': '黑龙江省黑河地区',
  '232601': '黑龙江省黑河市',
  '232602': '黑龙江省北安市',
  '232603': '黑龙江省五大连池市',
  '232621': '黑龙江省北安县',
  '232622': '黑龙江省嫩江县',
  '232623': '黑龙江省德都县',
  '232624': '黑龙江省爱辉县',
  '232625': '黑龙江省逊克县',
  '232626': '黑龙江省孙吴县',
  '232700': '黑龙江省大兴安岭地区',
  '232721': '黑龙江省呼玛县',
  '232722': '黑龙江省塔河县',
  '232723': '黑龙江省漠河县',
  '239000': '黑龙江省省直辖行政单位',
  '239001': '黑龙江省绥芬河市',
  '239002': '黑龙江省阿城市',
  '239003': '黑龙江省同江市',
  '239004': '黑龙江省富锦市',
  '239005': '黑龙江省铁力市',
  '239006': '黑龙江省密山市',
  '310000': '上海市',
  '310100': '上海市市辖区',
  '310101': '上海市黄浦区',
  '310102': '上海市南市区',
  '310103': '上海市卢湾区',
  '310104': '上海市徐汇区',
  '310105': '上海市长宁区',
  '310106': '上海市静安区',
  '310107': '上海市普陀区',
  '310108': '上海市闸北区',
  '310109': '上海市虹口区',
  '310110': '上海市杨浦区',
  '310111': '上海市吴淞区',
  '310112': '上海市闵行区',
  '310113': '上海市宝山区',
  '310114': '上海市嘉定区',
  '310115': '上海市浦东新区',
  '310116': '上海市金山区',
  '310117': '上海市松江区',
  '310118': '上海市青浦区',
  '310119': '上海市南汇区',
  '310120': '上海市奉贤区',
  '310221': '上海市上海县',
  '310222': '上海市嘉定县',
  '310223': '上海市宝山县',
  '310224': '上海市川沙县',
  '310225': '上海市南汇县',
  '310226': '上海市奉贤县',
  '310227': '上海市松江县',
  '310228': '上海市金山县',
  '310229': '上海市青浦县',
  '310230': '上海市崇明县',
  '320000': '江苏省',
  '320100': '江苏省南京市',
  '320101': '江苏省南京市市辖区',
  '320102': '江苏省南京市玄武区',
  '320103': '江苏省南京市白下区',
  '320104': '江苏省南京市秦淮区',
  '320105': '江苏省南京市建邺区',
  '320106': '江苏省南京市鼓楼区',
  '320107': '江苏省南京市下关区',
  '320111': '江苏省南京市浦口区',
  '320112': '江苏省南京市大厂区',
  '320113': '江苏省南京市栖霞区',
  '320114': '江苏省南京市雨花台区',
  '320115': '江苏省南京市江宁区',
  '320116': '江苏省南京市六合区',
  '320120': '江苏省南京市区',
  '320121': '江苏省江宁县',
  '320122': '江苏省江浦县',
  '320123': '江苏省六合县',
  '320124': '江苏省溧水县',
  '320125': '江苏省高淳县',
  '320200': '江苏省无锡市',
  '320201': '江苏省无锡市市辖区',
  '320202': '江苏省无锡市崇安区',
  '320203': '江苏省无锡市南长区',
  '320204': '江苏省无锡市北塘区',
  '320205': '江苏省无锡市锡山区',
  '320206': '江苏省无锡市惠山区',
  '320211': '江苏省无锡市滨湖区',
  '320212': '江苏省无锡市马山区',
  '320221': '江苏省江阴县',
  '320222': '江苏省无锡县',
  '320223': '江苏省宜兴县',
  '320281': '江苏省江阴市',
  '320282': '江苏省宜兴市',
  '320283': '江苏省锡山市',
  '320300': '江苏省徐州市',
  '320301': '江苏省徐州市市辖区',
  '320302': '江苏省徐州市鼓楼区',
  '320303': '江苏省徐州市云龙区',
  '320304': '江苏省徐州市九里区',
  '320305': '江苏省徐州市贾汪区',
  '320311': '江苏省徐州市泉山区',
  '320321': '江苏省丰县',
  '320322': '江苏省沛县',
  '320323': '江苏省铜山县',
  '320324': '江苏省睢宁县',
  '320325': '江苏省邳县',
  '320326': '江苏省新沂县',
  '320381': '江苏省新沂市',
  '320382': '江苏省邳州市',
  '320400': '江苏省常州市',
  '320401': '江苏省常州市市辖区',
  '320402': '江苏省常州市天宁区',
  '320403': '江苏省常州市广化区',
  '320404': '江苏省常州市钟楼区',
  '320405': '江苏省常州市戚墅堰区',
  '320411': '江苏省常州市新北区',
  '320412': '江苏省常州市武进区',
  '320421': '江苏省武进县',
  '320422': '江苏省金坛县',
  '320423': '江苏省溧阳县',
  '320481': '江苏省溧阳市',
  '320482': '江苏省金坛市',
  '320483': '江苏省武进市',
  '320500': '江苏省苏州市',
  '320501': '江苏省苏州市市辖区',
  '320502': '江苏省苏州市沧浪区',
  '320503': '江苏省苏州市平江区',
  '320504': '江苏省苏州市金阊区',
  '320505': '江苏省苏州市虎丘区',
  '320506': '江苏省苏州市吴中区',
  '320507': '江苏省苏州市相城区',
  '320511': '江苏省苏州市郊区',
  '320520': '江苏省常熟市',
  '320521': '江苏省沙洲县',
  '320522': '江苏省太仓县',
  '320523': '江苏省昆山县',
  '320524': '江苏省吴县',
  '320525': '江苏省吴江县',
  '320581': '江苏省常熟市',
  '320582': '江苏省张家港市',
  '320583': '江苏省昆山市',
  '320584': '江苏省吴江市',
  '320585': '江苏省太仓市',
  '320586': '江苏省吴县市',
  '320600': '江苏省南通市',
  '320601': '江苏省南通市市辖区',
  '320602': '江苏省南通市崇川区',
  '320611': '江苏省南通市港闸区',
  '320621': '江苏省海安县',
  '320622': '江苏省如皋县',
  '320623': '江苏省如东县',
  '320624': '江苏省南通县',
  '320625': '江苏省海门县',
  '320626': '江苏省启东县',
  '320681': '江苏省启东市',
  '320682': '江苏省如皋市',
  '320683': '江苏省通州市',
  '320684': '江苏省海门市',
  '320700': '江苏省连云港市',
  '320701': '江苏省连云港市市辖区',
  '320702': '江苏省连云港市新海区',
  '320703': '江苏省连云港市连云区',
  '320704': '江苏省连云港市云台区',
  '320705': '江苏省连云港市新浦区',
  '320706': '江苏省连云港市海州区',
  '320721': '江苏省赣榆县',
  '320722': '江苏省东海县',
  '320723': '江苏省灌云县',
  '320724': '江苏省灌南县',
  '320800': '江苏省淮安市',
  '320801': '江苏省淮安市市辖区',
  '320802': '江苏省淮安市清河区',
  '320803': '江苏省淮安市楚州区',
  '320804': '江苏省淮安市淮阴区',
  '320811': '江苏省淮安市清浦区',
  '320821': '江苏省淮阴县',
  '320822': '江苏省灌南县',
  '320823': '江苏省沭阳县',
  '320824': '江苏省宿迁县',
  '320825': '江苏省泗阳县',
  '320826': '江苏省涟水县',
  '320827': '江苏省泗洪县',
  '320828': '江苏省淮安县',
  '320829': '江苏省洪泽县',
  '320830': '江苏省盱眙县',
  '320831': '江苏省金湖县',
  '320881': '江苏省宿迁市',
  '320882': '江苏省淮安市',
  '320900': '江苏省盐城市',
  '320901': '江苏省盐城市市辖区',
  '320902': '江苏省盐城市亭湖区',
  '320903': '江苏省盐城市盐都区',
  '320911': '江苏省盐城市郊区',
  '320921': '江苏省响水县',
  '320922': '江苏省滨海县',
  '320923': '江苏省阜宁县',
  '320924': '江苏省射阳县',
  '320925': '江苏省建湖县',
  '320926': '江苏省大丰县',
  '320927': '江苏省东台县',
  '320928': '江苏省盐都县',
  '320981': '江苏省东台市',
  '320982': '江苏省大丰市',
  '321000': '江苏省扬州市',
  '321001': '江苏省扬州市市辖区',
  '321002': '江苏省扬州市广陵区',
  '321003': '江苏省扬州市邗江区',
  '321011': '江苏省扬州市郊区',
  '321019': '江苏省仪征市',
  '321020': '江苏省泰州市',
  '321021': '江苏省兴化县',
  '321022': '江苏省高邮县',
  '321023': '江苏省宝应县',
  '321024': '江苏省靖江县',
  '321025': '江苏省泰兴县',
  '321026': '江苏省江都县',
  '321027': '江苏省邗江县',
  '321028': '江苏省泰县',
  '321029': '江苏省仪征县',
  '321081': '江苏省仪征市',
  '321082': '江苏省泰州市',
  '321083': '江苏省兴化市',
  '321084': '江苏省高邮市',
  '321085': '江苏省泰兴市',
  '321086': '江苏省靖江市',
  '321088': '江苏省江都市',
  '321100': '江苏省镇江市',
  '321101': '江苏省镇江市市辖区',
  '321102': '江苏省镇江市京口区',
  '321111': '江苏省镇江市润州区',
  '321112': '江苏省镇江市丹徒区',
  '321121': '江苏省丹徒县',
  '321122': '江苏省丹阳县',
  '321123': '江苏省句容县',
  '321124': '江苏省扬中县',
  '321181': '江苏省丹阳市',
  '321182': '江苏省扬中市',
  '321183': '江苏省句容市',
  '321200': '江苏省泰州市',
  '321201': '江苏省泰州市市辖区',
  '321202': '江苏省泰州市海陵区',
  '321203': '江苏省泰州市高港区',
  '321281': '江苏省兴化市',
  '321282': '江苏省靖江市',
  '321283': '江苏省泰兴市',
  '321284': '江苏省姜堰市',
  '321300': '江苏省宿迁市',
  '321301': '江苏省宿迁市市辖区',
  '321302': '江苏省宿迁市宿城区',
  '321311': '江苏省宿迁市宿豫区',
  '321321': '江苏省宿豫县',
  '321322': '江苏省沭阳县',
  '321323': '江苏省泗阳县',
  '321324': '江苏省泗洪县',
  '322100': '江苏省徐州地区',
  '322121': '江苏省丰县',
  '322122': '江苏省沛县',
  '322123': '江苏省铜山县',
  '322124': '江苏省睢宁县',
  '322125': '江苏省邳县',
  '322126': '江苏省新沂县',
  '322127': '江苏省东海县',
  '322128': '江苏省赣榆县',
  '322200': '江苏省淮阴地区',
  '322201': '江苏省清江市',
  '322221': '江苏省淮阴县',
  '322222': '江苏省灌云县',
  '322223': '江苏省灌南县',
  '322224': '江苏省沭阳县',
  '322225': '江苏省宿迁县',
  '322226': '江苏省泗阳县',
  '322227': '江苏省涟水县',
  '322228': '江苏省泗洪县',
  '322229': '江苏省淮安县',
  '322230': '江苏省洪泽县',
  '322231': '江苏省盱眙县',
  '322232': '江苏省金湖县',
  '322300': '江苏省盐城地区',
  '322321': '江苏省响水县',
  '322322': '江苏省滨海县',
  '322323': '江苏省阜宁县',
  '322324': '江苏省射阳县',
  '322325': '江苏省建湖县',
  '322326': '江苏省盐城县',
  '322327': '江苏省大丰县',
  '322328': '江苏省东台县',
  '322400': '江苏省扬州地区',
  '322401': '江苏省扬州市',
  '322402': '江苏省泰州市',
  '322421': '江苏省兴化县',
  '322422': '江苏省高邮县',
  '322423': '江苏省宝应县',
  '322424': '江苏省靖江县',
  '322425': '江苏省泰兴县',
  '322426': '江苏省江都县',
  '322427': '江苏省邗江县',
  '322428': '江苏省泰县',
  '322429': '江苏省仪征县',
  '322500': '江苏省南通地区',
  '322521': '江苏省海安县',
  '322522': '江苏省如皋县',
  '322523': '江苏省如东县',
  '322524': '江苏省南通县',
  '322525': '江苏省海门县',
  '322526': '江苏省启东县',
  '322600': '江苏省镇江地区',
  '322601': '江苏省镇江市',
  '322621': '江苏省丹徒县',
  '322622': '江苏省武进县',
  '322623': '江苏省丹阳县',
  '322624': '江苏省句容县',
  '322625': '江苏省金坛县',
  '322626': '江苏省溧水县',
  '322627': '江苏省高淳县',
  '322628': '江苏省溧阳县',
  '322629': '江苏省宜兴县',
  '322630': '江苏省扬中县',
  '322700': '江苏省苏州地区',
  '322721': '江苏省江阴县',
  '322722': '江苏省无锡县',
  '322723': '江苏省沙洲县',
  '322724': '江苏省常熟县',
  '322725': '江苏省太仓县',
  '322726': '江苏省昆山县',
  '322727': '江苏省吴县',
  '322728': '江苏省吴江县',
  '329000': '江苏省省直辖行政单位',
  '329001': '江苏省泰州市',
  '329002': '江苏省仪征市',
  '329003': '江苏省常熟市',
  '329004': '江苏省张家港市',
  '329005': '江苏省江阴市',
  '329006': '江苏省宿迁市',
  '329007': '江苏省丹阳市',
  '329008': '江苏省东台市',
  '329009': '江苏省兴化市',
  '329010': '江苏省淮安市',
  '329011': '江苏省宜兴市',
  '330000': '浙江省',
  '330100': '浙江省杭州市',
  '330101': '浙江省杭州市市辖区',
  '330102': '浙江省杭州市上城区',
  '330103': '浙江省杭州市下城区',
  '330104': '浙江省杭州市江干区',
  '330105': '浙江省杭州市拱墅区',
  '330106': '浙江省杭州市西湖区',
  '330107': '浙江省杭州市半山区',
  '330108': '浙江省杭州市滨江区',
  '330109': '浙江省杭州市萧山区',
  '330110': '浙江省杭州市余杭区',
  '330120': '浙江省杭州市区',
  '330121': '浙江省萧山县',
  '330122': '浙江省桐庐县',
  '330123': '浙江省富阳县',
  '330124': '浙江省临安县',
  '330125': '浙江省余杭县',
  '330126': '浙江省建德县',
  '330127': '浙江省淳安县',
  '330181': '浙江省萧山市',
  '330182': '浙江省建德市',
  '330183': '浙江省富阳市',
  '330184': '浙江省余杭市',
  '330185': '浙江省临安市',
  '330200': '浙江省宁波市',
  '330201': '浙江省宁波市市辖区',
  '330202': '浙江省宁波市镇明区',
  '330203': '浙江省宁波市海曙区',
  '330204': '浙江省宁波市江东区',
  '330205': '浙江省宁波市江北区',
  '330206': '浙江省宁波市北仑区',
  '330211': '浙江省宁波市镇海区',
  '330212': '浙江省宁波市鄞州区',
  '330219': '浙江省余姚市',
  '330220': '浙江省宁波市区',
  '330221': '浙江省镇海县',
  '330222': '浙江省慈溪县',
  '330223': '浙江省余姚县',
  '330224': '浙江省奉化县',
  '330225': '浙江省象山县',
  '330226': '浙江省宁海县',
  '330227': '浙江省鄞县',
  '330281': '浙江省余姚市',
  '330282': '浙江省慈溪市',
  '330283': '浙江省奉化市',
  '330300': '浙江省温州市',
  '330301': '浙江省温州市市辖区',
  '330302': '浙江省温州市鹿城区',
  '330303': '浙江省温州市龙湾区',
  '330304': '浙江省温州市瓯海区',
  '330320': '浙江省温州市区',
  '330321': '浙江省瓯海县',
  '330322': '浙江省洞头县',
  '330323': '浙江省乐清县',
  '330324': '浙江省永嘉县',
  '330325': '浙江省瑞安县',
  '330326': '浙江省平阳县',
  '330327': '浙江省苍南县',
  '330328': '浙江省文成县',
  '330329': '浙江省泰顺县',
  '330381': '浙江省瑞安市',
  '330382': '浙江省乐清市',
  '330400': '浙江省嘉兴市',
  '330401': '浙江省嘉兴市市辖区',
  '330402': '浙江省嘉兴市秀城区',
  '330411': '浙江省嘉兴市秀洲区',
  '330421': '浙江省嘉善县',
  '330422': '浙江省平湖县',
  '330423': '浙江省海宁县',
  '330424': '浙江省海盐县',
  '330425': '浙江省桐乡县',
  '330481': '浙江省海宁市',
  '330482': '浙江省平湖市',
  '330483': '浙江省桐乡市',
  '330500': '浙江省湖州市',
  '330501': '浙江省湖州市市辖区',
  '330502': '浙江省湖州市城区',
  '330503': '浙江省湖州市南浔区',
  '330511': '浙江省湖州市郊区',
  '330521': '浙江省德清县',
  '330522': '浙江省长兴县',
  '330523': '浙江省安吉县',
  '330600': '浙江省绍兴市',
  '330601': '浙江省绍兴市市辖区',
  '330602': '浙江省绍兴市越城区',
  '330621': '浙江省绍兴县',
  '330622': '浙江省上虞县',
  '330623': '浙江省嵊县',
  '330624': '浙江省新昌县',
  '330625': '浙江省诸暨县',
  '330681': '浙江省诸暨市',
  '330682': '浙江省上虞市',
  '330683': '浙江省嵊州市',
  '330700': '浙江省金华市',
  '330701': '浙江省金华市市辖区',
  '330702': '浙江省金华市婺城区',
  '330703': '浙江省金华市金东区',
  '330719': '浙江省兰溪市',
  '330721': '浙江省金华县',
  '330722': '浙江省永康县',
  '330723': '浙江省武义县',
  '330724': '浙江省东阳县',
  '330725': '浙江省义乌县',
  '330726': '浙江省浦江县',
  '330727': '浙江省磐安县',
  '330781': '浙江省兰溪市',
  '330782': '浙江省义乌市',
  '330783': '浙江省东阳市',
  '330784': '浙江省永康市',
  '330800': '浙江省衢州市',
  '330801': '浙江省衢州市市辖区',
  '330802': '浙江省衢州市柯城区',
  '330803': '浙江省衢州市衢江区',
  '330821': '浙江省衢县',
  '330822': '浙江省常山县',
  '330823': '浙江省江山县',
  '330824': '浙江省开化县',
  '330825': '浙江省龙游县',
  '330881': '浙江省江山市',
  '330900': '浙江省舟山市',
  '330901': '浙江省舟山市市辖区',
  '330902': '浙江省舟山市定海区',
  '330903': '浙江省舟山市普陀区',
  '330921': '浙江省岱山县',
  '330922': '浙江省嵊泗县',
  '331000': '浙江省台州市',
  '331001': '浙江省台州市市辖区',
  '331002': '浙江省台州市椒江区',
  '331003': '浙江省台州市黄岩区',
  '331004': '浙江省台州市路桥区',
  '331021': '浙江省玉环县',
  '331022': '浙江省三门县',
  '331023': '浙江省天台县',
  '331024': '浙江省仙居县',
  '331081': '浙江省温岭市',
  '331082': '浙江省临海市',
  '331100': '浙江省丽水市',
  '331101': '浙江省丽水市市辖区',
  '331102': '浙江省丽水市莲都区',
  '331121': '浙江省青田县',
  '331122': '浙江省缙云县',
  '331123': '浙江省遂昌县',
  '331124': '浙江省松阳县',
  '331125': '浙江省云和县',
  '331126': '浙江省庆元县',
  '331127': '浙江省景宁畲族自治县',
  '331181': '浙江省龙泉市',
  '332100': '浙江省嘉兴地区',
  '332101': '浙江省湖州市',
  '332102': '浙江省嘉兴市',
  '332121': '浙江省嘉善县',
  '332122': '浙江省平湖县',
  '332123': '浙江省海宁县',
  '332124': '浙江省海盐县',
  '332125': '浙江省桐乡县',
  '332126': '浙江省德清县',
  '332127': '浙江省长兴县',
  '332128': '浙江省安吉县',
  '332200': '浙江省宁波地区',
  '332221': '浙江省慈溪县',
  '332222': '浙江省余姚县',
  '332223': '浙江省奉化县',
  '332224': '浙江省象山县',
  '332225': '浙江省宁海县',
  '332226': '浙江省鄞县',
  '332300': '浙江省绍兴地区',
  '332301': '浙江省绍兴市',
  '332321': '浙江省上虞县',
  '332322': '浙江省嵊县',
  '332323': '浙江省新昌县',
  '332324': '浙江省诸暨县',
  '332400': '浙江省金华地区',
  '332401': '浙江省金华市',
  '332402': '浙江省衢州市',
  '332421': '浙江省兰溪县',
  '332422': '浙江省永康县',
  '332423': '浙江省武义县',
  '332424': '浙江省东阳县',
  '332425': '浙江省义乌县',
  '332426': '浙江省浦江县',
  '332427': '浙江省常山县',
  '332428': '浙江省江山县',
  '332429': '浙江省开化县',
  '332430': '浙江省龙游县',
  '332431': '浙江省磐安县',
  '332500': '浙江省丽水地区',
  '332501': '浙江省丽水市',
  '332502': '浙江省龙泉市',
  '332521': '浙江省丽水县',
  '332522': '浙江省青田县',
  '332523': '浙江省云和县',
  '332524': '浙江省龙泉县',
  '332525': '浙江省庆元县',
  '332526': '浙江省缙云县',
  '332527': '浙江省遂昌县',
  '332528': '浙江省松阳县',
  '332529': '浙江省景宁畲族自治县',
  '332600': '浙江省台州地区',
  '332601': '浙江省椒江市',
  '332602': '浙江省临海市',
  '332603': '浙江省黄岩市',
  '332621': '浙江省临海县',
  '332622': '浙江省黄岩县',
  '332623': '浙江省温岭县',
  '332624': '浙江省仙居县',
  '332625': '浙江省天台县',
  '332626': '浙江省三门县',
  '332627': '浙江省玉环县',
  '332700': '浙江省舟山地区',
  '332721': '浙江省定海县',
  '332722': '浙江省普陀县',
  '332723': '浙江省岱山县',
  '332724': '浙江省嵊泗县',
  '339000': '浙江省省直辖行政单位',
  '339001': '浙江省余姚市',
  '339002': '浙江省海宁市',
  '339003': '浙江省兰溪市',
  '339004': '浙江省瑞安市',
  '339005': '浙江省萧山市',
  '339006': '浙江省江山市',
  '339007': '浙江省义乌市',
  '339008': '浙江省东阳市',
  '339009': '浙江省慈溪市',
  '339010': '浙江省奉化市',
  '340000': '安徽省',
  '340100': '安徽省合肥市',
  '340101': '安徽省合肥市市辖区',
  '340102': '安徽省合肥市瑶海区',
  '340103': '安徽省合肥市庐阳区',
  '340104': '安徽省合肥市蜀山区',
  '340111': '安徽省合肥市包河区',
  '340120': '安徽省合肥市区',
  '340121': '安徽省长丰县',
  '340122': '安徽省肥东县',
  '340123': '安徽省肥西县',
  '340200': '安徽省芜湖市',
  '340201': '安徽省芜湖市市辖区',
  '340202': '安徽省芜湖市镜湖区',
  '340203': '安徽省芜湖市马塘区',
  '340204': '安徽省芜湖市新芜区',
  '340207': '安徽省芜湖市鸠江区',
  '340211': '安徽省芜湖市郊区',
  '340220': '安徽省芜湖市区',
  '340221': '安徽省芜湖县',
  '340222': '安徽省繁昌县',
  '340223': '安徽省南陵县',
  '340224': '安徽省青阳县',
  '340300': '安徽省蚌埠市',
  '340301': '安徽省蚌埠市市辖区',
  '340302': '安徽省蚌埠市龙子湖区',
  '340303': '安徽省蚌埠市蚌山区',
  '340304': '安徽省蚌埠市禹会区',
  '340311': '安徽省蚌埠市淮上区',
  '340321': '安徽省怀远县',
  '340322': '安徽省五河县',
  '340323': '安徽省固镇县',
  '340400': '安徽省淮南市',
  '340401': '安徽省淮南市市辖区',
  '340402': '安徽省淮南市大通区',
  '340403': '安徽省淮南市田家庵区',
  '340404': '安徽省淮南市谢家集区',
  '340405': '安徽省淮南市八公山区',
  '340406': '安徽省淮南市潘集区',
  '340420': '安徽省淮南市区',
  '340421': '安徽省凤台县',
  '340500': '安徽省马鞍山市',
  '340501': '安徽省马鞍山市市辖区',
  '340502': '安徽省马鞍山市金家庄区',
  '340503': '安徽省马鞍山市花山区',
  '340504': '安徽省马鞍山市雨山区',
  '340505': '安徽省马鞍山市向山区',
  '340511': '安徽省马鞍山市郊区',
  '340521': '安徽省当涂县',
  '340600': '安徽省淮北市',
  '340601': '安徽省淮北市市辖区',
  '340602': '安徽省淮北市杜集区',
  '340603': '安徽省淮北市相山区',
  '340604': '安徽省淮北市烈山区',
  '340611': '安徽省淮北市郊区',
  '340620': '安徽省淮北市区',
  '340621': '安徽省濉溪县',
  '340700': '安徽省铜陵市',
  '340701': '安徽省铜陵市市辖区',
  '340702': '安徽省铜陵市铜官山区',
  '340703': '安徽省铜陵市狮子山区',
  '340704': '安徽省铜陵市铜山区',
  '340711': '安徽省铜陵市郊区',
  '340720': '安徽省铜陵市区',
  '340721': '安徽省铜陵县',
  '340800': '安徽省安庆市',
  '340801': '安徽省安庆市市辖区',
  '340802': '安徽省安庆市迎江区',
  '340803': '安徽省安庆市大观区',
  '340811': '安徽省安庆市郊区',
  '340821': '安徽省桐城县',
  '340822': '安徽省怀宁县',
  '340823': '安徽省枞阳县',
  '340824': '安徽省潜山县',
  '340825': '安徽省太湖县',
  '340826': '安徽省宿松县',
  '340827': '安徽省望江县',
  '340828': '安徽省岳西县',
  '340881': '安徽省桐城市',
  '340900': '安徽省省直辖行政单位',
  '340901': '安徽省黄山市',
  '341000': '安徽省黄山市',
  '341001': '安徽省黄山市市辖区',
  '341002': '安徽省黄山市屯溪区',
  '341003': '安徽省黄山市黄山区',
  '341004': '安徽省黄山市徽州区',
  '341021': '安徽省歙县',
  '341022': '安徽省休宁县',
  '341023': '安徽省黟县',
  '341024': '安徽省祁门县',
  '341100': '安徽省滁州市',
  '341101': '安徽省滁州市市辖区',
  '341102': '安徽省滁州市琅琊区',
  '341103': '安徽省滁州市南谯区',
  '341122': '安徽省来安县',
  '341124': '安徽省全椒县',
  '341125': '安徽省定远县',
  '341126': '安徽省凤阳县',
  '341127': '安徽省嘉山县',
  '341181': '安徽省天长市',
  '341182': '安徽省明光市',
  '341200': '安徽省阜阳市',
  '341201': '安徽省阜阳市市辖区',
  '341202': '安徽省阜阳市颍州区',
  '341203': '安徽省阜阳市颍东区',
  '341204': '安徽省阜阳市颍泉区',
  '341221': '安徽省临泉县',
  '341222': '安徽省太和县',
  '341223': '安徽省涡阳县',
  '341224': '安徽省蒙城县',
  '341225': '安徽省阜南县',
  '341226': '安徽省颍上县',
  '341227': '安徽省利辛县',
  '341281': '安徽省亳州市',
  '341282': '安徽省界首市',
  '341300': '安徽省宿州市',
  '341301': '安徽省宿州市市辖区',
  '341302': '安徽省宿州市墉桥区',
  '341321': '安徽省砀山县',
  '341322': '安徽省萧县',
  '341323': '安徽省灵璧县',
  '341324': '安徽省泗县',
  '341400': '安徽省巢湖市',
  '341401': '安徽省巢湖市市辖区',
  '341402': '安徽省巢湖市居巢区',
  '341421': '安徽省庐江县',
  '341422': '安徽省无为县',
  '341423': '安徽省含山县',
  '341424': '安徽省和县',
  '341500': '安徽省六安市',
  '341501': '安徽省六安市市辖区',
  '341502': '安徽省六安市金安区',
  '341503': '安徽省六安市裕安区',
  '341521': '安徽省寿县',
  '341522': '安徽省霍邱县',
  '341523': '安徽省舒城县',
  '341524': '安徽省金寨县',
  '341525': '安徽省霍山县',
  '341600': '安徽省亳州市',
  '341601': '安徽省亳州市市辖区',
  '341602': '安徽省亳州市谯城区',
  '341621': '安徽省涡阳县',
  '341622': '安徽省蒙城县',
  '341623': '安徽省利辛县',
  '341700': '安徽省池州市',
  '341701': '安徽省池州市市辖区',
  '341702': '安徽省池州市贵池区',
  '341721': '安徽省东至县',
  '341722': '安徽省石台县',
  '341723': '安徽省青阳县',
  '341800': '安徽省宣城市',
  '341801': '安徽省宣城市市辖区',
  '341802': '安徽省宣城市宣州区',
  '341821': '安徽省郎溪县',
  '341822': '安徽省广德县',
  '341823': '安徽省泾县',
  '341824': '安徽省绩溪县',
  '341825': '安徽省旌德县',
  '341881': '安徽省宁国市',
  '342100': '安徽省阜阳地区',
  '342101': '安徽省阜阳市',
  '342102': '安徽省亳州市',
  '342103': '安徽省界首市',
  '342121': '安徽省阜阳县',
  '342122': '安徽省临泉县',
  '342123': '安徽省太和县',
  '342124': '安徽省涡阳县',
  '342125': '安徽省蒙城县',
  '342126': '安徽省亳县',
  '342127': '安徽省阜南县',
  '342128': '安徽省颍上县',
  '342129': '安徽省界首县',
  '342130': '安徽省利辛县',
  '342200': '安徽省宿县地区',
  '342201': '安徽省宿州市',
  '342221': '安徽省砀山县',
  '342222': '安徽省萧县',
  '342223': '安徽省宿县',
  '342224': '安徽省灵壁县',
  '342225': '安徽省泗县',
  '342226': '安徽省怀远县',
  '342227': '安徽省五河县',
  '342228': '安徽省固镇县',
  '342300': '安徽省滁县地区',
  '342301': '安徽省滁州市',
  '342321': '安徽省天长县',
  '342322': '安徽省来安县',
  '342323': '安徽省滁县',
  '342324': '安徽省全椒县',
  '342325': '安徽省定远县',
  '342326': '安徽省凤阳县',
  '342327': '安徽省嘉山县',
  '342400': '安徽省六安地区',
  '342401': '安徽省六安市',
  '342421': '安徽省六安县',
  '342422': '安徽省寿县',
  '342423': '安徽省霍邱县',
  '342424': '安徽省肥西县',
  '342425': '安徽省舒城县',
  '342426': '安徽省金寨县',
  '342427': '安徽省霍山县',
  '342500': '安徽省宣城地区',
  '342501': '安徽省宣州市',
  '342502': '安徽省宁国市',
  '342521': '安徽省宣城县',
  '342522': '安徽省郎溪县',
  '342523': '安徽省广德县',
  '342524': '安徽省宁国县',
  '342525': '安徽省当涂县',
  '342526': '安徽省繁昌县',
  '342527': '安徽省南陵县',
  '342528': '安徽省青阳县',
  '342529': '安徽省泾县',
  '342530': '安徽省旌德县',
  '342531': '安徽省绩溪县',
  '342600': '安徽省巢湖地区',
  '342601': '安徽省巢湖市',
  '342621': '安徽省肥东县',
  '342622': '安徽省庐江县',
  '342623': '安徽省无为县',
  '342624': '安徽省巢县',
  '342625': '安徽省含山县',
  '342626': '安徽省和县',
  '342700': '安徽省徽州地区',
  '342701': '安徽省屯溪市',
  '342721': '安徽省绩溪县',
  '342722': '安徽省旌德县',
  '342723': '安徽省歙县',
  '342724': '安徽省休宁县',
  '342725': '安徽省黟县',
  '342726': '安徽省祁门县',
  '342727': '安徽省太平县',
  '342728': '安徽省石台县',
  '342800': '安徽省安庆地区',
  '342821': '安徽省怀宁县',
  '342822': '安徽省桐城县',
  '342823': '安徽省枞阳县',
  '342824': '安徽省潜山县',
  '342825': '安徽省太湖县',
  '342826': '安徽省宿松县',
  '342827': '安徽省望江县',
  '342828': '安徽省岳西县',
  '342829': '安徽省东至县',
  '342830': '安徽省贵池县',
  '342900': '安徽省池州地区',
  '342901': '安徽省贵池市',
  '342921': '安徽省东至县',
  '342922': '安徽省石台县',
  '342923': '安徽省青阳县',
  '350000': '福建省',
  '350100': '福建省福州市',
  '350101': '福建省福州市市辖区',
  '350102': '福建省福州市鼓楼区',
  '350103': '福建省福州市台江区',
  '350104': '福建省福州市仓山区',
  '350105': '福建省福州市马尾区',
  '350111': '福建省福州市晋安区',
  '350120': '福建省福州市区',
  '350121': '福建省闽侯县',
  '350122': '福建省连江县',
  '350123': '福建省罗源县',
  '350124': '福建省闽清县',
  '350125': '福建省永泰县',
  '350126': '福建省长乐县',
  '350127': '福建省福清县',
  '350128': '福建省平潭县',
  '350181': '福建省福清市',
  '350182': '福建省长乐市',
  '350200': '福建省厦门市',
  '350201': '福建省厦门市市辖区',
  '350202': '福建省厦门市鼓浪屿区',
  '350203': '福建省厦门市思明区',
  '350204': '福建省厦门市开元区',
  '350205': '福建省厦门市海沧区',
  '350206': '福建省厦门市湖里区',
  '350211': '福建省厦门市集美区',
  '350212': '福建省厦门市同安区',
  '350213': '福建省厦门市翔安区',
  '350220': '福建省厦门市区',
  '350221': '福建省同安县',
  '350300': '福建省莆田市',
  '350301': '福建省莆田市市辖区',
  '350302': '福建省莆田市城厢区',
  '350303': '福建省莆田市涵江区',
  '350304': '福建省莆田市荔城区',
  '350305': '福建省莆田市秀屿区',
  '350321': '福建省莆田县',
  '350322': '福建省仙游县',
  '350400': '福建省三明市',
  '350401': '福建省三明市市辖区',
  '350402': '福建省三明市梅列区',
  '350403': '福建省三明市三元区',
  '350420': '福建省永安市',
  '350421': '福建省明溪县',
  '350422': '福建省永安县',
  '350423': '福建省清流县',
  '350424': '福建省宁化县',
  '350425': '福建省大田县',
  '350426': '福建省尤溪县',
  '350427': '福建省沙县',
  '350428': '福建省将乐县',
  '350429': '福建省泰宁县',
  '350430': '福建省建宁县',
  '350481': '福建省永安市',
  '350500': '福建省泉州市',
  '350501': '福建省泉州市市辖区',
  '350502': '福建省泉州市鲤城区',
  '350503': '福建省泉州市丰泽区',
  '350504': '福建省泉州市洛江区',
  '350505': '福建省泉州市泉港区',
  '350521': '福建省惠安县',
  '350522': '福建省晋江县',
  '350523': '福建省南安县',
  '350524': '福建省安溪县',
  '350525': '福建省永春县',
  '350526': '福建省德化县',
  '350527': '福建省金门县',
  '350581': '福建省石狮市',
  '350582': '福建省晋江市',
  '350583': '福建省南安市',
  '350600': '福建省漳州市',
  '350601': '福建省漳州市市辖区',
  '350602': '福建省漳州市芗城区',
  '350603': '福建省漳州市龙文区',
  '350619': '福建省漳州市漳州开发区',
  '350621': '福建省龙海县',
  '350622': '福建省云霄县',
  '350623': '福建省漳浦县',
  '350624': '福建省诏安县',
  '350625': '福建省长泰县',
  '350626': '福建省东山县',
  '350627': '福建省南靖县',
  '350628': '福建省平和县',
  '350629': '福建省华安县',
  '350681': '福建省龙海市',
  '350700': '福建省南平市',
  '350701': '福建省南平市市辖区',
  '350702': '福建省南平市延平区',
  '350721': '福建省顺昌县',
  '350722': '福建省浦城县',
  '350723': '福建省光泽县',
  '350724': '福建省松溪县',
  '350725': '福建省政和县',
  '350781': '福建省邵武市',
  '350782': '福建省武夷山市',
  '350783': '福建省建瓯市',
  '350784': '福建省建阳市',
  '350800': '福建省龙岩市',
  '350801': '福建省龙岩市市辖区',
  '350802': '福建省龙岩市新罗区',
  '350821': '福建省长汀县',
  '350822': '福建省永定县',
  '350823': '福建省上杭县',
  '350824': '福建省武平县',
  '350825': '福建省连城县',
  '350881': '福建省漳平市',
  '350900': '福建省宁德市',
  '350901': '福建省宁德市市辖区',
  '350902': '福建省宁德市蕉城区',
  '350909': '福建省宁德市闽东华侨经济开发区',
  '350921': '福建省霞浦县',
  '350922': '福建省古田县',
  '350923': '福建省屏南县',
  '350924': '福建省寿宁县',
  '350925': '福建省周宁县',
  '350926': '福建省柘荣县',
  '350981': '福建省福安市',
  '350982': '福建省福鼎市',
  '352100': '福建省南平地区',
  '352101': '福建省南平市',
  '352102': '福建省邵武市',
  '352103': '福建省武夷山市',
  '352104': '福建省建瓯市',
  '352121': '福建省顺昌县',
  '352122': '福建省建阳县',
  '352123': '福建省建瓯县',
  '352124': '福建省浦城县',
  '352125': '福建省邵武县',
  '352126': '福建省崇安县',
  '352127': '福建省光泽县',
  '352128': '福建省松溪县',
  '352129': '福建省政和县',
  '352200': '福建省宁德地区',
  '352201': '福建省宁德市',
  '352202': '福建省福安市',
  '352203': '福建省福鼎市',
  '352221': '福建省宁德县',
  '352222': '福建省连江县',
  '352223': '福建省罗源县',
  '352224': '福建省福鼎县',
  '352225': '福建省霞浦县',
  '352226': '福建省福安县',
  '352227': '福建省古田县',
  '352228': '福建省屏南县',
  '352229': '福建省寿宁县',
  '352230': '福建省周宁县',
  '352231': '福建省柘荣县',
  '352300': '福建省莆田地区',
  '352321': '福建省闽清县',
  '352322': '福建省永泰县',
  '352323': '福建省长乐县',
  '352324': '福建省福清市',
  '352325': '福建省平潭县',
  '352326': '福建省莆田县',
  '352327': '福建省仙游县',
  '352400': '福建省晋江地区',
  '352401': '福建省泉州市',
  '352421': '福建省惠安县',
  '352422': '福建省晋江县',
  '352423': '福建省南安县',
  '352424': '福建省安溪县',
  '352425': '福建省永春县',
  '352426': '福建省德化县',
  '352427': '福建省金门县',
  '352500': '福建省龙溪地区',
  '352501': '福建省漳州市',
  '352521': '福建省龙海县',
  '352522': '福建省云霄县',
  '352523': '福建省漳浦县',
  '352524': '福建省诏安县',
  '352525': '福建省长泰县',
  '352526': '福建省东山县',
  '352527': '福建省南靖县',
  '352528': '福建省平和县',
  '352529': '福建省华安县',
  '352600': '福建省龙岩地区',
  '352601': '福建省龙岩市',
  '352602': '福建省漳平市',
  '352622': '福建省长汀县',
  '352623': '福建省永定县',
  '352624': '福建省上杭县',
  '352625': '福建省武平县',
  '352626': '福建省漳平县',
  '352627': '福建省连城县',
  '352700': '福建省三明地区',
  '352701': '福建省三明市',
  '352721': '福建省明溪县',
  '352722': '福建省永安县',
  '352723': '福建省清流县',
  '352724': '福建省宁化县',
  '352725': '福建省大田县',
  '352726': '福建省尤溪县',
  '352727': '福建省沙县',
  '352728': '福建省将乐县',
  '352729': '福建省泰宁县',
  '352730': '福建省建宁县',
  '359000': '福建省省直辖行政单位',
  '359001': '福建省永安市',
  '359002': '福建省石狮市',
  '360000': '江西省',
  '360100': '江西省南昌市',
  '360101': '江西省南昌市市辖区',
  '360102': '江西省南昌市东湖区',
  '360103': '江西省南昌市西湖区',
  '360104': '江西省南昌市青云谱区',
  '360105': '江西省南昌市湾里区',
  '360111': '江西省南昌市青山湖区',
  '360120': '江西省南昌市区',
  '360121': '江西省南昌县',
  '360122': '江西省新建县',
  '360123': '江西省安义县',
  '360124': '江西省进贤县',
  '360200': '江西省景德镇市',
  '360201': '江西省景德镇市市辖区',
  '360202': '江西省景德镇市昌江区',
  '360203': '江西省景德镇市珠山区',
  '360211': '江西省景德镇市鹅湖区',
  '360212': '江西省景德镇市蛟潭区',
  '360221': '江西省乐平县',
  '360222': '江西省浮梁县',
  '360281': '江西省乐平市',
  '360300': '江西省萍乡市',
  '360301': '江西省萍乡市市辖区',
  '360302': '江西省萍乡市安源区',
  '360311': '江西省萍乡市上栗区',
  '360312': '江西省萍乡市芦溪区',
  '360313': '江西省萍乡市湘东区',
  '360321': '江西省莲花县',
  '360322': '江西省上栗县',
  '360323': '江西省芦溪县',
  '360400': '江西省九江市',
  '360401': '江西省九江市市辖区',
  '360402': '江西省九江市庐山区',
  '360403': '江西省九江市浔阳区',
  '360411': '江西省九江市郊区',
  '360421': '江西省九江县',
  '360422': '江西省瑞昌县',
  '360423': '江西省武宁县',
  '360424': '江西省修水县',
  '360425': '江西省永修县',
  '360426': '江西省德安县',
  '360427': '江西省星子县',
  '360428': '江西省都昌县',
  '360429': '江西省湖口县',
  '360430': '江西省彭泽县',
  '360481': '江西省瑞昌市',
  '360500': '江西省新余市',
  '360501': '江西省新余市市辖区',
  '360502': '江西省新余市渝水区',
  '360521': '江西省分宜县',
  '360600': '江西省鹰潭市',
  '360601': '江西省鹰潭市市辖区',
  '360602': '江西省鹰潭市月湖区',
  '360621': '江西省贵溪县',
  '360622': '江西省余江县',
  '360681': '江西省贵溪市',
  '360700': '江西省赣州市',
  '360701': '江西省赣州市市辖区',
  '360702': '江西省赣州市章贡区',
  '360721': '江西省赣县',
  '360722': '江西省信丰县',
  '360723': '江西省大余县',
  '360724': '江西省上犹县',
  '360725': '江西省崇义县',
  '360726': '江西省安远县',
  '360727': '江西省龙南县',
  '360728': '江西省定南县',
  '360729': '江西省全南县',
  '360730': '江西省宁都县',
  '360731': '江西省于都县',
  '360732': '江西省兴国县',
  '360733': '江西省会昌县',
  '360734': '江西省寻乌县',
  '360735': '江西省石城县',
  '360781': '江西省瑞金市',
  '360782': '江西省南康市',
  '360800': '江西省吉安市',
  '360801': '江西省吉安市市辖区',
  '360802': '江西省吉安市吉州区',
  '360803': '江西省吉安市青原区',
  '360821': '江西省吉安县',
  '360822': '江西省吉水县',
  '360823': '江西省峡江县',
  '360824': '江西省新干县',
  '360825': '江西省永丰县',
  '360826': '江西省泰和县',
  '360827': '江西省遂川县',
  '360828': '江西省万安县',
  '360829': '江西省安福县',
  '360830': '江西省永新县',
  '360881': '江西省井冈山市',
  '360900': '江西省宜春市',
  '360901': '江西省宜春市市辖区',
  '360902': '江西省宜春市袁州区',
  '360921': '江西省奉新县',
  '360922': '江西省万载县',
  '360923': '江西省上高县',
  '360924': '江西省宜丰县',
  '360925': '江西省靖安县',
  '360926': '江西省铜鼓县',
  '360981': '江西省丰城市',
  '360982': '江西省樟树市',
  '360983': '江西省高安市',
  '361000': '江西省抚州市',
  '361001': '江西省抚州市市辖区',
  '361002': '江西省抚州市临川区',
  '361021': '江西省南城县',
  '361022': '江西省黎川县',
  '361023': '江西省南丰县',
  '361024': '江西省崇仁县',
  '361025': '江西省乐安县',
  '361026': '江西省宜黄县',
  '361027': '江西省金溪县',
  '361028': '江西省资溪县',
  '361029': '江西省东乡县',
  '361030': '江西省广昌县',
  '361100': '江西省上饶市',
  '361101': '江西省上饶市市辖区',
  '361102': '江西省上饶市信州区',
  '361121': '江西省上饶县',
  '361122': '江西省广丰县',
  '361123': '江西省玉山县',
  '361124': '江西省铅山县',
  '361125': '江西省横峰县',
  '361126': '江西省弋阳县',
  '361127': '江西省余干县',
  '361128': '江西省鄱阳县',
  '361129': '江西省万年县',
  '361130': '江西省婺源县',
  '361181': '江西省德兴市',
  '362100': '江西省赣州地区',
  '362101': '江西省赣州市',
  '362102': '江西省瑞金市',
  '362103': '江西省南康市',
  '362121': '江西省赣县',
  '362122': '江西省南康县',
  '362123': '江西省信丰县',
  '362124': '江西省大余县',
  '362125': '江西省上犹县',
  '362126': '江西省崇义县',
  '362127': '江西省安远县',
  '362128': '江西省龙南县',
  '362129': '江西省定南县',
  '362130': '江西省全南县',
  '362131': '江西省宁都县',
  '362132': '江西省于都县',
  '362133': '江西省兴国县',
  '362134': '江西省瑞金县',
  '362135': '江西省会昌县',
  '362136': '江西省寻乌县',
  '362137': '江西省石城县',
  '362138': '江西省广昌县',
  '362200': '江西省宜春地区',
  '362201': '江西省宜春市',
  '362202': '江西省丰城市',
  '362203': '江西省樟树市',
  '362204': '江西省高安市',
  '362221': '江西省丰城县',
  '362222': '江西省高安县',
  '362223': '江西省清江县',
  '362224': '江西省新余县',
  '362225': '江西省宜春县',
  '362226': '江西省奉新县',
  '362227': '江西省万载县',
  '362228': '江西省上高县',
  '362229': '江西省宜丰县',
  '362230': '江西省分宜县',
  '362231': '江西省安义县',
  '362232': '江西省靖安县',
  '362233': '江西省铜鼓县',
  '362300': '江西省上饶地区',
  '362301': '江西省上饶市',
  '362302': '江西省德兴市',
  '362321': '江西省上饶县',
  '362322': '江西省广丰县',
  '362323': '江西省玉山县',
  '362324': '江西省铅山县',
  '362325': '江西省横峰县',
  '362326': '江西省弋阳县',
  '362327': '江西省贵溪县',
  '362328': '江西省余江县',
  '362329': '江西省余干县',
  '362330': '江西省波阳县',
  '362331': '江西省万年县',
  '362332': '江西省乐平县',
  '362333': '江西省德兴县',
  '362334': '江西省婺源县',
  '362400': '江西省吉安地区',
  '362401': '江西省吉安市',
  '362402': '江西省井冈山市',
  '362421': '江西省吉安县',
  '362422': '江西省吉水县',
  '362423': '江西省峡江县',
  '362424': '江西省新干县',
  '362425': '江西省永丰县',
  '362426': '江西省泰和县',
  '362427': '江西省遂川县',
  '362428': '江西省万安县',
  '362429': '江西省安福县',
  '362430': '江西省永新县',
  '362431': '江西省莲花县',
  '362432': '江西省宁冈县',
  '362433': '江西省井冈山县',
  '362500': '江西省抚州地区',
  '362501': '江西省抚州市',
  '362502': '江西省临川市',
  '362521': '江西省临川县',
  '362522': '江西省南城县',
  '362523': '江西省黎川县',
  '362524': '江西省南丰县',
  '362525': '江西省崇仁县',
  '362526': '江西省乐安县',
  '362527': '江西省宜黄县',
  '362528': '江西省金溪县',
  '362529': '江西省资溪县',
  '362530': '江西省进贤县',
  '362531': '江西省东乡县',
  '362532': '江西省广昌县',
  '362600': '江西省九江地区',
  '362621': '江西省九江县',
  '362622': '江西省瑞昌县',
  '362623': '江西省武宁县',
  '362624': '江西省修水县',
  '362625': '江西省永修县',
  '362626': '江西省德安县',
  '362627': '江西省星子县',
  '362628': '江西省都昌县',
  '362629': '江西省湖口县',
  '362630': '江西省彭泽县',
  '370000': '山东省',
  '370100': '山东省济南市',
  '370101': '山东省济南市市辖区',
  '370102': '山东省济南市历下区',
  '370103': '山东省济南市市中区',
  '370104': '山东省济南市槐荫区',
  '370105': '山东省济南市天桥区',
  '370111': '山东省济南市郊区',
  '370112': '山东省济南市历城区',
  '370113': '山东省济南市长清区',
  '370120': '山东省济南市区',
  '370121': '山东省历城县',
  '370122': '山东省章丘县',
  '370123': '山东省长清县',
  '370124': '山东省平阴县',
  '370125': '山东省济阳县',
  '370126': '山东省商河县',
  '370181': '山东省章丘市',
  '370200': '山东省青岛市',
  '370201': '山东省青岛市市辖区',
  '370202': '山东省青岛市市南区',
  '370203': '山东省青岛市市北区',
  '370204': '山东省青岛市台东区',
  '370205': '山东省青岛市四方区',
  '370206': '山东省青岛市沧口区',
  '370211': '山东省青岛市黄岛区',
  '370212': '山东省青岛市崂山区',
  '370213': '山东省青岛市李沧区',
  '370214': '山东省青岛市城阳区',
  '370220': '山东省青岛市区',
  '370221': '山东省崂山县',
  '370222': '山东省即墨县',
  '370223': '山东省胶南县',
  '370224': '山东省胶县',
  '370225': '山东省莱西县',
  '370226': '山东省平度县',
  '370281': '山东省胶州市',
  '370282': '山东省即墨市',
  '370283': '山东省平度市',
  '370284': '山东省胶南市',
  '370285': '山东省莱西市',
  '370300': '山东省淄博市',
  '370301': '山东省淄博市市辖区',
  '370302': '山东省淄博市淄川区',
  '370303': '山东省淄博市张店区',
  '370304': '山东省淄博市博山区',
  '370305': '山东省淄博市临淄区',
  '370306': '山东省淄博市周村区',
  '370321': '山东省桓台县',
  '370322': '山东省高青县',
  '370323': '山东省沂源县',
  '370400': '山东省枣庄市',
  '370401': '山东省枣庄市市辖区',
  '370402': '山东省枣庄市市中区',
  '370403': '山东省枣庄市薛城区',
  '370404': '山东省枣庄市峄城区',
  '370405': '山东省枣庄市台儿庄区',
  '370406': '山东省枣庄市山亭区',
  '370420': '山东省枣庄市区',
  '370421': '山东省滕县',
  '370481': '山东省滕州市',
  '370500': '山东省东营市',
  '370501': '山东省东营市市辖区',
  '370502': '山东省东营市东营区',
  '370503': '山东省东营市河口区',
  '370504': '山东省东营市牛庄区',
  '370521': '山东省垦利县',
  '370522': '山东省利津县',
  '370523': '山东省广饶县',
  '370600': '山东省烟台市',
  '370601': '山东省烟台市市辖区',
  '370602': '山东省烟台市芝罘区',
  '370611': '山东省烟台市福山区',
  '370612': '山东省烟台市牟平区',
  '370613': '山东省烟台市莱山区',
  '370620': '山东省威海市',
  '370622': '山东省蓬莱县',
  '370623': '山东省黄县',
  '370624': '山东省招远县',
  '370625': '山东省掖县',
  '370627': '山东省莱阳县',
  '370628': '山东省栖霞县',
  '370629': '山东省海阳县',
  '370630': '山东省乳山县',
  '370631': '山东省牟平县',
  '370632': '山东省文登县',
  '370633': '山东省荣城县',
  '370634': '山东省长岛县',
  '370681': '山东省龙口市',
  '370682': '山东省莱阳市',
  '370683': '山东省莱州市',
  '370684': '山东省蓬莱市',
  '370685': '山东省招远市',
  '370686': '山东省栖霞市',
  '370687': '山东省海阳市',
  '370700': '山东省潍坊市',
  '370701': '山东省潍坊市市辖区',
  '370702': '山东省潍坊市潍城区',
  '370703': '山东省潍坊市寒亭区',
  '370704': '山东省潍坊市坊子区',
  '370705': '山东省潍坊市奎文区',
  '370719': '山东省青州市',
  '370721': '山东省益都县',
  '370722': '山东省安丘县',
  '370723': '山东省寿光县',
  '370724': '山东省临朐县',
  '370725': '山东省昌乐县',
  '370726': '山东省昌邑县',
  '370727': '山东省高密县',
  '370728': '山东省诸城县',
  '370729': '山东省五莲县',
  '370781': '山东省青州市',
  '370782': '山东省诸城市',
  '370783': '山东省寿光市',
  '370784': '山东省安丘市',
  '370785': '山东省高密市',
  '370786': '山东省昌邑市',
  '370800': '山东省济宁市',
  '370801': '山东省济宁市市辖区',
  '370802': '山东省济宁市市中区',
  '370811': '山东省济宁市任城区',
  '370819': '山东省济宁市曲阜市',
  '370822': '山东省兖州县',
  '370823': '山东省曲阜县',
  '370825': '山东省邹县',
  '370826': '山东省微山县',
  '370827': '山东省鱼台县',
  '370828': '山东省金乡县',
  '370829': '山东省嘉祥县',
  '370830': '山东省汶上县',
  '370831': '山东省泗水县',
  '370832': '山东省梁山县',
  '370881': '山东省曲阜市',
  '370882': '山东省兖州市',
  '370883': '山东省邹城市',
  '370900': '山东省泰安市',
  '370901': '山东省泰安市市辖区',
  '370902': '山东省泰安市泰山区',
  '370903': '山东省泰安市岱岳区',
  '370911': '山东省泰安市郊区',
  '370919': '山东省莱芜市',
  '370920': '山东省新泰市',
  '370921': '山东省宁阳县',
  '370922': '山东省肥城县',
  '370923': '山东省东平县',
  '370981': '山东省莱芜市',
  '370982': '山东省新泰市',
  '370983': '山东省肥城市',
  '371000': '山东省威海市',
  '371001': '山东省威海市市辖区',
  '371002': '山东省威海市环翠区',
  '371021': '山东省乳山县',
  '371081': '山东省文登市',
  '371082': '山东省荣成市',
  '371083': '山东省乳山市',
  '371100': '山东省日照市',
  '371101': '山东省日照市市辖区',
  '371102': '山东省日照市东港区',
  '371103': '山东省日照市岚山区',
  '371121': '山东省五莲县',
  '371122': '山东省莒县',
  '371200': '山东省莱芜市',
  '371201': '山东省莱芜市市辖区',
  '371202': '山东省莱芜市莱城区',
  '371203': '山东省莱芜市钢城区',
  '371300': '山东省临沂市',
  '371301': '山东省临沂市市辖区',
  '371302': '山东省临沂市兰山区',
  '371311': '山东省临沂市罗庄区',
  '371312': '山东省临沂市河东区',
  '371321': '山东省沂南县',
  '371322': '山东省郯城县',
  '371323': '山东省沂水县',
  '371324': '山东省苍山县',
  '371325': '山东省费县',
  '371326': '山东省平邑县',
  '371327': '山东省莒南县',
  '371328': '山东省蒙阴县',
  '371329': '山东省临沭县',
  '371400': '山东省德州市',
  '371401': '山东省德州市市辖区',
  '371402': '山东省德州市德城区',
  '371421': '山东省陵县',
  '371422': '山东省宁津县',
  '371423': '山东省庆云县',
  '371424': '山东省临邑县',
  '371425': '山东省齐河县',
  '371426': '山东省平原县',
  '371427': '山东省夏津县',
  '371428': '山东省武城县',
  '371481': '山东省乐陵市',
  '371482': '山东省禹城市',
  '371500': '山东省聊城市',
  '371501': '山东省聊城市市辖区',
  '371502': '山东省聊城市东昌府区',
  '371521': '山东省阳谷县',
  '371522': '山东省莘县',
  '371523': '山东省茌平县',
  '371524': '山东省东阿县',
  '371525': '山东省冠县',
  '371526': '山东省高唐县',
  '371581': '山东省临清市',
  '371600': '山东省滨州市',
  '371601': '山东省滨州市市辖区',
  '371602': '山东省滨州市滨城区',
  '371621': '山东省惠民县',
  '371622': '山东省阳信县',
  '371623': '山东省无棣县',
  '371624': '山东省沾化县',
  '371625': '山东省博兴县',
  '371626': '山东省邹平县',
  '371700': '山东省荷泽市',
  '371701': '山东省荷泽市市辖区',
  '371702': '山东省荷泽市牡丹区',
  '371721': '山东省曹县',
  '371722': '山东省单县',
  '371723': '山东省成武县',
  '371724': '山东省巨野县',
  '371725': '山东省郓城县',
  '371726': '山东省鄄城县',
  '371727': '山东省定陶县',
  '371728': '山东省东明县',
  '372100': '山东省烟台地区',
  '372101': '山东省烟台市',
  '372102': '山东省威海市',
  '372121': '山东省福山县',
  '372122': '山东省蓬莱县',
  '372123': '山东省黄县',
  '372124': '山东省招远县',
  '372125': '山东省掖县',
  '372126': '山东省莱西县',
  '372127': '山东省莱阳县',
  '372128': '山东省栖霞县',
  '372129': '山东省海阳县',
  '372130': '山东省乳山县',
  '372131': '山东省牟平县',
  '372132': '山东省文登县',
  '372133': '山东省荣城县',
  '372134': '山东省长岛县',
  '372200': '山东省潍坊地区',
  '372201': '山东省潍坊市',
  '372221': '山东省益都县',
  '372222': '山东省安丘县',
  '372223': '山东省寿光县',
  '372224': '山东省临朐县',
  '372225': '山东省昌乐县',
  '372226': '山东省昌邑县',
  '372227': '山东省高密县',
  '372228': '山东省诸城县',
  '372229': '山东省五莲县',
  '372230': '山东省平度县',
  '372231': '山东省潍县',
  '372300': '山东省滨州地区',
  '372301': '山东省滨州市',
  '372321': '山东省惠民县',
  '372322': '山东省滨县',
  '372323': '山东省阳信县',
  '372324': '山东省无棣县',
  '372325': '山东省沾化县',
  '372326': '山东省利津县',
  '372327': '山东省广饶县',
  '372328': '山东省博兴县',
  '372329': '山东省桓台县',
  '372330': '山东省邹平县',
  '372331': '山东省高青县',
  '372332': '山东省垦利县',
  '372400': '山东省德州地区',
  '372401': '山东省德州市',
  '372402': '山东省乐陵市',
  '372403': '山东省禹城市',
  '372421': '山东省陵县',
  '372422': '山东省平原县',
  '372423': '山东省夏津县',
  '372424': '山东省武城县',
  '372425': '山东省齐河县',
  '372426': '山东省禹城县',
  '372427': '山东省乐陵县',
  '372428': '山东省临邑县',
  '372429': '山东省商河县',
  '372430': '山东省济阳县',
  '372431': '山东省宁津县',
  '372432': '山东省庆云县',
  '372500': '山东省聊城地区',
  '372501': '山东省聊城市',
  '372502': '山东省临清市',
  '372521': '山东省聊城县',
  '372522': '山东省阳谷县',
  '372523': '山东省莘县',
  '372524': '山东省茌平县',
  '372525': '山东省东阿县',
  '372526': '山东省冠县',
  '372527': '山东省高唐县',
  '372528': '山东省临清县',
  '372600': '山东省泰安地区',
  '372601': '山东省泰安市',
  '372602': '山东省莱芜市',
  '372603': '山东省新泰市',
  '372622': '山东省莱芜县',
  '372623': '山东省新泰县',
  '372624': '山东省宁阳县',
  '372625': '山东省肥城县',
  '372626': '山东省东平县',
  '372627': '山东省平阴县',
  '372628': '山东省新汶县',
  '372629': '山东省汶上县',
  '372630': '山东省泗水县',
  '372700': '山东省济宁地区',
  '372701': '山东省济宁市',
  '372721': '山东省济宁县',
  '372722': '山东省兖州县',
  '372723': '山东省曲阜县',
  '372724': '山东省泗水县',
  '372725': '山东省邹县',
  '372726': '山东省微山县',
  '372727': '山东省鱼台县',
  '372728': '山东省金乡县',
  '372729': '山东省嘉祥县',
  '372730': '山东省汶上县',
  '372800': '山东省临沂地区',
  '372801': '山东省临沂市',
  '372802': '山东省日照市',
  '372821': '山东省临沂县',
  '372822': '山东省郯城县',
  '372823': '山东省苍山县',
  '372824': '山东省莒南县',
  '372825': '山东省日照县',
  '372826': '山东省莒县',
  '372827': '山东省沂水县',
  '372828': '山东省沂源县',
  '372829': '山东省蒙阴县',
  '372830': '山东省平邑县',
  '372831': '山东省费县',
  '372832': '山东省沂南县',
  '372833': '山东省临沭县',
  '372900': '山东省菏泽地区',
  '372901': '山东省菏泽市',
  '372921': '山东省荷泽县',
  '372922': '山东省曹县',
  '372923': '山东省定陶县',
  '372924': '山东省成武县',
  '372925': '山东省单县',
  '372926': '山东省巨野县',
  '372927': '山东省梁山县',
  '372928': '山东省郓城县',
  '372929': '山东省鄄城县',
  '372930': '山东省东明县',
  '379001': '山东省青州市',
  '379002': '山东省龙口市',
  '379003': '山东省曲阜市',
  '379004': '山东省莱芜市',
  '379005': '山东省新泰市',
  '379006': '山东省胶州市',
  '379007': '山东省诸城市',
  '379008': '山东省莱阳市',
  '379009': '山东省莱州市',
  '379010': '山东省滕州市',
  '379011': '山东省文登市',
  '379012': '山东省荣城市',
  '410000': '河南省',
  '410100': '河南省郑州市',
  '410101': '河南省郑州市市辖区',
  '410102': '河南省郑州市中原区',
  '410103': '河南省郑州市二七区',
  '410104': '河南省郑州市管城回族区',
  '410105': '河南省郑州市金水区',
  '410106': '河南省郑州市上街区',
  '410107': '河南省郑州市新密区',
  '410108': '河南省郑州市邙山区',
  '410111': '河南省郑州市金海区',
  '410112': '河南省郑州市郊区',
  '410120': '河南省郑州市区',
  '410121': '河南省荥阳县',
  '410122': '河南省中牟县',
  '410123': '河南省新郑县',
  '410124': '河南省巩县',
  '410125': '河南省登封县',
  '410126': '河南省密县',
  '410181': '河南省巩义市',
  '410182': '河南省荥阳市',
  '410183': '河南省新密市',
  '410184': '河南省新郑市',
  '410185': '河南省登封市',
  '410200': '河南省开封市',
  '410201': '河南省开封市市辖区',
  '410202': '河南省开封市龙亭区',
  '410203': '河南省开封市顺河回族区',
  '410204': '河南省开封市鼓楼区',
  '410205': '河南省开封市南关区',
  '410211': '河南省开封市郊区',
  '410221': '河南省杞县',
  '410222': '河南省通许县',
  '410223': '河南省尉氏县',
  '410224': '河南省开封县',
  '410225': '河南省兰考县',
  '410300': '河南省洛阳市',
  '410301': '河南省洛阳市市辖区',
  '410302': '河南省洛阳市老城区',
  '410303': '河南省洛阳市西工区',
  '410304': '河南省洛阳市廛河回族区',
  '410305': '河南省洛阳市涧西区',
  '410306': '河南省洛阳市吉利区',
  '410307': '河南省洛阳市洛龙区',
  '410311': '河南省洛阳市郊区',
  '410321': '河南省偃师县',
  '410322': '河南省孟津县',
  '410323': '河南省新安县',
  '410324': '河南省栾川县',
  '410325': '河南省嵩县',
  '410326': '河南省汝阳县',
  '410327': '河南省宜阳县',
  '410328': '河南省洛宁县',
  '410329': '河南省伊川县',
  '410381': '河南省偃师市',
  '410400': '河南省平顶山市',
  '410401': '河南省平顶山市市辖区',
  '410402': '河南省平顶山市新华区',
  '410403': '河南省平顶山市卫东区',
  '410404': '河南省平顶山市石龙区',
  '410411': '河南省平顶山市湛河区',
  '410412': '河南省平顶山市舞钢区',
  '410421': '河南省宝丰县',
  '410422': '河南省叶县',
  '410423': '河南省鲁山县',
  '410424': '河南省临汝县',
  '410425': '河南省郏县',
  '410426': '河南省襄城县',
  '410481': '河南省舞钢市',
  '410482': '河南省汝州市',
  '410500': '河南省安阳市',
  '410501': '河南省安阳市市辖区',
  '410502': '河南省安阳市文峰区',
  '410503': '河南省安阳市北关区',
  '410504': '河南省安阳市铁西区',
  '410505': '河南省安阳市殷都区',
  '410506': '河南省安阳市龙安区',
  '410511': '河南省安阳市郊区',
  '410521': '河南省林县',
  '410522': '河南省安阳县',
  '410523': '河南省汤阴县',
  '410524': '河南省淇县',
  '410525': '河南省浚县',
  '410526': '河南省滑县',
  '410527': '河南省内黄县',
  '410581': '河南省林州市',
  '410600': '河南省鹤壁市',
  '410601': '河南省鹤壁市市辖区',
  '410602': '河南省鹤壁市鹤山区',
  '410603': '河南省鹤壁市山城区',
  '410611': '河南省鹤壁市淇滨区',
  '410621': '河南省浚县',
  '410622': '河南省淇县',
  '410700': '河南省新乡市',
  '410701': '河南省新乡市市辖区',
  '410702': '河南省新乡市红旗区',
  '410703': '河南省新乡市卫滨区',
  '410704': '河南省新乡市凤泉区',
  '410711': '河南省新乡市牧野区',
  '410721': '河南省新乡县',
  '410722': '河南省汲县',
  '410723': '河南省辉县',
  '410724': '河南省获嘉县',
  '410725': '河南省原阳县',
  '410726': '河南省延津县',
  '410727': '河南省封丘县',
  '410728': '河南省长垣县',
  '410781': '河南省卫辉市',
  '410782': '河南省辉县市',
  '410800': '河南省焦作市',
  '410801': '河南省焦作市市辖区',
  '410802': '河南省焦作市解放区',
  '410803': '河南省焦作市中站区',
  '410804': '河南省焦作市马村区',
  '410811': '河南省焦作市山阳区',
  '410821': '河南省修武县',
  '410822': '河南省博爱县',
  '410823': '河南省武陟县',
  '410824': '河南省沁阳市',
  '410825': '河南省温县',
  '410826': '河南省孟县',
  '410827': '河南省济源县',
  '410881': '河南省济源市',
  '410882': '河南省沁阳市',
  '410883': '河南省孟州市',
  '410900': '河南省濮阳市',
  '410901': '河南省濮阳市市辖区',
  '410902': '河南省濮阳市华龙区',
  '410921': '河南省滑县',
  '410922': '河南省清丰县',
  '410923': '河南省南乐县',
  '410924': '河南省内黄县',
  '410925': '河南省长垣县',
  '410926': '河南省范县',
  '410927': '河南省台前县',
  '410928': '河南省濮阳县',
  '411000': '河南省许昌市',
  '411001': '河南省许昌市市辖区',
  '411002': '河南省许昌市魏都区',
  '411021': '河南省禹县',
  '411022': '河南省长葛县',
  '411023': '河南省许昌县',
  '411024': '河南省鄢陵县',
  '411025': '河南省襄城县',
  '411081': '河南省禹州市',
  '411082': '河南省长葛市',
  '411100': '河南省漯河市',
  '411101': '河南省漯河市市辖区',
  '411102': '河南省漯河市源汇区',
  '411103': '河南省漯河市郾城区',
  '411104': '河南省漯河市召陵区',
  '411121': '河南省舞阳县',
  '411122': '河南省临颍县',
  '411123': '河南省郾城县',
  '411200': '河南省三门峡市',
  '411201': '河南省三门峡市市辖区',
  '411202': '河南省三门峡市湖滨区',
  '411219': '河南省义马市',
  '411221': '河南省渑池县',
  '411222': '河南省陕县',
  '411223': '河南省灵宝县',
  '411224': '河南省卢氏县',
  '411281': '河南省义马市',
  '411282': '河南省灵宝市',
  '411300': '河南省南阳市',
  '411301': '河南省南阳市市辖区',
  '411302': '河南省南阳市宛城区',
  '411303': '河南省南阳市卧龙区',
  '411321': '河南省南召县',
  '411322': '河南省方城县',
  '411323': '河南省西峡县',
  '411324': '河南省镇平县',
  '411325': '河南省内乡县',
  '411326': '河南省淅川县',
  '411327': '河南省社旗县',
  '411328': '河南省唐河县',
  '411329': '河南省新野县',
  '411330': '河南省桐柏县',
  '411381': '河南省邓州市',
  '411400': '河南省商丘市',
  '411401': '河南省商丘市市辖区',
  '411402': '河南省商丘市梁园区',
  '411403': '河南省商丘市睢阳区',
  '411421': '河南省民权县',
  '411422': '河南省睢县',
  '411423': '河南省宁陵县',
  '411424': '河南省柘城县',
  '411425': '河南省虞城县',
  '411426': '河南省夏邑县',
  '411481': '河南省永城市',
  '411500': '河南省信阳市',
  '411501': '河南省信阳市市辖区',
  '411502': '河南省信阳市师河区',
  '411503': '河南省信阳市平桥区',
  '411521': '河南省罗山县',
  '411522': '河南省光山县',
  '411523': '河南省新县',
  '411524': '河南省商城县',
  '411525': '河南省固始县',
  '411526': '河南省潢川县',
  '411527': '河南省淮滨县',
  '411528': '河南省息县',
  '411600': '河南省周口市',
  '411601': '河南省周口市市辖区',
  '411602': '河南省周口市川汇区',
  '411621': '河南省扶沟县',
  '411622': '河南省西华县',
  '411623': '河南省商水县',
  '411624': '河南省沈丘县',
  '411625': '河南省郸城县',
  '411626': '河南省淮阳县',
  '411627': '河南省太康县',
  '411628': '河南省鹿邑县',
  '411681': '河南省项城市',
  '411700': '河南省驻马店市',
  '411701': '河南省驻马店市市辖区',
  '411702': '河南省驻马店市驿城区',
  '411721': '河南省西平县',
  '411722': '河南省上蔡县',
  '411723': '河南省平舆县',
  '411724': '河南省正阳县',
  '411725': '河南省确山县',
  '411726': '河南省泌阳县',
  '411727': '河南省汝南县',
  '411728': '河南省遂平县',
  '411729': '河南省新蔡县',
  '412100': '河南省安阳地区',
  '412121': '河南省林县',
  '412122': '河南省安阳县',
  '412123': '河南省汤阴县',
  '412124': '河南省淇县',
  '412125': '河南省浚县',
  '412126': '河南省濮阳县',
  '412127': '河南省滑县',
  '412128': '河南省清丰县',
  '412129': '河南省南乐县',
  '412130': '河南省内黄县',
  '412131': '河南省长垣县',
  '412132': '河南省范县',
  '412133': '河南省台前县',
  '412200': '河南省新乡地区',
  '412221': '河南省沁阳县',
  '412222': '河南省博爱县',
  '412223': '河南省济源县',
  '412224': '河南省孟县',
  '412225': '河南省温县',
  '412226': '河南省武陟县',
  '412227': '河南省修武县',
  '412228': '河南省获嘉县',
  '412229': '河南省新乡县',
  '412230': '河南省辉县',
  '412231': '河南省汲县',
  '412232': '河南省原阳县',
  '412233': '河南省延津县',
  '412234': '河南省封丘县',
  '412300': '河南省商丘地区',
  '412301': '河南省商丘市',
  '412302': '河南省永城市',
  '412321': '河南省虞城县',
  '412322': '河南省商丘县',
  '412323': '河南省民权县',
  '412324': '河南省宁陵县',
  '412325': '河南省睢县',
  '412326': '河南省夏邑县',
  '412327': '河南省柘城县',
  '412328': '河南省永城县',
  '412400': '河南省开封地区',
  '412421': '河南省杞县',
  '412422': '河南省通许县',
  '412423': '河南省尉氏县',
  '412424': '河南省开封县',
  '412425': '河南省中牟县',
  '412426': '河南省新郑县',
  '412427': '河南省巩县',
  '412428': '河南省登封县',
  '412429': '河南省密县',
  '412430': '河南省兰考县',
  '412500': '河南省洛阳地区',
  '412501': '河南省三门峡市',
  '412502': '河南省义马市',
  '412521': '河南省偃师县',
  '412522': '河南省孟津县',
  '412523': '河南省新安县',
  '412524': '河南省渑池县',
  '412525': '河南省陕县',
  '412526': '河南省灵宝县',
  '412527': '河南省伊川县',
  '412528': '河南省汝阳县',
  '412529': '河南省嵩县',
  '412530': '河南省洛宁县',
  '412531': '河南省卢氏县',
  '412532': '河南省栾川县',
  '412533': '河南省临汝县',
  '412534': '河南省宜阳县',
  '412600': '河南省许昌地区',
  '412601': '河南省许昌市',
  '412602': '河南省漯河市',
  '412621': '河南省长葛县',
  '412622': '河南省禹县',
  '412623': '河南省鄢陵县',
  '412624': '河南省许昌县',
  '412625': '河南省郏县',
  '412626': '河南省临颍县',
  '412627': '河南省襄城县',
  '412628': '河南省宝丰县',
  '412629': '河南省郾城县',
  '412630': '河南省叶县',
  '412631': '河南省鲁山县',
  '412632': '河南省舞阳县',
  '412700': '河南省周口地区',
  '412701': '河南省周口市',
  '412702': '河南省项城市',
  '412721': '河南省扶沟县',
  '412722': '河南省西华县',
  '412723': '河南省商水县',
  '412724': '河南省太康县',
  '412725': '河南省鹿邑县',
  '412726': '河南省郸城县',
  '412727': '河南省淮阳县',
  '412728': '河南省沈丘县',
  '412729': '河南省项城县',
  '412800': '河南省驻马店地区',
  '412801': '河南省驻马店市',
  '412821': '河南省确山县',
  '412822': '河南省泌阳县',
  '412823': '河南省遂平县',
  '412824': '河南省西平县',
  '412825': '河南省上蔡县',
  '412826': '河南省汝南县',
  '412827': '河南省平舆县',
  '412828': '河南省新蔡县',
  '412829': '河南省正阳县',
  '412900': '河南省南阳地区',
  '412901': '河南省南阳市',
  '412902': '河南省邓州市',
  '412921': '河南省南召县',
  '412922': '河南省方城县',
  '412923': '河南省西峡县',
  '412924': '河南省南阳县',
  '412925': '河南省镇平县',
  '412926': '河南省内乡县',
  '412927': '河南省淅川县',
  '412928': '河南省社旗县',
  '412929': '河南省唐河县',
  '412930': '河南省邓县',
  '412931': '河南省新野县',
  '412932': '河南省桐柏县',
  '413000': '河南省信阳地区',
  '413001': '河南省信阳市',
  '413021': '河南省息县',
  '413022': '河南省淮滨县',
  '413023': '河南省信阳县',
  '413024': '河南省潢川县',
  '413025': '河南省光山县',
  '413026': '河南省固始县',
  '413027': '河南省商城县',
  '413028': '河南省罗山县',
  '413029': '河南省新县',
  '419000': '河南省省直辖行政单位',
  '419001': '河南省义马市',
  '419002': '河南省汝州市',
  '419003': '河南省济源市',
  '419004': '河南省禹州市',
  '419005': '河南省卫辉市',
  '419006': '河南省辉县市',
  '420000': '湖北省',
  '420100': '武汉市',
  '420101': '武汉市市辖区',
  '420102': '武汉市江岸区',
  '420103': '武汉市江汉区',
  '420104': '武汉市',
  '420105': '武汉市汉阳区',
  '420106': '武汉市武昌区',
  '420107': '武汉市青山区',
  '420111': '武汉市洪山区',
  '420112': '武汉市东西湖区',
  '420113': '武汉市汉南区',
  '420114': '武汉市蔡甸区',
  '420115': '武汉市江夏区',
  '420116': '武汉市黄陂区',
  '420117': '武汉市新洲区',
  '420120': '武汉市区',
  '420121': '湖北省汉阳县',
  '420122': '湖北省武昌县',
  '420123': '湖北省黄陂县',
  '420124': '湖北省新洲县',
  '420200': '湖北省黄石市',
  '420201': '湖北省黄石市市辖区',
  '420202': '湖北省黄石市黄石港区',
  '420203': '湖北省黄石市西塞山区',
  '420204': '湖北省黄石市下陆区',
  '420205': '湖北省黄石市铁山区',
  '420220': '湖北省黄石市区',
  '420221': '湖北省大冶县',
  '420222': '湖北省阳新县',
  '420281': '湖北省大冶市',
  '420300': '湖北省十堰市',
  '420301': '湖北省十堰市市辖区',
  '420302': '湖北省十堰市茅箭区',
  '420303': '湖北省十堰市张湾区',
  '420321': '湖北省郧县',
  '420322': '湖北省郧西县',
  '420323': '湖北省竹山县',
  '420324': '湖北省竹溪县',
  '420325': '湖北省房县',
  '420381': '湖北省丹江口市',
  '420400': '湖北省沙市市',
  '420500': '湖北省宜昌市',
  '420501': '湖北省宜昌市市辖区',
  '420502': '湖北省宜昌市西陵区',
  '420503': '湖北省宜昌市伍家岗区',
  '420504': '湖北省宜昌市点军区',
  '420505': '湖北省宜昌市',
  '420506': '湖北省宜昌市夷陵区',
  '420521': '湖北省宜昌县',
  '420523': '湖北省枝江县',
  '420525': '湖北省远安县',
  '420526': '湖北省兴山县',
  '420527': '湖北省秭归县',
  '420528': '湖北省长阳土家族自治县',
  '420529': '湖北省五峰土家族自治县',
  '420581': '湖北省宜都市',
  '420582': '湖北省当阳市',
  '420583': '湖北省枝江市',
  '420600': '湖北省襄樊市',
  '420601': '湖北省襄樊市市辖区',
  '420602': '湖北省襄樊市襄城区',
  '420603': '湖北省襄樊市樊东区',
  '420604': '湖北省襄樊市樊西区',
  '420605': '湖北省襄樊市郊区',
  '420606': '湖北省襄樊市樊城区',
  '420607': '湖北省襄樊市襄阳区',
  '420619': '湖北省随州市',
  '420620': '湖北省老河口市',
  '420621': '湖北省襄阳县',
  '420622': '湖北省枣阳县',
  '420623': '湖北省宜城县',
  '420624': '湖北省南漳县',
  '420625': '湖北省谷城县',
  '420626': '湖北省保康县',
  '420681': '湖北省随州市',
  '420682': '湖北省老河口市',
  '420683': '湖北省枣阳市',
  '420684': '湖北省宜城市',
  '420700': '湖北省鄂州市',
  '420701': '湖北省鄂州市市辖区',
  '420702': '湖北省鄂州市梁子湖区',
  '420703': '湖北省鄂州市华容区',
  '420704': '湖北省鄂州市鄂城区',
  '420800': '湖北省荆门市',
  '420801': '湖北省荆门市市辖区',
  '420802': '湖北省荆门市东宝区',
  '420803': '湖北省荆门市掇刀区',
  '420804': '湖北省荆门市掇刀区',
  '420821': '湖北省京山县',
  '420822': '湖北省沙洋县',
  '420881': '湖北省钟祥市',
  '420900': '湖北省孝感市',
  '420901': '湖北省孝感市市辖区',
  '420902': '湖北省孝感市孝南区',
  '420921': '湖北省孝昌县',
  '420922': '湖北省大悟县',
  '420923': '湖北省云梦县',
  '420924': '湖北省汉川县',
  '420981': '湖北省应城市',
  '420982': '湖北省安陆市',
  '420983': '湖北省广水市',
  '420984': '湖北省汉川市',
  '421000': '湖北省荆州市',
  '421001': '湖北省荆州市市辖区',
  '421002': '湖北省荆州市沙市区',
  '421003': '湖北省荆州市荆州区',
  '421004': '湖北省荆州市江陵区',
  '421022': '湖北省公安县',
  '421023': '湖北省监利县',
  '421024': '湖北省江陵县',
  '421081': '湖北省石首市',
  '421083': '湖北省洪湖市',
  '421087': '湖北省松滋市',
  '421100': '湖北省黄冈市',
  '421101': '湖北省黄冈市市辖区',
  '421102': '湖北省黄冈市黄州区',
  '421121': '湖北省团风县',
  '421122': '湖北省红安县',
  '421123': '湖北省罗田县',
  '421124': '湖北省英山县',
  '421125': '湖北省浠水县',
  '421126': '湖北省蕲春县',
  '421127': '湖北省黄梅县',
  '421181': '湖北省麻城市',
  '421182': '湖北省武穴市',
  '421200': '湖北省咸宁市',
  '421201': '湖北省咸宁市市辖区',
  '421202': '湖北省咸宁市咸安区',
  '421221': '湖北省嘉鱼县',
  '421222': '湖北省通城县',
  '421223': '湖北省崇阳县',
  '421224': '湖北省通山县',
  '421281': '湖北省赤壁市',
  '421300': '湖北省随州市',
  '421301': '湖北省随州市市辖区',
  '421302': '湖北省随州市曾都区',
  '421381': '湖北省广水市',
  '422100': '湖北省黄冈地区',
  '422101': '湖北省麻城市',
  '422102': '湖北省武穴市',
  '422103': '湖北省黄州市',
  '422121': '湖北省黄冈县',
  '422122': '湖北省新洲县',
  '422123': '湖北省红安县',
  '422124': '湖北省麻城县',
  '422125': '湖北省罗田县',
  '422126': '湖北省英山县',
  '422127': '湖北省浠水县',
  '422128': '湖北省蕲春县',
  '422129': '湖北省广济县',
  '422130': '湖北省黄梅县',
  '422131': '湖北省鄂城县',
  '422200': '湖北省孝感地区',
  '422201': '湖北省孝感市',
  '422202': '湖北省应城市',
  '422203': '湖北省安陆市',
  '422204': '湖北省广水市',
  '422221': '湖北省孝感县',
  '422222': '湖北省黄陂县',
  '422223': '湖北省大悟县',
  '422224': '湖北省应山县',
  '422225': '湖北省安陆县',
  '422226': '湖北省云梦县',
  '422227': '湖北省应城县',
  '422228': '湖北省汉川县',
  '422300': '湖北省咸宁地区',
  '422301': '湖北省咸宁市',
  '422302': '湖北省赤壁市',
  '422321': '湖北省咸宁县',
  '422322': '湖北省嘉鱼县',
  '422323': '湖北省蒲圻县',
  '422324': '湖北省通城县',
  '422325': '湖北省崇阳县',
  '422326': '湖北省通山县',
  '422327': '湖北省阳新县',
  '422400': '湖北省荆州地区',
  '422401': '湖北省仙桃市',
  '422402': '湖北省石首市',
  '422403': '湖北省洪湖市',
  '422404': '湖北省天门市',
  '422405': '湖北省潜江市',
  '422406': '湖北省钟祥市',
  '422421': '湖北省江陵县',
  '422422': '湖北省松滋县',
  '422423': '湖北省公安县',
  '422424': '湖北省石首县',
  '422425': '湖北省监利县',
  '422426': '湖北省洪湖县',
  '422427': '湖北省沔阳县',
  '422428': '湖北省天门县',
  '422429': '湖北省潜江县',
  '422430': '湖北省荆门县',
  '422431': '湖北省钟祥县',
  '422432': '湖北省京山县',
  '422500': '湖北省襄阳地区',
  '422501': '湖北省随州市',
  '422502': '湖北省老河口市',
  '422521': '湖北省襄阳县',
  '422522': '湖北省枣阳县',
  '422523': '湖北省随县',
  '422524': '湖北省宜城县',
  '422525': '湖北省南漳县',
  '422526': '湖北省光华县',
  '422527': '湖北省谷城县',
  '422528': '湖北省保康县',
  '422600': '湖北省郧阳地区',
  '422601': '湖北省丹江口市',
  '422621': '湖北省均县',
  '422622': '湖北省郧县',
  '422623': '湖北省郧西县',
  '422624': '湖北省竹山县',
  '422625': '湖北省竹溪县',
  '422626': '湖北省房县',
  '422627': '湖北省神农架林区',
  '422700': '湖北省宜昌地区',
  '422701': '湖北省枝城市',
  '422702': '湖北省当阳市',
  '422721': '湖北省宜昌县',
  '422722': '湖北省宜都县',
  '422723': '湖北省枝江县',
  '422724': '湖北省当阳县',
  '422725': '湖北省远安县',
  '422726': '湖北省兴山县',
  '422727': '湖北省秭归县',
  '422728': '湖北省长阳土家族自治县',
  '422729': '湖北省五峰土家族自治县',
  '422800': '湖北省恩施土家族苗族自治州',
  '422801': '湖北省恩施市',
  '422802': '湖北省利川市',
  '422821': '湖北省恩施县',
  '422822': '湖北省建始县',
  '422823': '湖北省巴东县',
  '422824': '湖北省利川县',
  '422825': '湖北省宣恩县',
  '422826': '湖北省咸丰县',
  '422827': '湖北省来凤县',
  '422828': '湖北省鹤峰县',
  '422900': '湖北省省直辖行政单位',
  '422921': '湖北省神农架林区',
  '429000': '湖北省直属行政单位',
  '429001': '湖北省随州市',
  '429002': '湖北省老河口市',
  '429003': '湖北省枣阳市',
  '429004': '湖北省仙桃市',
  '429005': '湖北省潜江市',
  '429006': '湖北省天门市',
  '429021': '湖北省神农架林区',
  '430000': '湖南省',
  '430100': '湖南省长沙市',
  '430101': '湖南省长沙市市辖区',
  '430102': '湖南省长沙市芙蓉区',
  '430103': '湖南省长沙市天心区',
  '430104': '湖南省长沙市岳麓区',
  '430105': '湖南省长沙市开福区',
  '430111': '湖南省长沙市雨花区',
  '430120': '湖南省长沙市区',
  '430121': '湖南省长沙县',
  '430122': '湖南省望城县',
  '430123': '湖南省浏阳县',
  '430124': '湖南省宁乡县',
  '430181': '湖南省浏阳市',
  '430200': '湖南省株洲市',
  '430201': '湖南省株洲市市辖区',
  '430202': '湖南省株洲市荷塘区',
  '430203': '湖南省株洲市芦淞区',
  '430204': '湖南省株洲市石峰区',
  '430211': '湖南省株洲市天元区',
  '430219': '湖南省醴陵市',
  '430220': '湖南省株州市区',
  '430221': '湖南省株洲县',
  '430222': '湖南省醴陵县',
  '430223': '湖南省攸县',
  '430224': '湖南省茶陵县',
  '430225': '湖南省炎陵县',
  '430281': '湖南省醴陵市',
  '430300': '湖南省湘潭市',
  '430301': '湖南省湘潭市市辖区',
  '430302': '湖南省湘潭市雨湖区',
  '430303': '湖南省湘潭市湘江区',
  '430304': '湖南省湘潭市岳塘区',
  '430305': '湖南省湘潭市板塘区',
  '430306': '湖南省湘潭市韶山区',
  '430311': '湖南省湘潭市郊区',
  '430312': '湖南省湘潭市韶山区',
  '430321': '湖南省湘潭县',
  '430322': '湖南省湘乡县',
  '430381': '湖南省湘乡市',
  '430382': '湖南省韶山市',
  '430400': '湖南省衡阳市',
  '430401': '湖南省衡阳市市辖区',
  '430402': '湖南省衡阳市江东区',
  '430403': '湖南省衡阳市城南区',
  '430404': '湖南省衡阳市城北区',
  '430405': '湖南省衡阳市珠晖区',
  '430406': '湖南省衡阳市雁峰区',
  '430407': '湖南省衡阳市石鼓区',
  '430408': '湖南省衡阳市蒸湘区',
  '430411': '湖南省衡阳市郊区',
  '430412': '湖南省衡阳市南岳区',
  '430419': '湖南省耒阳市',
  '430421': '湖南省衡阳县',
  '430422': '湖南省衡南县',
  '430423': '湖南省衡山县',
  '430424': '湖南省衡东县',
  '430425': '湖南省常宁县',
  '430426': '湖南省祁东县',
  '430427': '湖南省耒阳县',
  '430481': '湖南省耒阳市',
  '430482': '湖南省常宁市',
  '430500': '湖南省邵阳市',
  '430501': '湖南省邵阳市市辖区',
  '430502': '湖南省邵阳市双清区',
  '430503': '湖南省邵阳市大祥区',
  '430504': '湖南省邵阳市桥头区',
  '430511': '湖南省邵阳市北塔区',
  '430521': '湖南省邵东县',
  '430522': '湖南省新邵县',
  '430523': '湖南省邵阳县',
  '430524': '湖南省隆回县',
  '430525': '湖南省洞口县',
  '430526': '湖南省武冈县',
  '430527': '湖南省绥宁县',
  '430528': '湖南省新宁县',
  '430529': '湖南省城步苗族自治县',
  '430581': '湖南省武冈市',
  '430600': '湖南省岳阳市',
  '430601': '湖南省岳阳市市辖区',
  '430602': '湖南省岳阳市岳阳楼区',
  '430603': '湖南省岳阳市云溪区',
  '430611': '湖南省岳阳市君山区',
  '430621': '湖南省岳阳县',
  '430622': '湖南省临湘县',
  '430623': '湖南省华容县',
  '430624': '湖南省湘阴县',
  '430625': '湖南省汨罗县',
  '430626': '湖南省平江县',
  '430681': '湖南省汨罗市',
  '430682': '湖南省临湘市',
  '430700': '湖南省常德市',
  '430701': '湖南省常德市市辖区',
  '430702': '湖南省常德市武陵区',
  '430703': '湖南省常德市鼎城区',
  '430721': '湖南省安乡县',
  '430722': '湖南省汉寿县',
  '430723': '湖南省澧县',
  '430724': '湖南省临澧县',
  '430725': '湖南省桃源县',
  '430726': '湖南省石门县',
  '430781': '湖南省津市市',
  '430800': '湖南省张家界市',
  '430801': '湖南省张家界市市辖区',
  '430802': '湖南省张家界市永定区',
  '430811': '湖南省张家界市武陵源区',
  '430821': '湖南省慈利县',
  '430822': '湖南省桑植县',
  '430900': '湖南省益阳市',
  '430901': '湖南省益阳市市辖区',
  '430902': '湖南省益阳市资阳区',
  '430903': '湖南省益阳市赫山区',
  '430921': '湖南省南县',
  '430922': '湖南省桃江县',
  '430923': '湖南省安化县',
  '430981': '湖南省沅江市',
  '431000': '湖南省郴州市',
  '431001': '湖南省郴州市市辖区',
  '431002': '湖南省郴州市北湖区',
  '431003': '湖南省郴州市苏仙区',
  '431021': '湖南省桂阳县',
  '431022': '湖南省宜章县',
  '431023': '湖南省永兴县',
  '431024': '湖南省嘉禾县',
  '431025': '湖南省临武县',
  '431026': '湖南省汝城县',
  '431027': '湖南省桂东县',
  '431028': '湖南省安仁县',
  '431081': '湖南省资兴市',
  '431100': '湖南省永州市',
  '431101': '湖南省永州市市辖区',
  '431102': '湖南省永州市芝山区',
  '431103': '湖南省永州市冷水滩区',
  '431121': '湖南省祁阳县',
  '431122': '湖南省东安县',
  '431123': '湖南省双牌县',
  '431124': '湖南省道县',
  '431125': '湖南省江永县',
  '431126': '湖南省宁远县',
  '431127': '湖南省蓝山县',
  '431128': '湖南省新田县',
  '431129': '湖南省江华瑶族自治县',
  '431200': '湖南省怀化市',
  '431201': '湖南省怀化市市辖区',
  '431202': '湖南省怀化市鹤城区',
  '431221': '湖南省中方县',
  '431222': '湖南省沅陵县',
  '431223': '湖南省辰溪县',
  '431224': '湖南省溆浦县',
  '431225': '湖南省会同县',
  '431226': '湖南省麻阳苗族自治县',
  '431227': '湖南省新晃侗族自治县',
  '431228': '湖南省芷江侗族自治县',
  '431229': '湖南省靖州苗族侗族自治县',
  '431230': '湖南省通道侗族自治县',
  '431281': '湖南省洪江市',
  '431300': '湖南省娄底市',
  '431301': '湖南省娄底市市辖区',
  '431302': '湖南省娄底市娄星区',
  '431321': '湖南省双峰县',
  '431322': '湖南省新化县',
  '431381': '湖南省冷水江市',
  '431382': '湖南省涟源市',
  '432100': '湖南省湘潭地区',
  '432121': '湖南省湘潭县',
  '432122': '湖南省湘乡县',
  '432123': '湖南省醴陵县',
  '432124': '湖南省浏阳县',
  '432125': '湖南省攸县',
  '432126': '湖南省茶陵县',
  '432127': '湖南省酃县',
  '432200': '湖南省岳阳地区',
  '432201': '湖南省岳阳市',
  '432222': '湖南省平江县',
  '432223': '湖南省湘阴县',
  '432224': '湖南省汨罗县',
  '432225': '湖南省临湘县',
  '432226': '湖南省华容县',
  '432300': '湖南省益阳地区',
  '432301': '湖南省益阳市',
  '432302': '湖南省沅江市',
  '432321': '湖南省益阳县',
  '432322': '湖南省南县',
  '432323': '湖南省沅江县',
  '432324': '湖南省宁乡县',
  '432325': '湖南省桃江县',
  '432326': '湖南省安化县',
  '432400': '湖南省常德地区',
  '432401': '湖南省常德市',
  '432402': '湖南省津市市',
  '432421': '湖南省常德县',
  '432422': '湖南省安乡县',
  '432423': '湖南省汉寿县',
  '432424': '湖南省澧县',
  '432425': '湖南省临澧县',
  '432426': '湖南省桃源县',
  '432427': '湖南省石门县',
  '432428': '湖南省慈利县',
  '432500': '湖南省娄底地区',
  '432501': '湖南省娄底市',
  '432502': '湖南省冷水江市',
  '432503': '湖南省涟源市',
  '432521': '湖南省涟源县',
  '432522': '湖南省双峰县',
  '432523': '湖南省邵东县',
  '432524': '湖南省新化县',
  '432525': '湖南省新邵县',
  '432600': '湖南省邵阳地区',
  '432621': '湖南省邵阳县',
  '432622': '湖南省隆回县',
  '432623': '湖南省武冈县',
  '432624': '湖南省洞口县',
  '432625': '湖南省新宁县',
  '432626': '湖南省绥宁县',
  '432627': '湖南省城步苗族自治县',
  '432700': '湖南省衡阳地区',
  '432721': '湖南省衡阳县',
  '432722': '湖南省衡南县',
  '432723': '湖南省衡山县',
  '432724': '湖南省衡东县',
  '432725': '湖南省常宁县',
  '432726': '湖南省祁东县',
  '432727': '湖南省祁阳县',
  '432800': '湖南省郴州地区',
  '432801': '湖南省郴州市',
  '432802': '湖南省资兴市',
  '432821': '湖南省郴县',
  '432822': '湖南省桂阳县',
  '432823': '湖南省永兴县',
  '432824': '湖南省宜章县',
  '432825': '湖南省资兴县',
  '432826': '湖南省嘉禾县',
  '432827': '湖南省临武县',
  '432828': '湖南省汝城县',
  '432829': '湖南省桂东县',
  '432830': '湖南省耒阳县',
  '432831': '湖南省安仁县',
  '432900': '湖南省零陵地区',
  '432901': '湖南省永州市',
  '432902': '湖南省冷水滩市',
  '432921': '湖南省零陵县',
  '432922': '湖南省东安县',
  '432923': '湖南省道县',
  '432924': '湖南省宁远县',
  '432925': '湖南省江永县',
  '432926': '湖南省江华瑶族自治县',
  '432927': '湖南省蓝山县',
  '432928': '湖南省新田县',
  '432929': '湖南省双牌县',
  '432930': '湖南省祁阳县',
  '433000': '湖南省怀化地区',
  '433001': '湖南省怀化市',
  '433002': '湖南省洪江市',
  '433021': '湖南省黔阳县',
  '433022': '湖南省沅陵县',
  '433023': '湖南省辰溪县',
  '433024': '湖南省溆浦县',
  '433025': '湖南省麻阳苗族自治县',
  '433026': '湖南省新晃侗族自治县',
  '433027': '湖南省芷江侗族自治县',
  '433028': '湖南省怀化县',
  '433029': '湖南省会同县',
  '433030': '湖南省靖州苗族侗族自治县',
  '433031': '湖南省通道侗族自治县',
  '433100': '湖南省湘西土家族苗族自治州',
  '433101': '湖南省吉首市',
  '433102': '湖南省大庸市',
  '433121': '湖南省吉首县',
  '433122': '湖南省泸溪县',
  '433123': '湖南省凤凰县',
  '433124': '湖南省花垣县',
  '433125': '湖南省保靖县',
  '433126': '湖南省古丈县',
  '433127': '湖南省永顺县',
  '433128': '湖南省大庸县',
  '433129': '湖南省桑植县',
  '433130': '湖南省龙山县',
  '439000': '湖南省省直辖行政单位',
  '439001': '湖南省醴陵市',
  '439002': '湖南省湘乡市',
  '439003': '湖南省耒阳市',
  '439004': '湖南省汨罗市',
  '439005': '湖南省津市市',
  '440000': '广东省',
  '440100': '广东省广州市',
  '440101': '广东省广州市市辖区',
  '440102': '广东省广州市东山区',
  '440103': '广东省广州市荔湾区',
  '440104': '广东省广州市越秀区',
  '440105': '广东省广州市海珠区',
  '440106': '广东省广州市天河区',
  '440107': '广东省广州市芳村区',
  '440111': '广东省广州市白云区',
  '440112': '广东省广州市黄埔区',
  '440113': '广东省广州市番禺区',
  '440114': '广东省广州市花都区',
  '440120': '广东省广州市区',
  '440121': '广东省花县',
  '440122': '广东省从化县',
  '440123': '广东省新丰县',
  '440124': '广东省龙门县',
  '440125': '广东省增城县',
  '440126': '广东省番禺县',
  '440127': '广东省清远县',
  '440128': '广东省佛冈县',
  '440181': '广东省番禺市',
  '440182': '广东省花都市',
  '440183': '广东省增城市',
  '440184': '广东省从化市',
  '440200': '广东省韶关市',
  '440201': '广东省韶关市市辖区',
  '440202': '广东省韶关市北江区',
  '440203': '广东省韶关市武江区',
  '440204': '广东省韶关市浈江区',
  '440205': '广东省韶关市曲江区',
  '440220': '广东省韶关市区',
  '440221': '广东省曲江县',
  '440222': '广东省始兴县',
  '440223': '广东省南雄县',
  '440224': '广东省仁化县',
  '440225': '广东省乐昌县',
  '440226': '广东省连县',
  '440227': '广东省阳山县',
  '440228': '广东省英德县',
  '440229': '广东省翁源县',
  '440230': '广东省连山壮族瑶族自治县',
  '440231': '广东省连南瑶族自治县',
  '440232': '广东省乳源瑶族自治县',
  '440233': '广东省新丰县',
  '440281': '广东省乐昌市',
  '440282': '广东省南雄市',
  '440300': '广东省深圳市',
  '440301': '广东省深圳市市辖区',
  '440302': '广东省深圳市沙头角区',
  '440303': '广东省深圳市罗湖区',
  '440304': '广东省深圳市福田区',
  '440305': '广东省深圳市南山区',
  '440306': '广东省深圳市宝安区',
  '440307': '广东省深圳市龙岗区',
  '440308': '广东省深圳市盐田区',
  '440320': '广东省深圳市区',
  '440321': '广东省宝安县',
  '440400': '广东省珠海市',
  '440401': '广东省珠海市市辖区',
  '440402': '广东省珠海市香洲区',
  '440403': '广东省珠海市斗门区',
  '440404': '广东省珠海市金湾区',
  '440421': '广东省斗门县',
  '440500': '广东省汕头市',
  '440501': '广东省汕头市市辖区',
  '440502': '广东省汕头市同平区',
  '440503': '广东省汕头市安平区',
  '440504': '广东省汕头市公园区',
  '440505': '广东省汕头市金砂区',
  '440506': '广东省汕头市达濠区',
  '440507': '广东省汕头市龙湖区',
  '440508': '广东省汕头市金园区',
  '440509': '广东省汕头市升平区',
  '440510': '广东省汕头市河浦区',
  '440511': '广东省汕头市郊区',
  '440512': '广东省汕头市濠江区',
  '440513': '广东省汕头市潮阳区',
  '440514': '广东省汕头市潮南区',
  '440515': '广东省汕头市澄海区',
  '440520': '广东省潮州市',
  '440521': '广东省澄海县',
  '440522': '广东省饶平县',
  '440523': '广东省南澳县',
  '440524': '广东省潮阳县',
  '440525': '广东省揭阳县',
  '440526': '广东省揭西县',
  '440527': '广东省普宁县',
  '440528': '广东省惠来县',
  '440581': '广东省潮州市',
  '440582': '广东省潮阳市',
  '440583': '广东省澄海市',
  '440600': '广东省佛山市',
  '440601': '广东省佛山市市辖区',
  '440602': '广东省佛山市城区',
  '440603': '广东省佛山市石湾区',
  '440604': '广东省佛山市禅城区',
  '440605': '广东省佛山市南海区',
  '440606': '广东省佛山市顺德区',
  '440607': '广东省佛山市三水区',
  '440608': '广东省佛山市高明区',
  '440620': '广东省中山市',
  '440621': '广东省三水县',
  '440622': '广东省南海县',
  '440623': '广东省顺德县',
  '440624': '广东省高明县',
  '440681': '广东省顺德市',
  '440682': '广东省南海市',
  '440683': '广东省三水市',
  '440684': '广东省高明市',
  '440700': '广东省江门市',
  '440701': '广东省江门市市辖区',
  '440702': '广东省江门市城区',
  '440703': '广东省江门市蓬江区',
  '440704': '广东省江门市江海区',
  '440705': '广东省江门市新会区',
  '440711': '广东省江门市郊区',
  '440721': '广东省新会县',
  '440722': '广东省台山县',
  '440723': '广东省恩平县',
  '440724': '广东省开平县',
  '440725': '广东省鹤山县',
  '440726': '广东省阳江县',
  '440727': '广东省阳春县',
  '440781': '广东省台山市',
  '440782': '广东省新会市',
  '440783': '广东省开平市',
  '440784': '广东省鹤山市',
  '440785': '广东省恩平市',
  '440800': '广东省湛江市',
  '440801': '广东省湛江市市辖区',
  '440802': '广东省湛江市赤坎区',
  '440803': '广东省湛江市霞山区',
  '440804': '广东省湛江市坡头区',
  '440811': '广东省湛江市麻章区',
  '440821': '广东省吴川县',
  '440822': '广东省廉江县',
  '440823': '广东省遂溪县',
  '440824': '广东省海康县',
  '440825': '广东省徐闻县',
  '440881': '广东省廉江市',
  '440882': '广东省雷州市',
  '440883': '广东省吴川市',
  '440900': '广东省茂名市',
  '440901': '广东省茂名市市辖区',
  '440902': '广东省茂名市茂南区',
  '440903': '广东省茂名市茂港区',
  '440921': '广东省信宜县',
  '440922': '广东省高州县',
  '440923': '广东省电白县',
  '440924': '广东省化州县',
  '440981': '广东省高州市',
  '440982': '广东省化州市',
  '440983': '广东省信宜市',
  '441000': '广东省海口市',
  '441200': '广东省肇庆市',
  '441201': '广东省肇庆市市辖区',
  '441202': '广东省肇庆市端州区',
  '441203': '广东省肇庆市鼎湖区',
  '441221': '广东省高要县',
  '441222': '广东省四会县',
  '441223': '广东省广宁县',
  '441224': '广东省怀集县',
  '441225': '广东省封开县',
  '441226': '广东省德庆县',
  '441227': '广东省云浮县',
  '441228': '广东省新兴县',
  '441229': '广东省郁南县',
  '441230': '广东省罗定县',
  '441281': '广东省云浮市',
  '441282': '广东省罗定市',
  '441283': '广东省高要市',
  '441284': '广东省四会市',
  '441300': '广东省惠州市',
  '441301': '广东省惠州市市辖区',
  '441302': '广东省惠州市惠城区',
  '441303': '广东省惠州市惠阳区',
  '441321': '广东省惠阳县',
  '441322': '广东省博罗县',
  '441323': '广东省惠东县',
  '441324': '广东省龙门县',
  '441381': '广东省惠阳市',
  '441400': '广东省梅州市',
  '441401': '广东省梅州市市辖区',
  '441402': '广东省梅州市梅江区',
  '441421': '广东省梅县',
  '441422': '广东省大埔县',
  '441423': '广东省丰顺县',
  '441424': '广东省五华县',
  '441425': '广东省兴宁县',
  '441426': '广东省平远县',
  '441427': '广东省蕉岭县',
  '441481': '广东省兴宁市',
  '441500': '广东省汕尾市',
  '441501': '广东省汕尾市市辖区',
  '441502': '广东省汕尾市城区',
  '441521': '广东省海丰县',
  '441522': '广东省陆丰县',
  '441523': '广东省陆河县',
  '441581': '广东省陆丰市',
  '441600': '广东省河源市',
  '441601': '广东省河源市市辖区',
  '441602': '广东省河源市源城区',
  '441611': '广东省河源市郊区',
  '441621': '广东省紫金县',
  '441622': '广东省龙川县',
  '441623': '广东省连平县',
  '441624': '广东省和平县',
  '441625': '广东省东源县',
  '441700': '广东省阳江市',
  '441701': '广东省阳江市市辖区',
  '441702': '广东省阳江市江城区',
  '441703': '广东省阳江市阳东区',
  '441721': '广东省阳西县',
  '441722': '广东省阳春县',
  '441723': '广东省阳东县',
  '441781': '广东省阳春市',
  '441800': '广东省清远市',
  '441801': '广东省清远市市辖区',
  '441802': '广东省清远市清城区',
  '441811': '广东省清远市清郊区',
  '441821': '广东省佛冈县',
  '441822': '广东省英德县',
  '441823': '广东省阳山县',
  '441824': '广东省连县',
  '441825': '广东省连山壮族瑶族自治县',
  '441826': '广东省连南瑶族自治县',
  '441827': '广东省清新县',
  '441881': '广东省英德市',
  '441882': '广东省连州市',
  '441900': '广东省东莞市',
  '442000': '广东省中山市',
  '442100': '广东省海南行政区',
  '442101': '广东省海口市',
  '442121': '广东省琼山县',
  '442122': '广东省文昌县',
  '442123': '广东省琼海县',
  '442124': '广东省万宁县',
  '442125': '广东省定安县',
  '442126': '广东省屯昌县',
  '442127': '广东省澄迈县',
  '442128': '广东省临高县',
  '442129': '广东省儋县',
  '442200': '广东省海南行政区黎族苗族自治州',
  '442201': '广东省三亚市',
  '442202': '广东省通什市',
  '442221': '广东省崖县',
  '442222': '广东省东方县',
  '442223': '广东省乐东县',
  '442224': '广东省琼中县',
  '442225': '广东省保亭县',
  '442226': '广东省陵水县',
  '442227': '广东省白沙县',
  '442228': '广东省昌江县',
  '442229': '广东省西沙群岛、南沙群岛、中沙群岛',
  '442300': '广东省汕头地区',
  '442301': '广东省汕头市',
  '442302': '广东省潮州市',
  '442321': '广东省潮安县',
  '442322': '广东省澄海县',
  '442323': '广东省饶平县',
  '442324': '广东省南澳县',
  '442325': '广东省潮阳县',
  '442326': '广东省揭阳县',
  '442327': '广东省揭西县',
  '442328': '广东省普宁县',
  '442329': '广东省惠来县',
  '442330': '广东省陆丰县',
  '442331': '广东省海丰县',
  '442400': '广东省梅县地区',
  '442401': '广东省梅县市',
  '442421': '广东省梅县',
  '442422': '广东省大埔县',
  '442423': '广东省丰顺县',
  '442424': '广东省五华县',
  '442425': '广东省兴宁县',
  '442426': '广东省平远县',
  '442427': '广东省蕉岭县',
  '442500': '广东省惠阳地区',
  '442501': '广东省惠州市',
  '442502': '广东省东莞市',
  '442521': '广东省惠阳县',
  '442522': '广东省紫金县',
  '442523': '广东省和平县',
  '442524': '广东省连平县',
  '442525': '广东省河源县',
  '442526': '广东省博罗县',
  '442527': '广东省东莞县',
  '442528': '广东省惠东县',
  '442529': '广东省龙川县',
  '442530': '广东省陆丰县',
  '442531': '广东省海丰县',
  '442600': '广东省韶关地区',
  '442621': '广东省始兴县',
  '442622': '广东省南雄县',
  '442623': '广东省仁化县',
  '442624': '广东省乐昌县',
  '442625': '广东省连县',
  '442626': '广东省阳山县',
  '442627': '广东省英德县',
  '442628': '广东省清远县',
  '442629': '广东省佛冈县',
  '442630': '广东省翁源县',
  '442631': '广东省连山壮族瑶族自治县',
  '442632': '广东省连南瑶族自治县',
  '442633': '广东省乳源瑶族自治县',
  '442700': '广东省佛山地区',
  '442701': '广东省佛山市',
  '442702': '广东省江门市',
  '442721': '广东省三水县',
  '442722': '广东省南海县',
  '442723': '广东省顺德县',
  '442724': '广东省中山县',
  '442725': '广东省斗门县',
  '442726': '广东省新会县',
  '442727': '广东省台山县',
  '442728': '广东省恩平县',
  '442729': '广东省开平县',
  '442731': '广东省鹤山县',
  '442732': '广东省高明县',
  '442800': '广东省肇庆地区',
  '442801': '广东省肇庆市',
  '442821': '广东省高要县',
  '442822': '广东省四会县',
  '442823': '广东省广宁县',
  '442824': '广东省怀集县',
  '442825': '广东省封开县',
  '442826': '广东省德庆县',
  '442827': '广东省云浮县',
  '442828': '广东省新兴县',
  '442829': '广东省郁南县',
  '442830': '广东省罗定县',
  '442900': '广东省湛江地区',
  '442901': '广东省湛江市',
  '442902': '广东省茂名市',
  '442921': '广东省阳江县',
  '442922': '广东省阳春县',
  '442923': '广东省信宜县',
  '442924': '广东省高州县',
  '442925': '广东省电白县',
  '442926': '广东省吴川县',
  '442927': '广东省化州县',
  '442928': '广东省廉江县',
  '442929': '广东省遂溪县',
  '442930': '广东省海康县',
  '442931': '广东省徐闻县',
  '445100': '广东省潮州市',
  '445101': '广东省潮州市市辖区',
  '445102': '广东省潮州市湘桥区',
  '445121': '广东省潮安县',
  '445122': '广东省饶平县',
  '445200': '广东省揭阳市',
  '445201': '广东省揭阳市市辖区',
  '445202': '广东省揭阳市榕城区',
  '445221': '广东省揭东县',
  '445222': '广东省揭西县',
  '445224': '广东省惠来县',
  '445281': '广东省普宁市',
  '445300': '广东省云浮市',
  '445301': '广东省云浮市市辖区',
  '445302': '广东省云浮市云城区',
  '445321': '广东省新兴县',
  '445322': '广东省郁南县',
  '445323': '广东省云安县',
  '445381': '广东省罗定市',
  '449000': '广东省省直辖行政单位',
  '449001': '广东省潮州市',
  '450000': '广西壮族自治区',
  '450100': '广西壮族自治区南宁市',
  '450101': '广西壮族自治区南宁市市辖区',
  '450102': '广西壮族自治区南宁市兴宁区',
  '450103': '广西壮族自治区南宁市青秀区',
  '450104': '广西壮族自治区南宁市城北区',
  '450105': '广西壮族自治区南宁市江南区',
  '450106': '广西壮族自治区南宁市永新区',
  '450107': '广西壮族自治区南宁市西乡塘区',
  '450108': '广西壮族自治区南宁市良庆区',
  '450109': '广西壮族自治区南宁市邕宁区',
  '450111': '广西壮族自治区南宁市市郊区',
  '450121': '广西壮族自治区邕宁县',
  '450122': '广西壮族自治区武鸣县',
  '450123': '广西壮族自治区隆安县',
  '450124': '广西壮族自治区马山县',
  '450125': '广西壮族自治区上林县',
  '450126': '广西壮族自治区宾阳县',
  '450127': '广西壮族自治区横县',
  '450200': '广西壮族自治区柳州市',
  '450201': '广西壮族自治区柳州市市辖区',
  '450202': '广西壮族自治区柳州市城中区',
  '450203': '广西壮族自治区柳州市鱼峰区',
  '450204': '广西壮族自治区柳州市柳南区',
  '450205': '广西壮族自治区柳州市柳北区',
  '450211': '广西壮族自治区柳州市市郊区',
  '450221': '广西壮族自治区柳江县',
  '450222': '广西壮族自治区柳城县',
  '450223': '广西壮族自治区鹿寨县',
  '450224': '广西壮族自治区融安县',
  '450225': '广西壮族自治区融水苗族自治县',
  '450226': '广西壮族自治区三江侗族自治县',
  '450300': '广西壮族自治区桂林市',
  '450301': '广西壮族自治区桂林市市辖区',
  '450302': '广西壮族自治区桂林市秀峰区',
  '450303': '广西壮族自治区桂林市叠彩区',
  '450304': '广西壮族自治区桂林市象山区',
  '450305': '广西壮族自治区桂林市七星区',
  '450311': '广西壮族自治区桂林市雁山区',
  '450321': '广西壮族自治区阳朔县',
  '450322': '广西壮族自治区临桂县',
  '450323': '广西壮族自治区灵川县',
  '450324': '广西壮族自治区全州县',
  '450325': '广西壮族自治区兴安县',
  '450326': '广西壮族自治区永福县',
  '450327': '广西壮族自治区灌阳县',
  '450328': '广西壮族自治区龙胜各族自治县',
  '450329': '广西壮族自治区资源县',
  '450330': '广西壮族自治区平乐县',
  '450331': '广西壮族自治区荔蒲县',
  '450332': '广西壮族自治区恭城瑶族自治县',
  '450400': '广西壮族自治区梧州市',
  '450401': '广西壮族自治区梧州市市辖区',
  '450403': '广西壮族自治区梧州市万秀区',
  '450404': '广西壮族自治区梧州市蝶山区',
  '450405': '广西壮族自治区梧州市长洲区',
  '450411': '广西壮族自治区梧州市市郊区',
  '450421': '广西壮族自治区苍梧县',
  '450422': '广西壮族自治区藤县',
  '450423': '广西壮族自治区蒙山县',
  '450481': '广西壮族自治区岑溪市',
  '450500': '广西壮族自治区北海市',
  '450501': '广西壮族自治区北海市市辖区',
  '450502': '广西壮族自治区北海市海城区',
  '450503': '广西壮族自治区北海市银海区',
  '450512': '广西壮族自治区北海市铁山港区',
  '450521': '广西壮族自治区合浦县',
  '450600': '广西壮族自治区防城港市',
  '450601': '广西壮族自治区防城港市市辖区',
  '450602': '广西壮族自治区防城港市港口区',
  '450603': '广西壮族自治区防城港市防城区',
  '450621': '广西壮族自治区上思县',
  '450681': '广西壮族自治区东兴市',
  '450700': '广西壮族自治区钦州市',
  '450701': '广西壮族自治区钦州市市辖区',
  '450702': '广西壮族自治区钦州市钦南区',
  '450703': '广西壮族自治区钦州市钦北区',
  '450721': '广西壮族自治区灵山县',
  '450722': '广西壮族自治区浦北县',
  '450800': '广西壮族自治区贵港市',
  '450801': '广西壮族自治区贵港市市辖区',
  '450802': '广西壮族自治区贵港市港北区',
  '450803': '广西壮族自治区贵港市港南区',
  '450804': '广西壮族自治区贵港市覃塘区',
  '450821': '广西壮族自治区平南县',
  '450881': '广西壮族自治区桂平市',
  '450900': '广西壮族自治区玉林市',
  '450901': '广西壮族自治区玉林市市辖区',
  '450902': '广西壮族自治区玉林市玉州区',
  '450921': '广西壮族自治区容县',
  '450922': '广西壮族自治区陆川县',
  '450923': '广西壮族自治区博白县',
  '450924': '广西壮族自治区兴业县',
  '450981': '广西壮族自治区北流市',
  '451000': '广西壮族自治区百色市',
  '451001': '广西壮族自治区百色市市辖区',
  '451002': '广西壮族自治区百色市右江区',
  '451021': '广西壮族自治区田阳县',
  '451022': '广西壮族自治区田东县',
  '451023': '广西壮族自治区平果县',
  '451024': '广西壮族自治区德保县',
  '451025': '广西壮族自治区靖西县',
  '451026': '广西壮族自治区那坡县',
  '451027': '广西壮族自治区凌云县',
  '451028': '广西壮族自治区乐业县',
  '451029': '广西壮族自治区田林县',
  '451030': '广西壮族自治区西林县',
  '451031': '广西壮族自治区隆林各族自治县',
  '451100': '广西壮族自治区贺州市',
  '451101': '广西壮族自治区贺州市市辖区',
  '451102': '广西壮族自治区贺州市八步区',
  '451121': '广西壮族自治区昭平县',
  '451122': '广西壮族自治区钟山县',
  '451123': '广西壮族自治区富川瑶族自治县',
  '451200': '广西壮族自治区河池市',
  '451201': '广西壮族自治区河池市市辖区',
  '451202': '广西壮族自治区河池市金城江区',
  '451221': '广西壮族自治区南丹县',
  '451222': '广西壮族自治区天峨县',
  '451223': '广西壮族自治区凤山县',
  '451224': '广西壮族自治区东兰县',
  '451225': '广西壮族自治区罗城仫佬族自治县',
  '451226': '广西壮族自治区环江毛南族自治县',
  '451227': '广西壮族自治区巴马瑶族自治县',
  '451228': '广西壮族自治区都安瑶族自治县',
  '451229': '广西壮族自治区大化瑶族自治县',
  '451281': '广西壮族自治区宜州市',
  '451300': '广西壮族自治区来宾市',
  '451301': '广西壮族自治区来宾市市辖区',
  '451302': '广西壮族自治区来宾市兴宾区',
  '451321': '广西壮族自治区忻城县',
  '451322': '广西壮族自治区象州县',
  '451323': '广西壮族自治区武宣县',
  '451324': '广西壮族自治区金秀瑶族自治县',
  '451381': '广西壮族自治区合山市',
  '451400': '广西壮族自治区崇左市',
  '451401': '广西壮族自治区崇左市市辖区',
  '451402': '广西壮族自治区崇左市江洲区',
  '451421': '广西壮族自治区扶绥县',
  '451422': '广西壮族自治区宁明县',
  '451423': '广西壮族自治区龙州县',
  '451424': '广西壮族自治区大新县',
  '451425': '广西壮族自治区天等县',
  '451481': '广西壮族自治区凭祥市',
  '452100': '广西壮族自治区南宁地区',
  '452101': '广西壮族自治区凭祥市',
  '452122': '广西壮族自治区横县',
  '452123': '广西壮族自治区宾阳县',
  '452124': '广西壮族自治区上林县',
  '452126': '广西壮族自治区隆安县',
  '452127': '广西壮族自治区马山县',
  '452128': '广西壮族自治区扶绥县',
  '452129': '广西壮族自治区崇左县',
  '452130': '广西壮族自治区大新县',
  '452131': '广西壮族自治区天等县',
  '452132': '广西壮族自治区宁明县',
  '452133': '广西壮族自治区龙州县',
  '452200': '广西壮族自治区柳州地区',
  '452201': '广西壮族自治区合山市',
  '452223': '广西壮族自治区鹿寨县',
  '452224': '广西壮族自治区象州县',
  '452225': '广西壮族自治区武宣县',
  '452226': '广西壮族自治区来宾县',
  '452227': '广西壮族自治区融安县',
  '452228': '广西壮族自治区三江侗族自治县',
  '452229': '广西壮族自治区融水苗族自治县',
  '452230': '广西壮族自治区金秀瑶族自治县',
  '452231': '广西壮族自治区忻城县',
  '452400': '广西壮族自治区贺州地区',
  '452402': '广西壮族自治区贺州市',
  '452424': '广西壮族自治区昭平县',
  '452427': '广西壮族自治区钟山县',
  '452428': '广西壮族自治区富川瑶族自治县',
  '452600': '广西壮族自治区百色地区',
  '452601': '广西壮族自治区百色市',
  '452622': '广西壮族自治区田阳县',
  '452623': '广西壮族自治区田东县',
  '452624': '广西壮族自治区平果县',
  '452625': '广西壮族自治区德保县',
  '452626': '广西壮族自治区靖西县',
  '452627': '广西壮族自治区那坡县',
  '452628': '广西壮族自治区凌云县',
  '452629': '广西壮族自治区乐业县',
  '452630': '广西壮族自治区田林县',
  '452631': '广西壮族自治区隆林各族自治县',
  '452632': '广西壮族自治区西林县',
  '452700': '广西壮族自治区河池地区',
  '452701': '广西壮族自治区河池市',
  '452702': '广西壮族自治区宜州市',
  '452723': '广西壮族自治区罗城仫佬族自治县',
  '452724': '广西壮族自治区环江毛南族自治县',
  '452725': '广西壮族自治区南丹县',
  '452726': '广西壮族自治区天峨县',
  '452727': '广西壮族自治区凤山县',
  '452728': '广西壮族自治区东兰县',
  '452729': '广西壮族自治区巴马瑶族自治县',
  '452730': '广西壮族自治区都安瑶族自治县',
  '452731': '广西壮族自治区大化瑶族自治县',
  '460000': '海南省',
  '460001': '海南省通什市',
  '460002': '海南省琼海市',
  '460003': '海南省儋州市',
  '460004': '海南省琼山市',
  '460005': '海南省文昌市',
  '460006': '海南省万宁市',
  '460007': '海南省东方市',
  '460021': '海南省琼山县',
  '460022': '海南省文昌县',
  '460023': '海南省琼海县',
  '460024': '海南省万宁县',
  '460025': '海南省定安县',
  '460026': '海南省屯昌县',
  '460027': '海南省澄迈县',
  '460028': '海南省临高县',
  '460029': '海南省儋县',
  '460030': '海南省白沙黎族自治县',
  '460031': '海南省昌江黎族自治县',
  '460032': '海南省东方黎族自治县',
  '460033': '海南省乐东黎族自治县',
  '460034': '海南省陵水黎族自治县',
  '460035': '海南省保亭黎族苗族自治县',
  '460036': '海南省琼中黎族苗族自治县',
  '460037': '海南省西沙群岛',
  '460038': '海南省南沙群岛',
  '460039': '海南省中沙群岛的岛礁及其海域',
  '460100': '海南省海口市',
  '460101': '海南省海口市市辖区',
  '460102': '海南省海口市振东区',
  '460103': '海南省海口市新华区',
  '460104': '海南省海口市秀英区',
  '460105': '海南省海口市秀英区',
  '460106': '海南省海口市龙华区',
  '460107': '海南省海口市琼山区',
  '460108': '海南省海口市美兰区',
  '460200': '海南省三亚市',
  '460201': '海南省三亚市市辖区',
  '460300': '海南省洋浦经济开发区',
  '469001': '海南省五指山市',
  '469002': '海南省琼海市',
  '469003': '海南省儋州市',
  '469004': '海南省琼山市',
  '469005': '海南省文昌市',
  '469006': '海南省万宁市',
  '469007': '海南省东方市',
  '469021': '海南省定安县',
  '469022': '海南省屯昌县',
  '469023': '海南省澄迈县',
  '469024': '海南省临高县',
  '469025': '海南省白沙黎族自治县',
  '469026': '海南省昌江黎族自治县',
  '469027': '海南省乐东黎族自治县',
  '469028': '海南省陵水黎族自治县',
  '469029': '海南省保亭黎族苗族自治县',
  '469030': '海南省琼中黎族苗族自治县',
  '469031': '海南省西沙群岛',
  '469032': '海南省南沙群岛',
  '469033': '海南省中沙群岛的岛礁及其海域',
  '500000': '重庆市',
  '500100': '重庆市市辖区',
  '500101': '重庆市万州区',
  '500102': '重庆市涪陵区',
  '500103': '重庆市渝中区',
  '500104': '重庆市大渡口区',
  '500105': '重庆市江北区',
  '500106': '重庆市沙坪坝区',
  '500107': '重庆市九龙坡区',
  '500108': '重庆市南岸区',
  '500109': '重庆市北碚区',
  '500110': '重庆市万盛区',
  '500111': '重庆市双桥区',
  '500112': '重庆市渝北区',
  '500113': '重庆市巴南区',
  '500114': '重庆市黔江区',
  '500115': '重庆市长寿区',
  '500221': '重庆市长寿县',
  '500222': '重庆市綦江县',
  '500223': '重庆市潼南县',
  '500224': '重庆市铜梁县',
  '500225': '重庆市大足县',
  '500226': '重庆市荣昌县',
  '500227': '重庆市璧山县',
  '500228': '重庆市梁平县',
  '500229': '重庆市城口县',
  '500230': '重庆市丰都县',
  '500231': '重庆市垫江县',
  '500232': '重庆市武隆县',
  '500233': '重庆市忠县',
  '500234': '重庆市开县',
  '500235': '重庆市云阳县',
  '500236': '重庆市奉节县',
  '500237': '重庆市巫山县',
  '500238': '重庆市巫溪县',
  '500239': '重庆市黔江土家族苗族自治县',
  '500240': '重庆市石柱土家族自治县',
  '500241': '重庆市秀山土家族苗族自治县',
  '500242': '重庆市酉阳土家族苗族自治县',
  '500243': '重庆市彭水苗族土家族自治县',
  '500381': '重庆市江津市',
  '500382': '重庆市合川市',
  '500383': '重庆市永川市',
  '500384': '重庆市南川市',
  '510000': '四川省',
  '510100': '四川省成都市',
  '510101': '四川省成都市市辖区',
  '510102': '四川省成都市东城区',
  '510103': '四川省成都市西城区',
  '510104': '四川省成都市锦江区',
  '510105': '四川省成都市青羊区',
  '510106': '四川省成都市金牛区',
  '510107': '四川省成都市武侯区',
  '510108': '四川省成都市成华区',
  '510111': '四川省成都市金牛区',
  '510112': '四川省成都市龙泉驿区',
  '510113': '四川省成都市青白江区',
  '510114': '四川省成都市新都区',
  '510115': '四川省成都市温江区',
  '510120': '四川省成都市区',
  '510121': '四川省金堂县',
  '510122': '四川省双流县',
  '510123': '四川省温江县',
  '510124': '四川省郫县',
  '510125': '四川省新都县',
  '510126': '四川省彭县',
  '510127': '四川省灌县',
  '510128': '四川省崇庆县',
  '510129': '四川省大邑县',
  '510130': '四川省邛崃县',
  '510131': '四川省蒲江县',
  '510132': '四川省新津县',
  '510181': '四川省都江堰市',
  '510182': '四川省彭州市',
  '510183': '四川省邛崃市',
  '510184': '四川省崇州市',
  '510200': '四川省重庆市',
  '510201': '四川省重庆市市辖区',
  '510202': '四川省重庆市市中区',
  '510203': '四川省重庆市大渡口区',
  '510211': '四川省重庆市江北区',
  '510212': '四川省重庆市沙平坝区',
  '510213': '四川省重庆市九龙坡区',
  '510214': '四川省重庆市南岸区',
  '510215': '四川省重庆市北碚区',
  '510216': '四川省重庆市万盛区(南桐矿区)',
  '510217': '四川省重庆市双桥区',
  '510220': '四川省重庆市区',
  '510221': '四川省长寿县',
  '510222': '四川省巴县',
  '510223': '四川省綦江县',
  '510224': '四川省江北县',
  '510225': '四川省江津县',
  '510226': '四川省合川县',
  '510227': '四川省潼南县',
  '510228': '四川省铜梁县',
  '510229': '四川省永川县',
  '510230': '四川省大足县',
  '510231': '四川省荣昌县',
  '510232': '四川省璧山县',
  '510281': '四川省永川市',
  '510282': '四川省江津市',
  '510283': '四川省合川市',
  '510300': '四川省自贡市',
  '510301': '四川省自贡市市辖区',
  '510302': '四川省自贡市自流井区',
  '510303': '四川省自贡市贡井区',
  '510304': '四川省自贡市大安区',
  '510311': '四川省自贡市沿滩区',
  '510320': '四川省自贡市区',
  '510321': '四川省荣县',
  '510322': '四川省富顺县',
  '510400': '四川省攀枝花市',
  '510401': '四川省攀枝花市市辖区',
  '510402': '四川省攀枝花市东区',
  '510403': '四川省攀枝花市西区',
  '510411': '四川省攀枝花市仁和区',
  '510420': '四川省渡口市区',
  '510421': '四川省米易县',
  '510422': '四川省盐边县',
  '510500': '四川省泸州市',
  '510501': '四川省泸州市市辖区',
  '510502': '四川省泸州市江阳区',
  '510503': '四川省泸州市纳溪区',
  '510504': '四川省泸州市龙马潭区',
  '510521': '四川省泸县',
  '510522': '四川省合江县',
  '510523': '四川省纳溪县',
  '510524': '四川省叙永县',
  '510525': '四川省古蔺县',
  '510600': '四川省德阳市',
  '510601': '四川省德阳市市辖区',
  '510602': '四川省德阳市市中区',
  '510603': '四川省德阳市旌阳区',
  '510621': '四川省德阳县',
  '510622': '四川省绵竹县',
  '510623': '四川省中江县',
  '510624': '四川省广汉县',
  '510625': '四川省什邡县',
  '510626': '四川省罗江县',
  '510681': '四川省广汉市',
  '510682': '四川省什邡市',
  '510683': '四川省绵竹市',
  '510700': '四川省绵阳市',
  '510701': '四川省绵阳市市辖区',
  '510702': '四川省绵阳市市中区',
  '510703': '四川省绵阳市涪城区',
  '510704': '四川省绵阳市游仙区',
  '510721': '四川省江油县',
  '510722': '四川省三台县',
  '510723': '四川省盐亭县',
  '510724': '四川省安县',
  '510725': '四川省梓潼县',
  '510726': '四川省北川羌族自治县',
  '510727': '四川省平武县',
  '510781': '四川省江油市',
  '510800': '四川省广元市',
  '510801': '四川省广元市市辖区',
  '510802': '四川省广元市市中区',
  '510811': '四川省广元市元坝区',
  '510812': '四川省广元市朝天区',
  '510821': '四川省旺苍县',
  '510822': '四川省青川县',
  '510823': '四川省剑阁县',
  '510824': '四川省苍溪县',
  '510900': '四川省遂宁市',
  '510901': '四川省遂宁市市辖区',
  '510902': '四川省遂宁市市中区',
  '510903': '四川省遂宁市船山区',
  '510904': '四川省遂宁市安居区',
  '510921': '四川省蓬溪县',
  '510922': '四川省射洪县',
  '510923': '四川省大英县',
  '511000': '四川省内江市',
  '511001': '四川省内江市市辖区',
  '511002': '四川省内江市市中区',
  '511011': '四川省内江市东兴区',
  '511021': '四川省内江县',
  '511022': '四川省乐至县',
  '511023': '四川省安岳县',
  '511024': '四川省威远县',
  '511025': '四川省资中县',
  '511026': '四川省资阳县',
  '511027': '四川省简阳县',
  '511028': '四川省隆昌县',
  '511081': '四川省资阳市',
  '511082': '四川省简阳市',
  '511100': '四川省乐山市',
  '511101': '四川省乐山市市辖区',
  '511102': '四川省乐山市市中区',
  '511111': '四川省乐山市沙湾区',
  '511112': '四川省乐山市五通桥区',
  '511113': '四川省乐山市金口河区',
  '511121': '四川省仁寿县',
  '511122': '四川省眉山县',
  '511123': '四川省犍为县',
  '511124': '四川省井研县',
  '511125': '四川省峨眉县',
  '511126': '四川省夹江县',
  '511127': '四川省洪雅县',
  '511128': '四川省彭山县',
  '511129': '四川省沐川县',
  '511130': '四川省青神县',
  '511131': '四川省丹棱县',
  '511132': '四川省峨边彝族自治县',
  '511133': '四川省马边彝族自治县',
  '511181': '四川省峨眉山市',
  '511200': '四川省万县市',
  '511201': '四川省万县市市辖区',
  '511202': '四川省万县市龙宝区',
  '511203': '四川省万县市天城区',
  '511204': '四川省万县市五桥区',
  '511221': '四川省开县',
  '511222': '四川省忠县',
  '511223': '四川省梁平县',
  '511224': '四川省云阳县',
  '511225': '四川省奉节县',
  '511226': '四川省巫山县',
  '511227': '四川省巫溪县',
  '511228': '四川省城口县',
  '511300': '四川省南充市',
  '511301': '四川省南充市市辖区',
  '511302': '四川省南充市顺庆区',
  '511303': '四川省南充市高坪区',
  '511304': '四川省南充市嘉陵区',
  '511321': '四川省南部县',
  '511322': '四川省营山县',
  '511323': '四川省蓬安县',
  '511324': '四川省仪陇县',
  '511325': '四川省西充县',
  '511381': '四川省阆中市',
  '511400': '四川省眉山市',
  '511401': '四川省眉山市市辖区',
  '511402': '四川省眉山市东坡区',
  '511421': '四川省仁寿县',
  '511422': '四川省彭山县',
  '511423': '四川省洪雅县',
  '511424': '四川省丹棱县',
  '511425': '四川省青神县',
  '511500': '四川省宜宾市',
  '511501': '四川省宜宾市市辖区',
  '511502': '四川省宜宾市翠屏区',
  '511521': '四川省宜宾县',
  '511522': '四川省南溪县',
  '511523': '四川省江安县',
  '511524': '四川省长宁县',
  '511525': '四川省高县',
  '511526': '四川省珙县',
  '511527': '四川省筠连县',
  '511528': '四川省兴文县',
  '511529': '四川省屏山县',
  '511600': '四川省广安市',
  '511601': '四川省广安市市辖区',
  '511602': '四川省广安市广安区',
  '511621': '四川省岳池县',
  '511622': '四川省武胜县',
  '511623': '四川省邻水县',
  '511681': '四川省华莹市',
  '511700': '四川省达州市',
  '511701': '四川省达州市市辖区',
  '511702': '四川省达州市通川区',
  '511721': '四川省达县',
  '511722': '四川省宣汉县',
  '511723': '四川省开江县',
  '511724': '四川省大竹县',
  '511725': '四川省渠县',
  '511781': '四川省万源市',
  '511800': '四川省雅安市',
  '511801': '四川省雅安市市辖区',
  '511802': '四川省雅安市雨城区',
  '511821': '四川省名山县',
  '511822': '四川省荥经县',
  '511823': '四川省汉源县',
  '511824': '四川省石棉县',
  '511825': '四川省天全县',
  '511826': '四川省芦山县',
  '511827': '四川省宝兴县',
  '511900': '四川省巴中市',
  '511901': '四川省巴中市市辖区',
  '511902': '四川省巴中市巴州区',
  '511921': '四川省通江县',
  '511922': '四川省南江县',
  '511923': '四川省平昌县',
  '512000': '四川省资阳市',
  '512001': '四川省资阳市市辖区',
  '512002': '四川省资阳市雁江区',
  '512021': '四川省安岳县',
  '512022': '四川省乐至县',
  '512081': '四川省简阳市',
  '512100': '四川省永川地区',
  '512121': '四川省江津县',
  '512122': '四川省合川县',
  '512123': '四川省潼南县',
  '512124': '四川省铜梁县',
  '512125': '四川省永川县',
  '512126': '四川省大足县',
  '512127': '四川省荣昌县',
  '512128': '四川省璧山县',
  '512200': '四川省万县地区',
  '512201': '四川省万县市',
  '512221': '四川省万县',
  '512222': '四川省开县',
  '512223': '四川省忠县',
  '512224': '四川省梁平县',
  '512225': '四川省云阳县',
  '512226': '四川省奉节县',
  '512227': '四川省巫山县',
  '512228': '四川省巫溪县',
  '512229': '四川省城口县',
  '512300': '四川省涪陵地区',
  '512301': '四川省涪陵市',
  '512321': '四川省涪陵县',
  '512322': '四川省垫江县',
  '512323': '四川省南川县',
  '512324': '四川省丰都县',
  '512325': '四川省石柱土家族自治县',
  '512326': '四川省武隆县',
  '512327': '四川省彭水苗族土家族自治县',
  '512328': '四川省黔江土家族苗族自治县',
  '512329': '四川省酉阳土家族苗族自治县',
  '512330': '四川省秀山土家族苗族自治县',
  '512400': '四川省内江地区',
  '512401': '四川省内江市',
  '512421': '四川省内江县',
  '512422': '四川省资中县',
  '512423': '四川省资阳县',
  '512424': '四川省简阳县',
  '512425': '四川省威远县',
  '512426': '四川省隆昌县',
  '512427': '四川省安岳县',
  '512428': '四川省乐至县',
  '512500': '四川省宜宾地区',
  '512501': '四川省宜宾市',
  '512502': '四川省泸州市',
  '512521': '四川省泸县',
  '512522': '四川省富顺县',
  '512523': '四川省合江县',
  '512524': '四川省纳溪县',
  '512525': '四川省叙永县',
  '512526': '四川省古蔺县',
  '512527': '四川省宜宾县',
  '512528': '四川省南溪县',
  '512529': '四川省江安县',
  '512530': '四川省长宁县',
  '512531': '四川省高县',
  '512532': '四川省筠连县',
  '512533': '四川省珙县',
  '512534': '四川省兴文县',
  '512535': '四川省屏山县',
  '512600': '四川省乐山地区',
  '512601': '四川省乐山市',
  '512621': '四川省仁寿县',
  '512622': '四川省眉山县',
  '512623': '四川省犍为县',
  '512624': '四川省井研县',
  '512625': '四川省峨眉县',
  '512626': '四川省夹江县',
  '512627': '四川省洪雅县',
  '512628': '四川省彭山县',
  '512629': '四川省沐川县',
  '512630': '四川省青神县',
  '512631': '四川省丹棱县',
  '512632': '四川省峨边彝族自治县',
  '512633': '四川省马边彝族自治县',
  '512634': '四川省金口河工农区',
  '512700': '四川省温江地区',
  '512721': '四川省温江县',
  '512722': '四川省郫县',
  '512723': '四川省新都县',
  '512724': '四川省广汉县',
  '512725': '四川省什邡县',
  '512726': '四川省彭县',
  '512727': '四川省灌县',
  '512728': '四川省崇庆县',
  '512729': '四川省大邑县',
  '512730': '四川省邛崃县',
  '512731': '四川省蒲江县',
  '512732': '四川省新津县',
  '512800': '四川省绵阳地区',
  '512801': '四川省绵阳市',
  '512821': '四川省德阳县',
  '512822': '四川省绵竹县',
  '512823': '四川省安县',
  '512824': '四川省江油县',
  '512825': '四川省梓潼县',
  '512826': '四川省剑阁县',
  '512827': '四川省广元县',
  '512828': '四川省旺苍县',
  '512829': '四川省青川县',
  '512830': '四川省平武县',
  '512831': '四川省北川县',
  '512832': '四川省遂宁县',
  '512833': '四川省三台县',
  '512834': '四川省中江县',
  '512835': '四川省蓬溪县',
  '512836': '四川省射洪县',
  '512837': '四川省盐亭县',
  '512900': '四川省南充地区',
  '512901': '四川省南充市',
  '512902': '四川省华蓥市',
  '512903': '四川省阆中市',
  '512921': '四川省南充县',
  '512922': '四川省南部县',
  '512923': '四川省岳池县',
  '512924': '四川省营山县',
  '512925': '四川省广安县',
  '512926': '四川省蓬安县',
  '512927': '四川省仪陇县',
  '512928': '四川省武胜县',
  '512929': '四川省西充县',
  '512930': '四川省阆中县',
  '512931': '四川省苍溪县',
  '512932': '四川省华云工农区',
  '513000': '四川省达川地区',
  '513001': '四川省达川市',
  '513002': '四川省万源市',
  '513021': '四川省达县',
  '513022': '四川省宣汉县',
  '513023': '四川省开江县',
  '513024': '四川省万源县',
  '513025': '四川省通江县',
  '513026': '四川省南江县',
  '513027': '四川省巴中县',
  '513028': '四川省平昌县',
  '513029': '四川省大竹县',
  '513030': '四川省渠县',
  '513031': '四川省邻水县',
  '513032': '四川省白沙工农区',
  '513100': '四川省雅安地区',
  '513101': '四川省雅安市',
  '513121': '四川省雅安县',
  '513122': '四川省名山县',
  '513123': '四川省荥经县',
  '513124': '四川省汉源县',
  '513125': '四川省石棉县',
  '513126': '四川省天全县',
  '513127': '四川省芦山县',
  '513128': '四川省宝兴县',
  '513200': '四川省阿坝藏族羌族自治州',
  '513221': '四川省汶川县',
  '513222': '四川省理县',
  '513223': '四川省茂县',
  '513224': '四川省松潘县',
  '513225': '四川省九寨沟县',
  '513226': '四川省金川县',
  '513227': '四川省小金县',
  '513228': '四川省黑水县',
  '513229': '四川省马尔康县',
  '513230': '四川省壤塘县',
  '513231': '四川省阿坝县',
  '513232': '四川省若尔盖县',
  '513233': '四川省红原县',
  '513300': '四川省甘孜藏族自治州',
  '513321': '四川省康定县',
  '513322': '四川省泸定县',
  '513323': '四川省丹巴县',
  '513324': '四川省九龙县',
  '513325': '四川省雅江县',
  '513326': '四川省道孚县',
  '513327': '四川省炉霍县',
  '513328': '四川省甘孜县',
  '513329': '四川省新龙县',
  '513330': '四川省德格县',
  '513331': '四川省白玉县',
  '513332': '四川省石渠县',
  '513333': '四川省色达县',
  '513334': '四川省理塘县',
  '513335': '四川省巴塘县',
  '513336': '四川省乡城县',
  '513337': '四川省稻城县',
  '513338': '四川省得荣县',
  '513400': '四川省凉山彝族自治州',
  '513401': '四川省西昌市',
  '513421': '四川省西昌县',
  '513422': '四川省木里藏族自治县',
  '513423': '四川省盐源县',
  '513424': '四川省德昌县',
  '513425': '四川省会理县',
  '513426': '四川省会东县',
  '513427': '四川省宁南县',
  '513428': '四川省普格县',
  '513429': '四川省布拖县',
  '513430': '四川省金阳县',
  '513431': '四川省昭觉县',
  '513432': '四川省喜德县',
  '513433': '四川省冕宁县',
  '513434': '四川省越西县',
  '513435': '四川省甘洛县',
  '513436': '四川省美姑县',
  '513437': '四川省雷波县',
  '513500': '四川省黔江地区',
  '513521': '四川省石柱土家族自治县',
  '513522': '四川省秀山土家族苗族自治县',
  '513523': '四川省黔江土家族苗族自治县',
  '513524': '四川省酉阳土家族苗族自治县',
  '513525': '四川省彭水苗族土家族自治县',
  '513600': '四川省广安地区',
  '513601': '四川省华蓥市',
  '513621': '四川省岳池县',
  '513622': '四川省广安县',
  '513623': '四川省武胜县',
  '513624': '四川省邻水县',
  '513700': '四川省巴中地区',
  '513701': '四川省巴中市',
  '513721': '四川省通江县',
  '513722': '四川省南江县',
  '513723': '四川省平昌县',
  '513800': '四川省眉山地区',
  '513821': '四川省眉山县',
  '513822': '四川省仁寿县',
  '513823': '四川省彭山县',
  '513824': '四川省洪雅县',
  '513825': '四川省丹棱县',
  '513826': '四川省青神县',
  '513900': '四川省资阳地区',
  '513901': '四川省资阳市',
  '513902': '四川省简阳市',
  '513921': '四川省安岳县',
  '513922': '四川省乐至县',
  '519000': '四川省直辖行政单位',
  '519001': '四川省广汉市',
  '519002': '四川省江油市',
  '519003': '四川省都江堰市',
  '519004': '四川省峨眉山市',
  '520000': '贵州省',
  '520100': '贵州省贵阳市',
  '520101': '贵州省贵阳市市辖区',
  '520102': '贵州省贵阳市南明区',
  '520103': '贵州省贵阳市云岩区',
  '520111': '贵州省贵阳市花溪区',
  '520112': '贵州省贵阳市乌当区',
  '520113': '贵州省贵阳市白云区',
  '520114': '贵州省贵阳市小河区',
  '520121': '贵州省开阳县',
  '520122': '贵州省息烽县',
  '520123': '贵州省修文县',
  '520181': '贵州省清镇市',
  '520200': '贵州省六盘水市',
  '520201': '贵州省六盘水市钟山区',
  '520202': '贵州省六盘水市盘县特区',
  '520203': '贵州省六盘水市六枝特区',
  '520204': '贵州省六盘水市六枝特区',
  '520221': '贵州省水城县',
  '520222': '贵州省盘县',
  '520300': '贵州省遵义市',
  '520301': '贵州省遵义市市辖区',
  '520302': '贵州省遵义市红花岗区',
  '520303': '贵州省遵义市汇川区',
  '520321': '贵州省遵义县',
  '520322': '贵州省桐梓县',
  '520323': '贵州省绥阳县',
  '520324': '贵州省正安县',
  '520325': '贵州省道真仡佬族苗族自治县',
  '520326': '贵州省务川仡佬族苗族自治县',
  '520327': '贵州省凤冈县',
  '520328': '贵州省湄潭县',
  '520329': '贵州省余庆县',
  '520330': '贵州省习水县',
  '520381': '贵州省赤水市',
  '520382': '贵州省仁怀市',
  '520400': '贵州省安顺市',
  '520401': '贵州省安顺市市辖区',
  '520402': '贵州省安顺市西秀区',
  '520421': '贵州省平坝县',
  '520422': '贵州省普定县',
  '520423': '贵州省镇宁布依族苗族自治县',
  '520424': '贵州省关岭布依族苗族自治县',
  '520425': '贵州省紫云苗族布依族自治县',
  '522100': '贵州省遵义地区',
  '522101': '贵州省遵义市',
  '522102': '贵州省赤水市',
  '522103': '贵州省仁怀市',
  '522121': '贵州省遵义县',
  '522122': '贵州省桐梓县',
  '522123': '贵州省绥阳县',
  '522124': '贵州省正安县',
  '522125': '贵州省道真仡佬族苗族自治县',
  '522126': '贵州省务川仡佬族苗族自治县',
  '522127': '贵州省凤冈县',
  '522128': '贵州省湄潭县',
  '522129': '贵州省余庆县',
  '522130': '贵州省仁怀县',
  '522131': '贵州省赤水县',
  '522132': '贵州省习水县',
  '522200': '贵州省铜仁地区',
  '522201': '贵州省铜仁市',
  '522221': '贵州省铜仁县',
  '522222': '贵州省江口县',
  '522223': '贵州省玉屏侗族自治县',
  '522224': '贵州省石阡县',
  '522225': '贵州省思南县',
  '522226': '贵州省印江土家族苗族自治县',
  '522227': '贵州省德江县',
  '522228': '贵州省沿河土家族自治县',
  '522229': '贵州省松桃苗族自治县',
  '522230': '贵州省万山特区',
  '522300': '贵州省黔西南布依族苗族自治州',
  '522301': '贵州省兴义市',
  '522321': '贵州省兴义县',
  '522322': '贵州省兴仁县',
  '522323': '贵州省普安县',
  '522324': '贵州省晴隆县',
  '522325': '贵州省贞丰县',
  '522326': '贵州省望谟县',
  '522327': '贵州省册亨县',
  '522328': '贵州省安龙县',
  '522400': '贵州省毕节地区',
  '522401': '贵州省毕节市',
  '522421': '贵州省毕节县',
  '522422': '贵州省大方县',
  '522423': '贵州省黔西县',
  '522424': '贵州省金沙县',
  '522425': '贵州省织金县',
  '522426': '贵州省纳雍县',
  '522427': '贵州省威宁彝族回族苗族自治县',
  '522428': '贵州省赫章县',
  '522500': '贵州省安顺地区',
  '522501': '贵州省安顺市',
  '522502': '贵州省清镇市',
  '522521': '贵州省安顺县',
  '522522': '贵州省开阳县',
  '522523': '贵州省息烽县',
  '522524': '贵州省修文县',
  '522525': '贵州省清镇县',
  '522526': '贵州省平坝县',
  '522527': '贵州省普定县',
  '522528': '贵州省关岭布依族苗族自治县',
  '522529': '贵州省镇宁布依族苗族自治县',
  '522530': '贵州省紫云苗族布依族自治县',
  '522600': '贵州省黔东南苗族侗族自治州',
  '522601': '贵州省凯里市',
  '522621': '贵州省凯里县',
  '522622': '贵州省黄平县',
  '522623': '贵州省施秉县',
  '522624': '贵州省三穗县',
  '522625': '贵州省镇远县',
  '522626': '贵州省岑巩县',
  '522627': '贵州省天柱县',
  '522628': '贵州省锦屏县',
  '522629': '贵州省剑河县',
  '522630': '贵州省台江县',
  '522631': '贵州省黎平县',
  '522632': '贵州省榕江县',
  '522633': '贵州省从江县',
  '522634': '贵州省雷山县',
  '522635': '贵州省麻江县',
  '522636': '贵州省丹寨县',
  '522700': '贵州省黔南布依族苗族自治州',
  '522701': '贵州省都匀市',
  '522702': '贵州省福泉市',
  '522721': '贵州省都匀县',
  '522722': '贵州省荔波县',
  '522723': '贵州省贵定县',
  '522724': '贵州省福泉县',
  '522725': '贵州省瓮安县',
  '522726': '贵州省独山县',
  '522727': '贵州省平塘县',
  '522728': '贵州省罗甸县',
  '522729': '贵州省长顺县',
  '522730': '贵州省龙里县',
  '522731': '贵州省惠水县',
  '522732': '贵州省三都水族自治县',
  '530000': '云南省',
  '530100': '云南省昆明市',
  '530101': '云南省昆明市市辖区',
  '530102': '云南省昆明市五华区',
  '530103': '云南省昆明市盘龙区',
  '530111': '云南省昆明市官渡区',
  '530112': '云南省昆明市西山区',
  '530113': '云南省昆明市东川区',
  '530120': '云南省昆明市区',
  '530121': '云南省呈贡县',
  '530122': '云南省晋宁县',
  '530123': '云南省安宁县',
  '530124': '云南省富民县',
  '530125': '云南省宜良县',
  '530126': '云南省石林彝族自治县',
  '530127': '云南省嵩明县',
  '530128': '云南省禄劝彝族苗族自治县',
  '530129': '云南省寻甸回族彝族自治县',
  '530181': '云南省安宁市',
  '530200': '云南省东川市',
  '530201': '云南省东川市市辖区',
  '530300': '云南省曲靖市',
  '530301': '云南省曲靖市市辖区',
  '530302': '云南省曲靖市麒麟区',
  '530321': '云南省马龙县',
  '530322': '云南省陆良县',
  '530323': '云南省师宗县',
  '530324': '云南省罗平县',
  '530325': '云南省富源县',
  '530326': '云南省会泽县',
  '530328': '云南省沾益县',
  '530381': '云南省宣威市',
  '530400': '云南省玉溪市',
  '530401': '云南省玉溪市市辖区',
  '530402': '云南省玉溪市红塔区',
  '530421': '云南省江川县',
  '530422': '云南省澄江县',
  '530423': '云南省通海县',
  '530424': '云南省华宁县',
  '530425': '云南省易门县',
  '530426': '云南省峨山彝族自治县',
  '530427': '云南省新平彝族傣族自治县',
  '530428': '云南省元江哈尼族彝族傣族自治县',
  '530500': '云南省保山市',
  '530501': '云南省保山市市辖区',
  '530502': '云南省保山市隆阳区',
  '530521': '云南省施甸县',
  '530522': '云南省腾冲县',
  '530523': '云南省龙陵县',
  '530524': '云南省昌宁县',
  '530600': '云南省昭通市',
  '530601': '云南省昭通市市辖区',
  '530602': '云南省昭通市昭阳区',
  '530621': '云南省鲁甸县',
  '530622': '云南省巧家县',
  '530623': '云南省盐津县',
  '530624': '云南省大关县',
  '530625': '云南省永善县',
  '530626': '云南省绥江县',
  '530627': '云南省镇雄县',
  '530628': '云南省彝良县',
  '530629': '云南省威信县',
  '530630': '云南省水富县',
  '530700': '云南省丽江市',
  '530701': '云南省丽江市市辖区',
  '530702': '云南省丽江市古城区',
  '530721': '云南省玉龙纳西族自治县',
  '530722': '云南省永胜县',
  '530723': '云南省华坪县',
  '530724': '云南省宁蒗彝族自治县',
  '530800': '云南省思茅市',
  '530801': '云南省思茅市市辖区',
  '530802': '云南省思茅市翠云区',
  '530821': '云南省普洱哈尼族彝族自治县',
  '530822': '云南省墨江哈尼族自治县',
  '530823': '云南省景东彝族自治县',
  '530824': '云南省景谷傣族彝族自治县',
  '530825': '云南省镇沅彝族哈尼族拉祜族自治县',
  '530826': '云南省江城哈尼族彝族自治县',
  '530827': '云南省孟连傣族拉祜族佤族自治县',
  '530828': '云南省澜沧拉祜族自治县',
  '530829': '云南省西盟佤族自治县',
  '530900': '云南省临沧市',
  '530901': '云南省临沧市市辖区',
  '530902': '云南省临沧市临翔区',
  '530921': '云南省凤庆县',
  '530922': '云南省云县',
  '530923': '云南省永德县',
  '530924': '云南省镇康县',
  '530925': '云南省双江拉祜族佤族布朗族傣族自治县',
  '530926': '云南省耿马傣族佤族自治县',
  '530927': '云南省沧源佤族自治县',
  '532100': '云南省昭通地区',
  '532101': '云南省昭通市',
  '532121': '云南省昭通县',
  '532122': '云南省鲁甸县',
  '532123': '云南省巧家县',
  '532124': '云南省盐津县',
  '532125': '云南省大关县',
  '532126': '云南省永善县',
  '532127': '云南省绥江县',
  '532128': '云南省镇雄县',
  '532129': '云南省彝良县',
  '532130': '云南省威信县',
  '532131': '云南省水富县',
  '532200': '云南省曲靖地区',
  '532201': '云南省曲靖市',
  '532202': '云南省宣威市',
  '532221': '云南省曲靖县',
  '532222': '云南省沾益县',
  '532223': '云南省马龙县',
  '532224': '云南省宣威县',
  '532225': '云南省富源县',
  '532226': '云南省罗平县',
  '532227': '云南省师宗县',
  '532228': '云南省陆良县',
  '532229': '云南省宜良县',
  '532230': '云南省路南彝族自治县',
  '532231': '云南省寻甸回族彝族自治县',
  '532232': '云南省嵩明县',
  '532233': '云南省会泽县',
  '532300': '云南省楚雄彝族自治州',
  '532301': '云南省楚雄市',
  '532321': '云南省楚雄县',
  '532322': '云南省双柏县',
  '532323': '云南省牟定县',
  '532324': '云南省南华县',
  '532325': '云南省姚安县',
  '532326': '云南省大姚县',
  '532327': '云南省永仁县',
  '532328': '云南省元谋县',
  '532329': '云南省武定县',
  '532330': '云南省禄劝县',
  '532331': '云南省禄丰县',
  '532400': '云南省玉溪地区',
  '532401': '云南省玉溪市',
  '532421': '云南省玉溪县',
  '532422': '云南省江川县',
  '532423': '云南省澄江县',
  '532424': '云南省通海县',
  '532425': '云南省华宁县',
  '532426': '云南省易门县',
  '532427': '云南省峨山彝族自治县',
  '532428': '云南省新平彝族傣族自治县',
  '532429': '云南省元江哈尼族彝族傣族自治县',
  '532500': '云南省红河哈尼族彝族自治州',
  '532501': '云南省个旧市',
  '532502': '云南省开远市',
  '532522': '云南省蒙自县',
  '532523': '云南省屏边苗族自治县',
  '532524': '云南省建水县',
  '532525': '云南省石屏县',
  '532526': '云南省弥勒县',
  '532527': '云南省泸西县',
  '532528': '云南省元阳县',
  '532529': '云南省红河县',
  '532530': '云南省金平苗族瑶族傣族自治县',
  '532531': '云南省绿春县',
  '532532': '云南省河口瑶族自治县',
  '532600': '云南省文山壮族苗族自治州',
  '532621': '云南省文山县',
  '532622': '云南省砚山县',
  '532623': '云南省西畴县',
  '532624': '云南省麻栗坡县',
  '532625': '云南省马关县',
  '532626': '云南省丘北县',
  '532627': '云南省广南县',
  '532628': '云南省富宁县',
  '532700': '云南省思茅地区',
  '532701': '云南省思茅市',
  '532721': '云南省思茅县',
  '532722': '云南省普洱哈尼族彝族自治县',
  '532723': '云南省墨江哈尼族自治县',
  '532724': '云南省景东彝族自治县',
  '532725': '云南省景谷傣族彝族自治县',
  '532726': '云南省镇沅彝族哈尼族拉祜族自治县',
  '532727': '云南省江城哈尼族彝族自治县',
  '532728': '云南省孟连傣族拉祜族佤族自治县',
  '532729': '云南省澜沧拉祜族自治县',
  '532730': '云南省西盟佤族自治县',
  '532800': '云南省西双版纳傣族自治州',
  '532801': '云南省景洪市',
  '532821': '云南省景洪县',
  '532822': '云南省勐海县',
  '532823': '云南省勐腊县',
  '532900': '云南省大理白族自治州',
  '532901': '云南省大理市',
  '532921': '云南省大理县',
  '532922': '云南省漾濞彝族自治县',
  '532923': '云南省祥云县',
  '532924': '云南省宾川县',
  '532925': '云南省弥渡县',
  '532926': '云南省南涧彝族自治县',
  '532927': '云南省巍山彝族回族自治县',
  '532928': '云南省永平县',
  '532929': '云南省云龙县',
  '532930': '云南省洱源县',
  '532931': '云南省剑川县',
  '532932': '云南省鹤庆县',
  '533000': '云南省保山地区',
  '533001': '云南省保山市',
  '533021': '云南省保山县',
  '533022': '云南省施甸县',
  '533023': '云南省腾冲县',
  '533024': '云南省龙陵县',
  '533025': '云南省昌宁县',
  '533100': '云南省德宏傣族景颇族自治州',
  '533101': '云南省畹町市',
  '533102': '云南省瑞丽市',
  '533103': '云南省潞西市',
  '533121': '云南省潞西县',
  '533122': '云南省梁河县',
  '533123': '云南省盈江县',
  '533124': '云南省陇川县',
  '533125': '云南省瑞丽县',
  '533126': '云南省畹町镇',
  '533200': '云南省丽江地区',
  '533221': '云南省丽江纳西族自治县',
  '533222': '云南省永胜县',
  '533223': '云南省华坪县',
  '533224': '云南省宁蒗彝族自治县',
  '533300': '云南省怒江傈僳族自治州',
  '533321': '云南省泸水县',
  '533322': '云南省碧江县',
  '533323': '云南省福贡县',
  '533324': '云南省贡山独龙族怒族自治县',
  '533325': '云南省兰坪白族普米族自治县',
  '533400': '云南省迪庆藏族自治州',
  '533421': '云南省香格里拉县',
  '533422': '云南省德钦县',
  '533423': '云南省维西傈僳族自治县',
  '533500': '云南省临沧地区',
  '533521': '云南省临沧县',
  '533522': '云南省凤庆县',
  '533523': '云南省云县',
  '533524': '云南省永德县',
  '533525': '云南省镇康县',
  '533526': '云南省双江拉祜族佤族布朗族傣族自治县',
  '533527': '云南省耿马傣族佤族自治县',
  '533528': '云南省沧源佤族自治县',
  '540000': '西藏自治区',
  '540100': '西藏自治区拉萨市',
  '540101': '西藏自治区拉萨市市辖区',
  '540102': '西藏自治区拉萨市城关区',
  '540120': '西藏自治区拉萨市区',
  '540121': '西藏自治区林周县',
  '540122': '西藏自治区当雄县',
  '540123': '西藏自治区尼木县',
  '540124': '西藏自治区曲水县',
  '540125': '西藏自治区堆龙德庆县',
  '540126': '西藏自治区达孜县',
  '540127': '西藏自治区墨竹工卡县',
  '540128': '西藏自治区工布江达县',
  '540129': '西藏自治区林芝县',
  '540130': '西藏自治区米林县',
  '540131': '西藏自治区墨脱县',
  '542100': '西藏自治区昌都地区',
  '542121': '西藏自治区昌都县',
  '542122': '西藏自治区江达县',
  '542123': '西藏自治区贡觉县',
  '542124': '西藏自治区类乌齐县',
  '542125': '西藏自治区丁青县',
  '542126': '西藏自治区察雅县',
  '542127': '西藏自治区八宿县',
  '542128': '西藏自治区左贡县',
  '542129': '西藏自治区芒康县',
  '542130': '西藏自治区波密县',
  '542131': '西藏自治区察隅县',
  '542132': '西藏自治区洛隆县',
  '542133': '西藏自治区边坝县',
  '542134': '西藏自治区盐井县',
  '542135': '西藏自治区碧土县',
  '542136': '西藏自治区妥坝县',
  '542137': '西藏自治区生达县',
  '542200': '西藏自治区山南地区',
  '542221': '西藏自治区乃东县',
  '542222': '西藏自治区扎囊县',
  '542223': '西藏自治区贡嘎县',
  '542224': '西藏自治区桑日县',
  '542225': '西藏自治区琼结县',
  '542226': '西藏自治区曲松县',
  '542227': '西藏自治区措美县',
  '542228': '西藏自治区洛扎县',
  '542229': '西藏自治区加查县',
  '542230': '西藏自治区郎县',
  '542231': '西藏自治区隆子县',
  '542232': '西藏自治区错那县',
  '542233': '西藏自治区浪卡子县',
  '542300': '西藏自治区日喀则地区',
  '542301': '西藏自治区日喀则市',
  '542321': '西藏自治区日喀则县',
  '542322': '西藏自治区南木林县',
  '542323': '西藏自治区江孜县',
  '542324': '西藏自治区定日县',
  '542325': '西藏自治区萨迦县',
  '542326': '西藏自治区拉孜县',
  '542327': '西藏自治区昂仁县',
  '542328': '西藏自治区谢通门县',
  '542329': '西藏自治区白朗县',
  '542330': '西藏自治区仁布县',
  '542331': '西藏自治区康马县',
  '542332': '西藏自治区定结县',
  '542333': '西藏自治区仲巴县',
  '542334': '西藏自治区亚东县',
  '542335': '西藏自治区吉隆县',
  '542336': '西藏自治区聂拉木县',
  '542337': '西藏自治区萨嘎县',
  '542338': '西藏自治区岗巴县',
  '542400': '西藏自治区那曲地区',
  '542421': '西藏自治区那曲县',
  '542422': '西藏自治区嘉黎县',
  '542423': '西藏自治区比如县',
  '542424': '西藏自治区聂荣县',
  '542425': '西藏自治区安多县',
  '542426': '西藏自治区申扎县',
  '542427': '西藏自治区索县',
  '542428': '西藏自治区班戈县',
  '542429': '西藏自治区巴青县',
  '542430': '西藏自治区尼玛县',
  '542500': '西藏自治区阿里地区',
  '542521': '西藏自治区普兰县',
  '542522': '西藏自治区札达县',
  '542523': '西藏自治区噶尔县',
  '542524': '西藏自治区日土县',
  '542525': '西藏自治区革吉县',
  '542526': '西藏自治区改则县',
  '542527': '西藏自治区措勤县',
  '542528': '西藏自治区隆格尔县',
  '542600': '西藏自治区林芝地区',
  '542621': '西藏自治区林芝县',
  '542622': '西藏自治区工布江达县',
  '542623': '西藏自治区米林县',
  '542624': '西藏自治区墨脱县',
  '542625': '西藏自治区波密县',
  '542626': '西藏自治区察隅县',
  '542627': '西藏自治区朗县',
  '542700': '西藏自治区江孜地区',
  '542721': '西藏自治区江孜县',
  '542722': '西藏自治区浪卡子县',
  '542723': '西藏自治区白朗县',
  '542724': '西藏自治区仁布县',
  '542725': '西藏自治区康马县',
  '542726': '西藏自治区亚东县',
  '542727': '西藏自治区岗巴县',
  '610000': '陕西省',
  '610100': '陕西省西安市',
  '610101': '陕西省西安市市辖区',
  '610102': '陕西省西安市新城区',
  '610103': '陕西省西安市碑林区',
  '610104': '陕西省西安市莲湖区',
  '610111': '陕西省西安市灞桥区',
  '610112': '陕西省西安市未央区',
  '610113': '陕西省西安市雁塔区',
  '610114': '陕西省西安市阎良区',
  '610115': '陕西省西安市临潼区',
  '610116': '陕西省西安市长安区',
  '610120': '陕西省西安市区',
  '610121': '陕西省长安县',
  '610122': '陕西省蓝田县',
  '610123': '陕西省临潼县',
  '610124': '陕西省周至县',
  '610125': '陕西省户县',
  '610126': '陕西省高陵县',
  '610200': '陕西省铜川市',
  '610201': '陕西省铜川市市辖区',
  '610202': '陕西省铜川市王益区',
  '610203': '陕西省铜川市印台区',
  '610204': '陕西省铜川市耀州区',
  '610220': '陕西省铜川市区',
  '610221': '陕西省耀县',
  '610222': '陕西省宜君县',
  '610300': '陕西省宝鸡市',
  '610301': '陕西省宝鸡市市辖区',
  '610302': '陕西省宝鸡市渭滨区',
  '610303': '陕西省宝鸡市金台区',
  '610304': '陕西省宝鸡市陈仓区',
  '610320': '陕西省宝鸡市区',
  '610321': '陕西省宝鸡县',
  '610322': '陕西省凤翔县',
  '610323': '陕西省岐山县',
  '610324': '陕西省扶风县',
  '610325': '陕西省武功县',
  '610326': '陕西省眉县',
  '610327': '陕西省陇县',
  '610328': '陕西省千阳县',
  '610329': '陕西省麟游县',
  '610330': '陕西省凤县',
  '610331': '陕西省太白县',
  '610400': '陕西省咸阳市',
  '610401': '陕西省咸阳市市辖区',
  '610402': '陕西省咸阳市秦都区',
  '610403': '陕西省咸阳市杨凌区',
  '610404': '陕西省咸阳市渭城区',
  '610421': '陕西省兴平县',
  '610422': '陕西省三原县',
  '610423': '陕西省泾阳县',
  '610424': '陕西省乾县',
  '610425': '陕西省礼泉县',
  '610426': '陕西省永寿县',
  '610427': '陕西省彬县',
  '610428': '陕西省长武县',
  '610429': '陕西省旬邑县',
  '610430': '陕西省淳化县',
  '610431': '陕西省武功县',
  '610481': '陕西省兴平市',
  '610500': '陕西省渭南市',
  '610501': '陕西省渭南市市辖区',
  '610502': '陕西省渭南市临渭区',
  '610521': '陕西省华县',
  '610522': '陕西省潼关县',
  '610523': '陕西省大荔县',
  '610524': '陕西省合阳县',
  '610525': '陕西省澄城县',
  '610526': '陕西省蒲城县',
  '610527': '陕西省白水县',
  '610528': '陕西省富平县',
  '610581': '陕西省韩城市',
  '610582': '陕西省华阴市',
  '610600': '陕西省延安市',
  '610601': '陕西省延安市市辖区',
  '610602': '陕西省延安市宝塔区',
  '610621': '陕西省延长县',
  '610622': '陕西省延川县',
  '610623': '陕西省子长县',
  '610624': '陕西省安塞县',
  '610625': '陕西省志丹县',
  '610626': '陕西省吴旗县',
  '610627': '陕西省甘泉县',
  '610628': '陕西省富县',
  '610629': '陕西省洛川县',
  '610630': '陕西省宜川县',
  '610631': '陕西省黄龙县',
  '610632': '陕西省黄陵县',
  '610700': '陕西省汉中市',
  '610701': '陕西省汉中市市辖区',
  '610702': '陕西省汉中市汉台区',
  '610721': '陕西省南郑县',
  '610722': '陕西省城固县',
  '610723': '陕西省洋县',
  '610724': '陕西省西乡县',
  '610725': '陕西省勉县',
  '610726': '陕西省宁强县',
  '610727': '陕西省略阳县',
  '610728': '陕西省镇巴县',
  '610729': '陕西省留坝县',
  '610730': '陕西省佛坪县',
  '610800': '陕西省榆林市',
  '610801': '陕西省榆林市市辖区',
  '610802': '陕西省榆林市榆阳区',
  '610821': '陕西省神木县',
  '610822': '陕西省府谷县',
  '610823': '陕西省横山县',
  '610824': '陕西省靖边县',
  '610825': '陕西省定边县',
  '610826': '陕西省绥德县',
  '610827': '陕西省米脂县',
  '610828': '陕西省佳县',
  '610829': '陕西省吴堡县',
  '610830': '陕西省清涧县',
  '610831': '陕西省子洲县',
  '610900': '陕西省安康市',
  '610901': '陕西省安康市市辖区',
  '610902': '陕西省安康市汉滨区',
  '610921': '陕西省汉阴县',
  '610922': '陕西省石泉县',
  '610923': '陕西省宁陕县',
  '610924': '陕西省紫阳县',
  '610925': '陕西省岚皋县',
  '610926': '陕西省平利县',
  '610927': '陕西省镇坪县',
  '610928': '陕西省旬阳县',
  '610929': '陕西省白河县',
  '611000': '陕西省商洛市',
  '611001': '陕西省商洛市市辖区',
  '611002': '陕西省商洛市商州区',
  '611021': '陕西省洛南县',
  '611022': '陕西省丹凤县',
  '611023': '陕西省商南县',
  '611024': '陕西省山阳县',
  '611025': '陕西省镇安县',
  '611026': '陕西省柞水县',
  '612100': '陕西省渭南地区',
  '612101': '陕西省渭南市',
  '612102': '陕西省韩城市',
  '612103': '陕西省华阴市',
  '612121': '陕西省蓝田县',
  '612122': '陕西省临潼县',
  '612123': '陕西省渭南县',
  '612124': '陕西省华县',
  '612125': '陕西省华阴县',
  '612126': '陕西省潼关县',
  '612127': '陕西省大荔县',
  '612128': '陕西省蒲城县',
  '612129': '陕西省澄城县',
  '612130': '陕西省白水县',
  '612131': '陕西省韩城县',
  '612132': '陕西省合阳县',
  '612133': '陕西省富平县',
  '612200': '陕西省咸阳地区',
  '612201': '陕西省咸阳市',
  '612221': '陕西省兴平县',
  '612222': '陕西省周至县',
  '612223': '陕西省户县',
  '612224': '陕西省三原县',
  '612225': '陕西省泾阳县',
  '612226': '陕西省高陵县',
  '612227': '陕西省乾县',
  '612228': '陕西省礼泉县',
  '612229': '陕西省永寿县',
  '612230': '陕西省彬县',
  '612231': '陕西省长武县',
  '612232': '陕西省旬邑县',
  '612233': '陕西省淳化县',
  '612300': '陕西省汉中地区',
  '612301': '陕西省汉中市',
  '612321': '陕西省南郑县',
  '612322': '陕西省城固县',
  '612323': '陕西省洋县',
  '612324': '陕西省西乡县',
  '612325': '陕西省勉县',
  '612326': '陕西省宁强县',
  '612327': '陕西省略阳县',
  '612328': '陕西省镇巴县',
  '612329': '陕西省留坝县',
  '612330': '陕西省佛坪县',
  '612400': '陕西省安康地区',
  '612401': '陕西省安康市',
  '612421': '陕西省安康县',
  '612422': '陕西省汉阴县',
  '612423': '陕西省石泉县',
  '612424': '陕西省宁陕县',
  '612425': '陕西省紫阳县',
  '612426': '陕西省岚皋县',
  '612427': '陕西省平利县',
  '612428': '陕西省镇坪县',
  '612429': '陕西省旬阳县',
  '612430': '陕西省白河县',
  '612500': '陕西省商洛地区',
  '612501': '陕西省商州市',
  '612521': '陕西省商县',
  '612522': '陕西省洛南县',
  '612523': '陕西省丹凤县',
  '612524': '陕西省商南县',
  '612525': '陕西省山阳县',
  '612526': '陕西省镇安县',
  '612527': '陕西省柞水县',
  '612600': '陕西省延安地区',
  '612601': '陕西省延安市',
  '612621': '陕西省延长县',
  '612622': '陕西省延川县',
  '612623': '陕西省子长县',
  '612624': '陕西省安塞县',
  '612625': '陕西省志丹县',
  '612626': '陕西省吴旗县',
  '612627': '陕西省甘泉县',
  '612628': '陕西省富县',
  '612629': '陕西省洛川县',
  '612630': '陕西省宜川县',
  '612631': '陕西省黄龙县',
  '612632': '陕西省黄陵县',
  '612633': '陕西省宜君县',
  '612700': '陕西省榆林地区',
  '612701': '陕西省榆林市',
  '612721': '陕西省榆林县',
  '612722': '陕西省神木县',
  '612723': '陕西省府谷县',
  '612724': '陕西省横山县',
  '612725': '陕西省靖边县',
  '612726': '陕西省定边县',
  '612727': '陕西省绥德县',
  '612728': '陕西省米脂县',
  '612729': '陕西省佳县',
  '612730': '陕西省吴堡县',
  '612731': '陕西省清涧县',
  '612732': '陕西省子洲县',
  '620000': '甘肃省',
  '620100': '甘肃省兰州市',
  '620101': '甘肃省兰州市市辖区',
  '620102': '甘肃省兰州市城关区',
  '620103': '甘肃省兰州市七里河区',
  '620104': '甘肃省兰州市西固区',
  '620105': '甘肃省兰州市安宁区',
  '620111': '甘肃省兰州市红古区',
  '620112': '甘肃省兰州市白银区',
  '620120': '甘肃省兰州市区',
  '620121': '甘肃省永登县',
  '620122': '甘肃省皋兰县',
  '620123': '甘肃省榆中县',
  '620200': '甘肃省嘉峪关市',
  '620201': '甘肃省嘉峪关市市辖区',
  '620202': '甘肃省嘉峪关市嘉峪关区',
  '620300': '甘肃省金昌市',
  '620301': '甘肃省金昌市市辖区',
  '620302': '甘肃省金昌市金川区',
  '620320': '甘肃省金昌市区',
  '620321': '甘肃省永昌县',
  '620400': '甘肃省白银市',
  '620401': '甘肃省白银市市辖区',
  '620402': '甘肃省白银市白银区',
  '620403': '甘肃省白银市平川区',
  '620421': '甘肃省靖远县',
  '620422': '甘肃省会宁县',
  '620423': '甘肃省景泰县',
  '620500': '甘肃省天水市',
  '620501': '甘肃省天水市市辖区',
  '620502': '甘肃省天水市秦城区',
  '620503': '甘肃省天水市北道区',
  '620521': '甘肃省清水县',
  '620522': '甘肃省秦安县',
  '620523': '甘肃省甘谷县',
  '620524': '甘肃省武山县',
  '620525': '甘肃省张家川回族自治县',
  '620600': '甘肃省武威市',
  '620601': '甘肃省武威市市辖区',
  '620602': '甘肃省武威市凉州区',
  '620621': '甘肃省民勤县',
  '620622': '甘肃省古浪县',
  '620623': '甘肃省天祝藏族自治县',
  '620700': '甘肃省张掖市',
  '620701': '甘肃省张掖市市辖区',
  '620702': '甘肃省张掖市甘州区',
  '620721': '甘肃省肃南裕固族自治县',
  '620722': '甘肃省民乐县',
  '620723': '甘肃省临泽县',
  '620724': '甘肃省高台县',
  '620725': '甘肃省山丹县',
  '620800': '甘肃省平凉市',
  '620801': '甘肃省平凉市市辖区',
  '620802': '甘肃省平凉市崆峒区',
  '620821': '甘肃省泾川县',
  '620822': '甘肃省灵台县',
  '620823': '甘肃省崇信县',
  '620824': '甘肃省华亭县',
  '620825': '甘肃省庄浪县',
  '620826': '甘肃省静宁县',
  '620900': '甘肃省酒泉市',
  '620901': '甘肃省酒泉市市辖区',
  '620902': '甘肃省酒泉市肃州区',
  '620921': '甘肃省金塔县',
  '620922': '甘肃省安西县',
  '620923': '甘肃省肃北蒙古族自治县',
  '620924': '甘肃省阿克塞哈萨克族自治县',
  '620981': '甘肃省玉门市',
  '620982': '甘肃省敦煌市',
  '621000': '甘肃省庆阳市',
  '621001': '甘肃省庆阳市市辖区',
  '621002': '甘肃省庆阳市西峰区',
  '621021': '甘肃省庆城县',
  '621022': '甘肃省环县',
  '621023': '甘肃省华池县',
  '621024': '甘肃省合水县',
  '621025': '甘肃省正宁县',
  '621026': '甘肃省宁县',
  '621027': '甘肃省镇原县',
  '621100': '甘肃省定西市',
  '621101': '甘肃省定西市市辖区',
  '621102': '甘肃省定西市安定区',
  '621121': '甘肃省通渭县',
  '621122': '甘肃省陇西县',
  '621123': '甘肃省渭源县',
  '621124': '甘肃省临洮县',
  '621125': '甘肃省漳县',
  '621126': '甘肃省岷县',
  '621200': '甘肃省陇南市',
  '621201': '甘肃省陇南市市辖区',
  '621202': '甘肃省陇南市武都区',
  '621221': '甘肃省成县',
  '621222': '甘肃省文县',
  '621223': '甘肃省宕昌县',
  '621224': '甘肃省康县',
  '621225': '甘肃省西和县',
  '621226': '甘肃省礼县',
  '621227': '甘肃省徽县',
  '621228': '甘肃省两当县',
  '622100': '甘肃省酒泉地区',
  '622101': '甘肃省玉门市',
  '622102': '甘肃省酒泉市',
  '622103': '甘肃省敦煌市',
  '622121': '甘肃省酒泉县',
  '622122': '甘肃省敦煌县',
  '622123': '甘肃省金塔县',
  '622124': '甘肃省肃北蒙古族自治县',
  '622125': '甘肃省阿克塞哈萨克族自治县',
  '622126': '甘肃省安西县',
  '622200': '甘肃省张掖地区',
  '622201': '甘肃省张掖市',
  '622221': '甘肃省张掖县',
  '622222': '甘肃省肃南裕固族自治县',
  '622223': '甘肃省民乐县',
  '622224': '甘肃省临泽县',
  '622225': '甘肃省高台县',
  '622226': '甘肃省山丹县',
  '622300': '甘肃省武威地区',
  '622301': '甘肃省武威市',
  '622321': '甘肃省武威县',
  '622322': '甘肃省民勤县',
  '622323': '甘肃省古浪县',
  '622324': '甘肃省景泰县',
  '622326': '甘肃省天祝藏族自治县',
  '622400': '甘肃省定西地区',
  '622421': '甘肃省定西县',
  '622422': '甘肃省靖远县',
  '622423': '甘肃省会宁县',
  '622424': '甘肃省通渭县',
  '622425': '甘肃省陇西县',
  '622426': '甘肃省渭源县',
  '622427': '甘肃省临洮县',
  '622428': '甘肃省漳县',
  '622429': '甘肃省岷县',
  '622500': '甘肃省天水地区',
  '622501': '甘肃省天水市',
  '622521': '甘肃省张家川回族自治县',
  '622522': '甘肃省天水县',
  '622523': '甘肃省清水县',
  '622524': '甘肃省徽县',
  '622525': '甘肃省两当县',
  '622526': '甘肃省礼县',
  '622527': '甘肃省西和县',
  '622528': '甘肃省武山县',
  '622529': '甘肃省甘谷县',
  '622530': '甘肃省秦安县',
  '622531': '甘肃省漳县',
  '622600': '甘肃省陇南地区',
  '622621': '甘肃省武都县',
  '622622': '甘肃省岷县',
  '622623': '甘肃省宕昌县',
  '622624': '甘肃省成县',
  '622625': '甘肃省康县',
  '622626': '甘肃省文县',
  '622627': '甘肃省西和县',
  '622628': '甘肃省礼县',
  '622629': '甘肃省两当县',
  '622630': '甘肃省徽县',
  '622700': '甘肃省平凉地区',
  '622701': '甘肃省平凉市',
  '622721': '甘肃省平凉县',
  '622722': '甘肃省泾川县',
  '622723': '甘肃省灵台县',
  '622724': '甘肃省崇信县',
  '622725': '甘肃省华亭县',
  '622726': '甘肃省庄浪县',
  '622727': '甘肃省静宁县',
  '622800': '甘肃省庆阳地区',
  '622801': '甘肃省西峰市',
  '622821': '甘肃省庆阳县',
  '622822': '甘肃省环县',
  '622823': '甘肃省华池县',
  '622824': '甘肃省合水县',
  '622825': '甘肃省正宁县',
  '622826': '甘肃省宁县',
  '622827': '甘肃省镇原县',
  '622900': '甘肃省临夏回族自治州',
  '622901': '甘肃省临夏市',
  '622921': '甘肃省临夏县',
  '622922': '甘肃省康乐县',
  '622923': '甘肃省永靖县',
  '622924': '甘肃省广河县',
  '622925': '甘肃省和政县',
  '622926': '甘肃省东乡族自治县',
  '622927': '甘肃省积石山保安族东乡族撒拉族自治县',
  '623000': '甘肃省甘南藏族自治州',
  '623001': '甘肃省合作市',
  '623021': '甘肃省临潭县',
  '623022': '甘肃省卓尼县',
  '623023': '甘肃省舟曲县',
  '623024': '甘肃省迭部县',
  '623025': '甘肃省玛曲县',
  '623026': '甘肃省碌曲县',
  '623027': '甘肃省夏河县',
  '630000': '青海省',
  '630100': '青海省西宁市',
  '630101': '青海省西宁市市辖区',
  '630102': '青海省西宁市城东区',
  '630103': '青海省西宁市城中区',
  '630104': '青海省西宁市城西区',
  '630105': '青海省西宁市城北区',
  '630111': '青海省西宁市郊区',
  '630120': '青海省西宁市区',
  '630121': '青海省大通回族土族自治县',
  '630122': '青海省湟中县',
  '630123': '青海省湟源县',
  '632100': '青海省海东地区',
  '632121': '青海省平安县',
  '632122': '青海省民和回族土族自治县',
  '632123': '青海省乐都县',
  '632124': '青海省湟中县',
  '632125': '青海省湟源县',
  '632126': '青海省互助土族自治县',
  '632127': '青海省化隆回族自治县',
  '632128': '青海省循化撒拉族自治县',
  '632200': '青海省海北藏族自治州',
  '632221': '青海省门源回族自治县',
  '632222': '青海省祁连县',
  '632223': '青海省海晏县',
  '632224': '青海省刚察县',
  '632300': '青海省黄南藏族自治州',
  '632321': '青海省同仁县',
  '632322': '青海省尖扎县',
  '632323': '青海省泽库县',
  '632324': '青海省河南蒙古族自治县',
  '632400': '青海省省直辖行政单位',
  '632421': '青海省河南蒙古族自治县',
  '632500': '青海省海南藏族自治州',
  '632521': '青海省共和县',
  '632522': '青海省同德县',
  '632523': '青海省贵德县',
  '632524': '青海省兴海县',
  '632525': '青海省贵南县',
  '632600': '青海省果洛藏族自治州',
  '632621': '青海省玛沁县',
  '632622': '青海省班玛县',
  '632623': '青海省甘德县',
  '632624': '青海省达日县',
  '632625': '青海省久治县',
  '632626': '青海省玛多县',
  '632700': '青海省玉树藏族自治州',
  '632721': '青海省玉树县',
  '632722': '青海省杂多县',
  '632723': '青海省称多县',
  '632724': '青海省治多县',
  '632725': '青海省囊谦县',
  '632726': '青海省曲麻莱县',
  '632800': '青海省海西蒙古族藏族自治州',
  '632801': '青海省格尔木市',
  '632802': '青海省德令哈市',
  '632821': '青海省乌兰县',
  '632822': '青海省都兰县',
  '632823': '青海省天峻县',
  '632824': '青海省大柴旦镇',
  '632825': '青海省冷湖镇',
  '632826': '青海省茫崖镇',
  '640000': '宁夏回族自治区',
  '640100': '宁夏回族自治区银川市',
  '640101': '宁夏回族自治区银川市市辖区',
  '640102': '宁夏回族自治区银川市城区',
  '640103': '宁夏回族自治区银川市新城区',
  '640104': '宁夏回族自治区银川市兴庆区',
  '640105': '宁夏回族自治区银川市西夏区',
  '640106': '宁夏回族自治区银川市金凤区',
  '640111': '宁夏回族自治区银川市郊区',
  '640120': '宁夏回族自治区银川市区',
  '640121': '宁夏回族自治区永宁县',
  '640122': '宁夏回族自治区贺兰县',
  '640181': '宁夏回族自治区灵武市',
  '640200': '宁夏回族自治区石嘴山市',
  '640201': '宁夏回族自治区石嘴山市市辖区',
  '640202': '宁夏回族自治区石嘴山市大武口区',
  '640203': '宁夏回族自治区石嘴山市石嘴山区',
  '640204': '宁夏回族自治区石嘴山市石炭井区',
  '640205': '宁夏回族自治区石嘴山市惠农区',
  '640211': '宁夏回族自治区石嘴山市郊区',
  '640220': '宁夏回族自治区石嘴山市区',
  '640221': '宁夏回族自治区平罗县',
  '640222': '宁夏回族自治区陶乐县',
  '640223': '宁夏回族自治区惠农县',
  '640300': '宁夏回族自治区吴忠市',
  '640301': '宁夏回族自治区吴忠市市辖区',
  '640302': '宁夏回族自治区吴忠市利通区',
  '640321': '宁夏回族自治区中卫县',
  '640322': '宁夏回族自治区中宁县',
  '640323': '宁夏回族自治区盐池县',
  '640324': '宁夏回族自治区同心县',
  '640381': '宁夏回族自治区青铜峡市',
  '640382': '宁夏回族自治区灵武市',
  '640400': '宁夏回族自治区固原市',
  '640401': '宁夏回族自治区固原市市辖区',
  '640402': '宁夏回族自治区固原市原州区',
  '640421': '宁夏回族自治区海原县',
  '640422': '宁夏回族自治区西吉县',
  '640423': '宁夏回族自治区隆德县',
  '640424': '宁夏回族自治区泾源县',
  '640425': '宁夏回族自治区彭阳县',
  '640500': '宁夏回族自治区中卫市',
  '640501': '宁夏回族自治区中卫市市辖区',
  '640502': '宁夏回族自治区中卫市沙坡头区',
  '640521': '宁夏回族自治区中宁县',
  '640522': '宁夏回族自治区海原县',
  '642100': '宁夏回族自治区银南地区',
  '642101': '宁夏回族自治区吴忠市',
  '642102': '宁夏回族自治区青铜峡市',
  '642103': '宁夏回族自治区灵武市',
  '642121': '宁夏回族自治区吴忠县',
  '642122': '宁夏回族自治区青铜峡县',
  '642123': '宁夏回族自治区中卫县',
  '642124': '宁夏回族自治区中宁县',
  '642125': '宁夏回族自治区灵武县',
  '642126': '宁夏回族自治区盐池县',
  '642127': '宁夏回族自治区同心县',
  '642200': '宁夏回族自治区固原地区',
  '642221': '宁夏回族自治区固原县',
  '642222': '宁夏回族自治区海原县',
  '642223': '宁夏回族自治区西吉县',
  '642224': '宁夏回族自治区隆德县',
  '642225': '宁夏回族自治区泾源县',
  '642226': '宁夏回族自治区彭阳县',
  '650000': '新疆维吾尔自治区',
  '650100': '新疆维吾尔自治区乌鲁木齐市',
  '650101': '新疆维吾尔自治区乌鲁木齐市市辖区',
  '650102': '新疆维吾尔自治区乌鲁木齐市天山区',
  '650103': '新疆维吾尔自治区乌鲁木齐市沙依巴克区',
  '650104': '新疆维吾尔自治区乌鲁木齐市新市区',
  '650105': '新疆维吾尔自治区乌鲁木齐市水磨沟区',
  '650106': '新疆维吾尔自治区乌鲁木齐市头屯河区',
  '650107': '新疆维吾尔自治区乌鲁木齐市达坂城区',
  '650108': '新疆维吾尔自治区乌鲁木齐市东山区',
  '650120': '新疆维吾尔自治区乌鲁木齐市区',
  '650121': '新疆维吾尔自治区乌鲁木齐县',
  '650200': '新疆维吾尔自治区克拉玛依市',
  '650201': '新疆维吾尔自治区克拉玛依市市辖区',
  '650202': '新疆维吾尔自治区克拉玛依市独山子区',
  '650203': '新疆维吾尔自治区克拉玛依市克拉玛依区',
  '650204': '新疆维吾尔自治区克拉玛依市白碱滩区',
  '650205': '新疆维吾尔自治区克拉玛依市乌尔禾区',
  '650300': '新疆维吾尔自治区石河子市',
  '652100': '新疆维吾尔自治区吐鲁番地区',
  '652101': '新疆维吾尔自治区吐鲁番市',
  '652121': '新疆维吾尔自治区吐鲁番县',
  '652122': '新疆维吾尔自治区鄯善县',
  '652123': '新疆维吾尔自治区托克逊县',
  '652200': '新疆维吾尔自治区哈密地区',
  '652201': '新疆维吾尔自治区哈密市',
  '652221': '新疆维吾尔自治区哈密县',
  '652222': '新疆维吾尔自治区巴里坤哈萨克自治县',
  '652223': '新疆维吾尔自治区伊吾县',
  '652300': '新疆维吾尔自治区昌吉回族自治州',
  '652301': '新疆维吾尔自治区昌吉市',
  '652302': '新疆维吾尔自治区阜康市',
  '652303': '新疆维吾尔自治区米泉市',
  '652321': '新疆维吾尔自治区昌吉县',
  '652322': '新疆维吾尔自治区米泉县',
  '652323': '新疆维吾尔自治区呼图壁县',
  '652324': '新疆维吾尔自治区玛纳斯县',
  '652325': '新疆维吾尔自治区奇台县',
  '652326': '新疆维吾尔自治区阜康县',
  '652327': '新疆维吾尔自治区吉木萨尔县',
  '652328': '新疆维吾尔自治区木垒哈萨克自治县',
  '652401': '新疆维吾尔自治区伊宁市',
  '652402': '新疆维吾尔自治区奎屯市',
  '652421': '新疆维吾尔自治区伊宁县',
  '652422': '新疆维吾尔自治区察布查尔锡伯自治县',
  '652423': '新疆维吾尔自治区霍城县',
  '652424': '新疆维吾尔自治区巩留县',
  '652425': '新疆维吾尔自治区新源县',
  '652426': '新疆维吾尔自治区昭苏县',
  '652427': '新疆维吾尔自治区特克斯县',
  '652428': '新疆维吾尔自治区尼勒克县',
  '652500': '新疆维吾尔自治区塔城地区',
  '652521': '新疆维吾尔自治区塔城县',
  '652522': '新疆维吾尔自治区额敏县',
  '652523': '新疆维吾尔自治区乌苏县',
  '652524': '新疆维吾尔自治区沙湾县',
  '652525': '新疆维吾尔自治区托里县',
  '652526': '新疆维吾尔自治区裕民县',
  '652527': '新疆维吾尔自治区和布克赛尔蒙古族自治县',
  '652600': '新疆维吾尔自治区阿勒泰地区',
  '652621': '新疆维吾尔自治区阿勒泰县',
  '652622': '新疆维吾尔自治区布尔津县',
  '652623': '新疆维吾尔自治区富蕴县',
  '652624': '新疆维吾尔自治区福海县',
  '652625': '新疆维吾尔自治区哈巴河县',
  '652626': '新疆维吾尔自治区青河县',
  '652627': '新疆维吾尔自治区吉木乃县',
  '652700': '新疆维吾尔自治区博尔塔拉蒙古自治州',
  '652701': '新疆维吾尔自治区博乐市',
  '652721': '新疆维吾尔自治区博乐县',
  '652722': '新疆维吾尔自治区精河县',
  '652723': '新疆维吾尔自治区温泉县',
  '652800': '新疆维吾尔自治区巴音郭楞蒙古自治州',
  '652801': '新疆维吾尔自治区库尔勒市',
  '652821': '新疆维吾尔自治区库尔勒县',
  '652822': '新疆维吾尔自治区轮台县',
  '652823': '新疆维吾尔自治区尉犁县',
  '652824': '新疆维吾尔自治区若羌县',
  '652825': '新疆维吾尔自治区且末县',
  '652826': '新疆维吾尔自治区焉耆回族自治县',
  '652827': '新疆维吾尔自治区和静县',
  '652828': '新疆维吾尔自治区和硕县',
  '652829': '新疆维吾尔自治区博湖县',
  '652900': '新疆维吾尔自治区阿克苏地区',
  '652901': '新疆维吾尔自治区阿克苏市',
  '652921': '新疆维吾尔自治区阿克苏县',
  '652922': '新疆维吾尔自治区温宿县',
  '652923': '新疆维吾尔自治区库车县',
  '652924': '新疆维吾尔自治区沙雅县',
  '652925': '新疆维吾尔自治区新和县',
  '652926': '新疆维吾尔自治区拜城县',
  '652927': '新疆维吾尔自治区乌什县',
  '652928': '新疆维吾尔自治区阿瓦提县',
  '652929': '新疆维吾尔自治区柯坪县',
  '653000': '新疆维吾尔自治区克孜勒苏柯尔克孜自治州',
  '653001': '新疆维吾尔自治区阿图什市',
  '653021': '新疆维吾尔自治区阿图什县',
  '653022': '新疆维吾尔自治区阿克陶县',
  '653023': '新疆维吾尔自治区阿合奇县',
  '653024': '新疆维吾尔自治区乌恰县',
  '653100': '新疆维吾尔自治区喀什地区',
  '653101': '新疆维吾尔自治区喀什市',
  '653121': '新疆维吾尔自治区疏附县',
  '653122': '新疆维吾尔自治区疏勒县',
  '653123': '新疆维吾尔自治区英吉沙县',
  '653124': '新疆维吾尔自治区泽普县',
  '653125': '新疆维吾尔自治区莎车县',
  '653126': '新疆维吾尔自治区叶城县',
  '653127': '新疆维吾尔自治区麦盖提县',
  '653128': '新疆维吾尔自治区岳普湖县',
  '653129': '新疆维吾尔自治区伽师县',
  '653130': '新疆维吾尔自治区巴楚县',
  '653131': '新疆维吾尔自治区塔什库尔干塔吉克自治县',
  '653200': '新疆维吾尔自治区和田地区',
  '653201': '新疆维吾尔自治区和田市',
  '653221': '新疆维吾尔自治区和田县',
  '653222': '新疆维吾尔自治区墨玉县',
  '653223': '新疆维吾尔自治区皮山县',
  '653224': '新疆维吾尔自治区洛浦县',
  '653225': '新疆维吾尔自治区策勒县',
  '653226': '新疆维吾尔自治区于田县',
  '653227': '新疆维吾尔自治区民丰县',
  '654000': '新疆维吾尔自治区伊犁哈萨克自治州',
  '654001': '新疆维吾尔自治区奎屯市',
  '654002': '新疆维吾尔自治区伊宁市',
  '654003': '新疆维吾尔自治区奎屯市',
  '654021': '新疆维吾尔自治区伊宁县',
  '654022': '新疆维吾尔自治区察布查尔锡伯自治县',
  '654023': '新疆维吾尔自治区霍城县',
  '654024': '新疆维吾尔自治区巩留县',
  '654025': '新疆维吾尔自治区新源县',
  '654026': '新疆维吾尔自治区昭苏县',
  '654027': '新疆维吾尔自治区特克斯县',
  '654028': '新疆维吾尔自治区尼勒克县',
  '654100': '新疆维吾尔自治区伊犁地区',
  '654101': '新疆维吾尔自治区伊宁市',
  '654121': '新疆维吾尔自治区伊宁县',
  '654122': '新疆维吾尔自治区察布查尔锡伯自治县',
  '654123': '新疆维吾尔自治区霍城县',
  '654124': '新疆维吾尔自治区巩留县',
  '654125': '新疆维吾尔自治区新源县',
  '654126': '新疆维吾尔自治区昭苏县',
  '654127': '新疆维吾尔自治区特克斯县',
  '654128': '新疆维吾尔自治区尼勒克县',
  '654200': '新疆维吾尔自治区塔城地区',
  '654201': '新疆维吾尔自治区塔城市',
  '654202': '新疆维吾尔自治区乌苏市',
  '654221': '新疆维吾尔自治区额敏县',
  '654222': '新疆维吾尔自治区乌苏县',
  '654223': '新疆维吾尔自治区沙湾县',
  '654224': '新疆维吾尔自治区托里县',
  '654225': '新疆维吾尔自治区裕民县',
  '654226': '新疆维吾尔自治区和布克赛尔蒙古自治县',
  '654300': '新疆维吾尔自治区阿勒泰地区',
  '654301': '新疆维吾尔自治区阿勒泰市',
  '654321': '新疆维吾尔自治区布尔津县',
  '654322': '新疆维吾尔自治区富蕴县',
  '654323': '新疆维吾尔自治区福海县',
  '654324': '新疆维吾尔自治区哈巴河县',
  '654325': '新疆维吾尔自治区青河县',
  '654326': '新疆维吾尔自治区吉木乃县',
  '659001': '新疆维吾尔自治区石河子市',
  '659002': '新疆维吾尔自治区阿拉尔市',
  '659003': '新疆维吾尔自治区图木舒克市',
  '659004': '新疆维吾尔自治区五家渠市',
  '660000': '新疆生产建设兵团',
  '662800': '新疆生产建设兵团农八师（石河子市）',
  '710000': '台湾省',
  '810000': '香港特别行政区',
  '820000': '澳门特别行政区'
}
const yuefen = {
  '02': 29,
  '01': 31,
  '03': 31,
  '04': 30,
  '05': 31,
  '06': 30,
  '07': 31,
  '08': 31,
  '09': 30,
  '10': 31,
  '11': 30,
  '12': 31
}

export {cardArr, yuefen}



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/assets/area.js